
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $2h4sD = parcelRequire("2h4sD");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-cfbcc58be9";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $2h4sD.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error("Failed to initialize DynamicConfigClient", error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? "" : pathForCanonical === "" ? "" : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("dXL3R", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePage", function () { return $9d047481379b0727$export$a6be62ed06c967ea; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $67UrT = parcelRequire("67UrT");

var $9rnwe = parcelRequire("9rnwe");

var $3L8ZR = parcelRequire("3L8ZR");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");
parcelRequire("l8kCZ");
var $bTseT = parcelRequire("bTseT");

var $5JA6e = parcelRequire("5JA6e");

var $2V8Su = parcelRequire("2V8Su");

var $bxwDC = parcelRequire("bxwDC");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $b2rSp = parcelRequire("b2rSp");
const $9d047481379b0727$export$a6be62ed06c967ea = ({ utmCampaign: utmCampaign })=>{
    const loggedInHasJira = (0, $doAVE.useLoggedInHasJira)();
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    const isWae = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).dxpMigrationJiraProductTourGate);
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate("gwp-737-enable-intercom-chat-jsw");
    const hasImcKey = (0, $7VwhR.hasJiraImcCampaignKey)(utmCampaign);
    // Jira FFl experiment check start
    const jiraFflExperimentCheck = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).cfind6215FrictionlessFirstLookJiraV2);
    const isJiraFflVariant = jiraFflExperimentCheck.type === (0, $ea4mV.EnrollmentType).ENROLLED && jiraFflExperimentCheck.value;
    // Jira FFl experiment check end
    let template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bxwDC.LoggedOutOrNoJiraProductTourOverview), {});
    //For logged in, we will either show a "Has Jira" experience, otherwise the Uniform "logged out" page
    if (loggedInHasJira) template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5JA6e.LoggedInHeroContainer), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2V8Su.OrganicLoggedInJiraProductTourOverview), {})
    });
    else {
        if (hasImcKey && isJiraFflVariant && isLoggedOut) template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b2rSp.JiraProductTourAiTemplate), {});
        else if (isWae) template = /*#__PURE__*/ (0, $7VQPk.jsx)($9d047481379b0727$var$WaeJiraPage, {});
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "jira-product-tour-overview",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
            appId: "p0ww63i2",
            triggerBoot: isBootIntercom,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kPBa.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $20OkY.ProductKeys).JIRA_SOFTWARE
                ],
                screenName: "wacJswProductTourPage",
                children: template
            })
        })
    });
};
const $9d047481379b0727$var$WaeJiraPage = ()=>{
    const { composition: composition } = (0, $9rnwe.useWAEContext)();
    const [jiraFflExposureFired, fireJiraFflExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind6215FrictionlessFirstLookJiraV2);
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraFflExposureFired) fireJiraFflExposure();
    }, [
        jiraFflExposureFired,
        fireJiraFflExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $67UrT.UniformEntryPage), {
        composition: composition
    });
};

});
parcelRegister("67UrT", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPage", function () { return $567142e6bd5e85f1$export$f0d4a992b207ed41; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iSeHD = parcelRequire("iSeHD");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");
parcelRequire("1RvSu");
var $ipRTK = parcelRequire("ipRTK");

var $ea4mV = parcelRequire("ea4mV");

var $doAVE = parcelRequire("doAVE");
const $567142e6bd5e85f1$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const [dxpMigrationJsmAnchorJourneyExposureFired, fireDxpMigrationJsmAnchorJourneyExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isDxpMigrationJsmAnchorJourney = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationJsmAnchorJourneyExposureFired && isDxpMigrationJsmAnchorJourney.type === (0, $ea4mV.EnrollmentType).ENROLLED && isLoggedOut && [
            `paid-lp-jsm-itsm`,
            `paid-lp-jsm-features`,
            `paid-lp-jsm-service-desk`,
            `paid-lp-jsm-ticketing`
        ].includes(window.cmsPageVariant || "")) fireDxpMigrationJsmAnchorJourneyExposure();
    }, [
        dxpMigrationJsmAnchorJourneyExposureFired,
        fireDxpMigrationJsmAnchorJourneyExposure,
        isDxpMigrationJsmAnchorJourney,
        isLoggedOut
    ]);
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $1oC0p.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: "pageRender",
            actionSubject: "uniformPage",
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType("paint");
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === "first-contentful-paint");
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint");
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        "paint"
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn("Error measuring Page Render Time:", error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ipRTK.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("7WM7y", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $b3e0454f7f1f85f3$export$580adf4c24c28053; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $9GLx2 = parcelRequire("9GLx2");

var $bv77X = parcelRequire("bv77X");

var $doAVE = parcelRequire("doAVE");

var $PE2DD = parcelRequire("PE2DD");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $1ka2O = parcelRequire("1ka2O");

var $4d61Q = parcelRequire("4d61Q");
const $b3e0454f7f1f85f3$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9GLx2.default), {
        locale: "en",
        messages: {},
        defaultLocale: "en",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $PE2DD.BxpWebStargateClientProvider), {
            baseUrl: (0, $PE2DD.getStargateBaseUrl)(),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $doAVE.UserContextProvider), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "404-page",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1ka2O.LocationProvider), {
                            location: typeof window !== "undefined" ? window.location : {
                                pathname: "/",
                                href: "/"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                                        isShowTryNowLink: true,
                                        tryNowLinkCtaButtonColor: "light_grey",
                                        productKey: "404"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4d61Q.MainSection), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
                            ]
                        })
                    })
                })
            })
        })
    });
};

});

parcelRegister("1RvSu", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return (parcelRequire("ipRTK")).UniformEntryPageTemplate; });

var $ipRTK = parcelRequire("ipRTK");

});
parcelRegister("ipRTK", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $9b881e462c85fa95$export$8328465fb6b6a7d2; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $9b881e462c85fa95$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});



parcelRegister("l8kCZ", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("bTseT")).IntercomProvider; });
parcelRequire("bTseT");
parcelRequire("25OgP");

});
parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $PE2DD = parcelRequire("PE2DD");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== "undefined";
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            const intercomSettings = window.intercomSettings ?? {
                app_id: appId
            };
            try {
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                window.Intercom?.("boot", {
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher",
                    ...intercomSettings
                });
                window.Intercom?.("trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            window.Intercom?.("shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.("show");
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.("hide");
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("25OgP", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("5JA6e", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroContainer", function () { return $7dd9a4cf5c1be356$export$c91dc4c235bd2e79; });

var $7VQPk = parcelRequire("7VQPk");

var $3Ccrv = parcelRequire("3Ccrv");

var $doAVE = parcelRequire("doAVE");

var $ZCSXq = parcelRequire("ZCSXq");
const $7dd9a4cf5c1be356$export$c91dc4c235bd2e79 = ({ children: children })=>{
    const { profile: { requestInProgress: profileRequestInProgress }, user: { requestInProgress: userRequestInProgress } } = (0, $doAVE.useUserContext)();
    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (userRequestInProgress || profileRequestInProgress) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Ccrv.default), {
        name: "logged-in-hero-loading",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ZCSXq.LoggedInHeroSkeleton), {})
    });
    return children;
};

});
parcelRegister("ZCSXq", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSkeleton", function () { return $136a2b90265c9861$export$84abebbf129cccbc; });
/* logged-in-hero-skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $136a2b90265c9861$var$headingSectionGap = null;
const $136a2b90265c9861$var$sectionGap = null;
const $136a2b90265c9861$var$contianerStyles = null;
const $136a2b90265c9861$var$mobileDisplay = null;
const $136a2b90265c9861$var$desktopDisplay = null;
const $136a2b90265c9861$export$84abebbf129cccbc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "logged-in-jira-pt-skeleton",
        className: (0, $2jatx.default)([
            "_1pfh1ejb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1152px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1140px",
                                height: "1140px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _1mjb1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "480px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "480px",
                                height: "480px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("eUwCn", function(module, exports) {
$parcel$export(module.exports, "Adg4Skeleton", function () { return $a7f43d28d2add36d$export$e754784845e8828d; });

var $7VQPk = parcelRequire("7VQPk");

var $4jcRW = parcelRequire("4jcRW");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");
const $a7f43d28d2add36d$export$e754784845e8828d = ({ width: width, height: height, groupName: groupName, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
        width: width,
        height: height,
        groupName: groupName,
        testId: testId,
        isShimmering: true,
        borderRadius: (0, $lP7A9.default)("space.100"),
        color: (0, $kbpa7.wacToken)("color.neutral.light200"),
        ShimmeringEndColor: (0, $kbpa7.wacToken)("color.neutral.light300"),
        ...props
    });
};

});
parcelRegister("4jcRW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3232eb4c0efd91e0$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $izd0e = parcelRequire("izd0e");

var $1frsO = parcelRequire("1frsO");

var $1oC0p = parcelRequire("1oC0p");

var $7DAIH = parcelRequire("7DAIH");
var $dtlzK = parcelRequire("dtlzK");
function $3232eb4c0efd91e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3232eb4c0efd91e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3232eb4c0efd91e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1frsO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3232eb4c0efd91e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3232eb4c0efd91e0$var$shimmerKeyframes = null;
var $3232eb4c0efd91e0$var$skeletonStyles = null;
var $3232eb4c0efd91e0$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $3232eb4c0efd91e0$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? '100px' : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $izd0e.default)({
        "data-testid": testId
    }, groupDataAttribute && (0, $1frsO.default)({}, groupDataAttribute, 'true'), {
        className: (0, $7DAIH.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq586c"
        ]),
        style: $3232eb4c0efd91e0$var$_objectSpread($3232eb4c0efd91e0$var$_objectSpread({}, {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }), {}, {
            "--_wenvhl": (0, $dtlzK.default)("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
            "--_1soe2er": (0, $dtlzK.default)("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
        })
    }));
};
var $3232eb4c0efd91e0$export$2e2bcd8739ae039 = $3232eb4c0efd91e0$var$Skeleton;

});
parcelRegister("izd0e", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d84594f2b691282c$export$2e2bcd8739ae039; });
function $d84594f2b691282c$export$2e2bcd8739ae039() {
    return $d84594f2b691282c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d84594f2b691282c$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1frsO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e8c7ee4084df533$export$2e2bcd8739ae039; });

var $5UTFk = parcelRequire("5UTFk");
function $0e8c7ee4084df533$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5UTFk.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("5UTFk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44ed5cc0978ce04c$export$2e2bcd8739ae039; });

var $9KWCY = parcelRequire("9KWCY");

var $cgXBi = parcelRequire("cgXBi");
function $44ed5cc0978ce04c$export$2e2bcd8739ae039(t) {
    var i = (0, $cgXBi.default)(t, "string");
    return "symbol" == (0, $9KWCY.default)(i) ? i : i + "";
}

});
parcelRegister("9KWCY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $71a5e321fb8ce654$export$2e2bcd8739ae039; });
function $71a5e321fb8ce654$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $71a5e321fb8ce654$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $71a5e321fb8ce654$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cgXBi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8ef5361c42ff446b$export$2e2bcd8739ae039; });

var $9KWCY = parcelRequire("9KWCY");
function $8ef5361c42ff446b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $9KWCY.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $9KWCY.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7DAIH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58f8a8b7a32ab166$export$2e2bcd8739ae039; });
const $58f8a8b7a32ab166$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $58f8a8b7a32ab166$var$ATOMIC_GROUP_LENGTH = 5;
function $58f8a8b7a32ab166$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $58f8a8b7a32ab166$var$UNDERSCORE_UNICODE ? $58f8a8b7a32ab166$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("dtlzK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9ceeb844cdd8c978$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $9ceeb844cdd8c978$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});





parcelRegister("2V8Su", function(module, exports) {
$parcel$export(module.exports, "OrganicLoggedInJiraProductTourOverview", function () { return $416013fb4d6c28df$export$49bc6fac881dd811; });

var $7VQPk = parcelRequire("7VQPk");

var $8LaTa = parcelRequire("8LaTa");

var $l4vdU = parcelRequire("l4vdU");

var $2emUn = parcelRequire("2emUn");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $4afjM = parcelRequire("4afjM");

var $ly0rU = parcelRequire("ly0rU");

var $lTaG1 = parcelRequire("lTaG1");

var $jmYmp = parcelRequire("jmYmp");
const $416013fb4d6c28df$export$49bc6fac881dd811 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "jfind-1506-after-d7-gubtp-organic",
        group: "jfind-1506-after-d7-gubtp-organic",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "jfind-organic-jpt-logged-in-redesign",
            group: "jfind-organic-jpt-logged-in-redesign",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $ly0rU.JiraSitesProvider), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4vdU.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmYmp.default), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        scrollTrackingEnabled: true,
                        pageId: "jsw",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4afjM.ReturningUserBanner), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTaG1.LoggedInHeroSection), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
                        ]
                    })
                ]
            })
        })
    });
};

});
parcelRegister("l4vdU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73f92d32d2fa0cb0$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $32ng3 = parcelRequire("32ng3");
const $73f92d32d2fa0cb0$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $2jatx.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $73f92d32d2fa0cb0$var$sticky = null;
var $73f92d32d2fa0cb0$export$2e2bcd8739ae039 = $73f92d32d2fa0cb0$var$StickyContainer;

});

parcelRegister("j6FQw", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("je135")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("je135")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("je135")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("5S2vX")).ParentScrollTracking; });
parcelRequire("je135");
parcelRequire("5S2vX");

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)({
        threshold: 0.5,
        triggerOnce: true,
        ...observerOptions,
        skip: observerOptions?.skip || !scrollTrackingEnabled
    });
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            if (analyticsClient) {
                createAnalyticsEvent({
                    ...scrollTrackAnalyticsPayload
                }).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent({
                            ...dwellTimeTrackAnalyticsPayload
                        }).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, {
            section: section,
            ...options,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, {
                ...props
            })
        });
    };
}

});
parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("j6FQw");
var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    const pageId = props.pageId ?? parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});



parcelRegister("4afjM", function(module, exports) {
$parcel$export(module.exports, "ReturningUserBanner", function () { return $51537c7de9d5df83$export$14e4a778e9c76f32; });
/* returning-user-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $51537c7de9d5df83$export$14e4a778e9c76f32 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "returning-user-banner",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhk6kkz _1e0c1txw _1n261g80 _zulp1kwk _1bah1h6o _vwz410nf _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v"
        ]),
        style: {
            "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: "\uD83D\uDCE3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraProductTourReturningUserBanner.message",
                defaultMessage: "Introducing agents in Jira <link>Learn more</link>",
                values: {
                    link: $51537c7de9d5df83$var$LearnMoreLink
                }
            })
        ]
    });
const $51537c7de9d5df83$var$LearnMoreLink = (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: "https://www.atlassian.com/blog/announcements/ai-agents-in-jira",
        className: (0, $2jatx.default)([
            "_syazjk2v _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
        ]),
        style: {
            "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
        },
        children: chunks
    });
const $51537c7de9d5df83$var$bannerCss = null;
const $51537c7de9d5df83$var$linkCss = null;

});

parcelRegister("ly0rU", function(module, exports) {
$parcel$export(module.exports, "useJiraSitesContext", function () { return $007cd6e9556fb39d$export$8095836340dcdac5; });
$parcel$export(module.exports, "JiraSitesProvider", function () { return $007cd6e9556fb39d$export$e5844423e4215335; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $doAVE = parcelRequire("doAVE");

var $lmmDf = parcelRequire("lmmDf");

var $32ng3 = parcelRequire("32ng3");
const $007cd6e9556fb39d$var$JiraSitesContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $007cd6e9556fb39d$export$8095836340dcdac5 = ()=>{
    const context = (0, $1oC0p.useContext)($007cd6e9556fb39d$var$JiraSitesContext);
    if (!context) throw new Error("useJiraSitesContext must be used within a JiraSitesProvider");
    return context;
};
const $007cd6e9556fb39d$export$e5844423e4215335 = ({ children: children })=>{
    const [jiraSitesFromAgg, setJiraSitesFromAgg] = (0, $1oC0p.useState)(undefined);
    const { profile: profile } = (0, $doAVE.useUserContext)();
    const aggClient = (0, $1oC0p.useMemo)(()=>new (0, $lmmDf.LoggedInUserJiraSitesClient)(), []);
    const isRtpAvatarsBugFixEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).jfind2379RtpAvatarsBugFix);
    (0, $1oC0p.useEffect)(()=>{
        if (!profile.attributes?.existingSites || !isRtpAvatarsBugFixEnabled && profile.attributes.existingSites.length !== 1) return;
        const site = profile.attributes.existingSites[0];
        aggClient.getJiraSites(site?.cloudId ?? "").then((data)=>{
            setJiraSitesFromAgg(data);
        });
    }, [
        aggClient,
        profile.attributes?.existingSites,
        isRtpAvatarsBugFixEnabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($007cd6e9556fb39d$var$JiraSitesContext.Provider, {
        value: {
            jiraSitesFromAgg: jiraSitesFromAgg
        },
        children: children
    });
};

});

parcelRegister("lTaG1", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSection", function () { return $27cf35ec8a7f1f0a$export$49c6370202c57ed1; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iSeHD = parcelRequire("iSeHD");

var $lqyi6 = parcelRequire("lqyi6");

var $eY3N6 = parcelRequire("eY3N6");

var $hLJF4 = parcelRequire("hLJF4");

var $doAVE = parcelRequire("doAVE");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $1OyVz = parcelRequire("1OyVz");

var $aTTHV = parcelRequire("aTTHV");

var $kP8Dm = parcelRequire("kP8Dm");

var $3riD8 = parcelRequire("3riD8");

var $jUgJp = parcelRequire("jUgJp");

var $1YSly = parcelRequire("1YSly");

var $ly0rU = parcelRequire("ly0rU");
const $27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES = {
    loggedInHeroProductCtaClicked: "loggedInHeroProductCtaClicked",
    loggedInHeroAnotherSiteCtaClicked: "loggedInHeroAnotherSiteCtaClicked",
    loggedInHeroExploreFeaturesClicked: "loggedInHeroExploreFeaturesClicked",
    loggedInHeroCreateNewSiteClicked: "loggedInHeroCreateNewSiteClicked"
};
const $27cf35ec8a7f1f0a$var$START_URL = "https://start.atlassian.com";
const $27cf35ec8a7f1f0a$export$cbc42fadf8b93ea3 = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "loggedInHero",
    source: "/software/jira"
};
const $27cf35ec8a7f1f0a$var$jswLoggedInCss = null;
const $27cf35ec8a7f1f0a$var$heroSectionCss = null;
const $27cf35ec8a7f1f0a$var$anchorContainer = null;
const $27cf35ec8a7f1f0a$var$jiraSiteBoxCss = null;
const $27cf35ec8a7f1f0a$var$headingCss = null;
const $27cf35ec8a7f1f0a$var$starCss = null;
const $27cf35ec8a7f1f0a$var$differentSiteCss = null;
const $27cf35ec8a7f1f0a$var$subHeadingContainerCss = null;
const $27cf35ec8a7f1f0a$var$createNewSiteAnchorCss = null;
const $27cf35ec8a7f1f0a$var$subHeadingCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesContainerCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesHeadingCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesCtaCss = null;
const $27cf35ec8a7f1f0a$var$nameUnderlineCss = null;
const $27cf35ec8a7f1f0a$var$inlineJiraLogoCss = null;
const $27cf35ec8a7f1f0a$var$siteInfoContainerCss = null;
const $27cf35ec8a7f1f0a$var$sitenameIconCss = null;
const $27cf35ec8a7f1f0a$var$sitenameIconTextCss = null;
const $27cf35ec8a7f1f0a$var$sitenameAndAvatarContainerCss = null;
const $27cf35ec8a7f1f0a$var$siteNameSpanCss = null;
const $27cf35ec8a7f1f0a$var$tooltipWrapperCss = null;
const $27cf35ec8a7f1f0a$var$avatarContainerCss = null;
const $27cf35ec8a7f1f0a$var$linkPlaceholderCss = null;
const $27cf35ec8a7f1f0a$export$49c6370202c57ed1 = ()=>{
    const loggedInUserProfile = (0, $3riD8.useLoggedInUser)();
    const { user: user } = (0, $doAVE.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $ly0rU.useJiraSitesContext)();
    const [teammateAvatars, setTeammateAvatars] = (0, $1oC0p.useState)([]);
    const [totalUserCount, setTotalUserCount] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    // GWP-10447: Check if the user is an SMB sales lead to adjust the hero CTA button variant
    const { isEligible: isSMBSalesLead } = (0, $aTTHV.useContactSalesCtaEligibility)();
    // Try to get name from props, and fallback to hook if needed
    const userFirstName = user.name?.split(" ")[0] ?? loggedInUserProfile.name?.split(" ")[0];
    // Try to get picture from props, and fallback to hook if needed
    const userPicture = user?.picture ?? loggedInUserProfile.picture;
    const avatars = jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges;
    (0, $1oC0p.useEffect)(()=>{
        setTeammateAvatars(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges.filter((assignableUser)=>assignableUser.node.picture !== userPicture && assignableUser.node.accountStatus === "active").map((assignableUser)=>{
            return assignableUser.node.picture ?? "";
        }) ?? []);
    }, [
        avatars,
        jiraSitesFromAgg?.jira?.allJiraProjects.edges,
        userPicture
    ]);
    (0, $1oC0p.useEffect)(()=>setTotalUserCount(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.totalCount), [
        jiraSitesFromAgg?.jira?.allJiraProjects.edges
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedTryLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&createNew=true");
    const localizedProductGuideLink = (0, $kooLp.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const [hasMultipleJiras, setHasMultipleJiras] = (0, $1oC0p.useState)(false);
    const [siteName, setSiteName] = (0, $1oC0p.useState)("");
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)("");
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)("");
    const { hasMultipleJiras: mostRecentHasMultipleJiras, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials } = (0, $kP8Dm.useRecentJiraSite)();
    (0, $1oC0p.useEffect)(()=>{
        setHasMultipleJiras(mostRecentHasMultipleJiras);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        mostRecentHasMultipleJiras,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const loggedInHeroLoadedAnalyticsPayload = {
        eventType: "ui",
        action: "loaded",
        actionSubject: "component",
        actionSubjectId: "loggedInHero",
        source: "/software/jira",
        attributes: {
            atlasId: "ATLAS-76385, ATLAS-93656"
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== "undefined") createAnalyticsEvent({
            ...loggedInHeroLoadedAnalyticsPayload
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            ...$27cf35ec8a7f1f0a$export$cbc42fadf8b93ea3,
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: "ATLAS-76385, ATLAS-93656"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _11q71ybm _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5110yn _85i512am _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _syaz1hlo _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7co1w81 _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp",
                            alt: ""
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41pz4 _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnltki _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_u1whbc": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.saffron400"))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: "Jira",
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _195g14id"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroCreateNewSiteClicked),
                            className: (0, $2jatx.default)([
                                "_ect4bzd7 _1wyb7vkz _k48pni7l _vwz41f4h _syazjk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new site"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhkcd5j _2rko1y44 _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1wcj _1rjc7vkz _18zr7vkz _1mougktf _kqswh2mm"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jUgJp.JiraSiteContainer), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_11q7ihgv _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                            ]),
                                            style: {
                                                "--_1efrnav": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime300"))
                                            },
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz5wis _ect41pz4 _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o"
                                                ]),
                                                style: {
                                                    "--_1yoj5ey": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime800")),
                                                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                                },
                                                children: siteInitials
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3igktf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                                        content: siteName,
                                                        position: "top-end",
                                                        mousePosition: "top",
                                                        tag: "span",
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_ect4bzd7 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                            ]),
                                                            style: {
                                                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                                            },
                                                            children: siteName
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                    ]),
                                                    children: userPicture && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YSly.LoggedInProductTourAvatarFacepile), {
                                                        max: 4,
                                                        iconSize: 24,
                                                        icons: [
                                                            userPicture,
                                                            ...teammateAvatars
                                                        ],
                                                        totalUserCount: totalUserCount ?? 0
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    "data-testid": "goToJiraButton",
                                    variant: isSMBSalesLead ? "primary" : "primary_alt",
                                    href: siteUrl,
                                    size: "small",
                                    onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroProductCtaClicked),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                        defaultMessage: "Go to Jira"
                                    })
                                })
                            ]
                        })
                    })
                }),
                hasMultipleJiras ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ect4bzd7 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite",
                            defaultMessage: "Looking for a different site?"
                        }),
                        href: $27cf35ec8a7f1f0a$var$START_URL,
                        type: "primary",
                        onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroAnotherSiteCtaClicked)
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3iqslr"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhvbgk _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1 _6rth7vkz"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.findOutMore",
                                defaultMessage: "Want to find out more about Jira?"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "exploreFeaturesAnchor",
                            href: localizedProductGuideLink,
                            onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroExploreFeaturesClicked),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb7vkz _k48pni7l _11q7glyw _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _19it1axk _80omtlke"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                                    defaultMessage: "Explore features"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$27cf35ec8a7f1f0a$export$49c6370202c57ed1.displayName = "LoggedInHeroSection";
var $27cf35ec8a7f1f0a$export$2e2bcd8739ae039 = $27cf35ec8a7f1f0a$export$49c6370202c57ed1;

});

parcelRegister("jmYmp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32c81aeeb0653afd$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $cjWBX = parcelRequire("cjWBX");

var $doAVE = parcelRequire("doAVE");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");

var $ly0rU = parcelRequire("ly0rU");
const $32c81aeeb0653afd$var$JiraLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $32c81aeeb0653afd$var$SoftwareJiraLoggedInNavbar = ()=>{
    const intl = (0, $8e22h.default)();
    const logoUrl = (0, $kooLp.useLocalizedHref)("/software/jira");
    const { profile: profile } = (0, $doAVE.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $ly0rU.useJiraSitesContext)();
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)("");
    (0, $1oC0p.useEffect)(()=>{
        const site = profile?.attributes?.existingSites[0];
        let tempSiteUrl = site?.url;
        if (jiraSitesFromAgg?.jira.allJiraProjects.edges.length === 1) tempSiteUrl = jiraSitesFromAgg?.jira.allJiraProjects?.edges[0]?.node?.webUrl;
        setSiteUrl(tempSiteUrl ?? "");
    }, [
        jiraSitesFromAgg?.jira.allJiraProjects.edges,
        jiraSitesFromAgg?.jira.allJiraProjects.edges.length,
        profile?.attributes?.existingSites,
        profile?.attributes?.existingSites.length
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cjWBX.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
                productLogoUrl: logoUrl,
                productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($32c81aeeb0653afd$var$JiraLogo, {}),
                productLogoAriaLabel: intl.formatMessage({
                    id: "wacJiraSoftwareNavigation.logo-label",
                    defaultMessage: "Jira Software logo"
                }),
                mobileCtaText: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.navbar.goToJira",
                    defaultMessage: "Go to Jira"
                }),
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                mobileCtaOnClick: ()=>{},
                mobileCtaUrl: siteUrl,
                mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($32c81aeeb0653afd$var$JiraLogo, {}),
                navigationTrynowCtaText: intl.formatMessage({
                    id: "JiraFeatureSoftwarePageTemplate.navbar.goToJira",
                    defaultMessage: "Go to Jira"
                }),
                navigationTrynowCtaUrl: siteUrl,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                navigationTrynowCtaOnClick: ()=>{},
                productPageNavLinks: [],
                mobileLinksSections: [],
                isShowSearchButton: false,
                isShowAppSwitcher: false,
                isShowTabletDropdown: false
            })
        ]
    });
};
var $32c81aeeb0653afd$export$2e2bcd8739ae039 = $32c81aeeb0653afd$var$SoftwareJiraLoggedInNavbar;

});


parcelRegister("b2rSp", function(module, exports) {
$parcel$export(module.exports, "JiraProductTourAiTemplate", function () { return $63cdd6d02720a2e7$export$2464f9fe3647b767; });
/* cfind-6215-frictionless-first-look-jira-v2.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eY3N6 = parcelRequire("eY3N6");

var $k9ZIM = parcelRequire("k9ZIM");

var $8IN8s = parcelRequire("8IN8s");

var $ea4mV = parcelRequire("ea4mV");

var $4E3yC = parcelRequire("4E3yC");

var $jYNiT = parcelRequire("jYNiT");

var $33kEK = parcelRequire("33kEK");

var $e72X5 = parcelRequire("e72X5");

var $jUBSR = parcelRequire("jUBSR");
const $63cdd6d02720a2e7$var$promptContainerCss = null;
const $63cdd6d02720a2e7$var$promptShellExitCss = null;
const $63cdd6d02720a2e7$var$promptContentCss = null;
const $63cdd6d02720a2e7$var$promptContentExitCss = null;
const $63cdd6d02720a2e7$var$disclaimerExitCss = null;
const $63cdd6d02720a2e7$export$2bf0755ba7240c46 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    const promptRef = (0, $1oC0p.useRef)(null);
    const { cgsDataLoading: cgsDataLoading, isErrorFromCgs: isErrorFromCgs, hasSubmittedDefaultValues: hasSubmittedDefaultValues, formattedCgsData: formattedCgsData, rawCgsData: rawCgsData, workingOnValue: workingOnValue, goalValue: goalValue, workingOnSuggestion: workingOnSuggestion, goalSuggestion: goalSuggestion } = (0, $jUBSR.useJiraAiFFL)();
    const [jiraFflV2ExposureFired, fireJiraFflV2Exposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind6215FrictionlessFirstLookJiraV2);
    const jiraFflV2Experiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).cfind6215FrictionlessFirstLookJiraV2);
    const [hideOriginalPrompt, setHideOriginalPrompt] = (0, $1oC0p.useState)(cgsDataLoading);
    const [isPromptExiting, setIsPromptExiting] = (0, $1oC0p.useState)(false);
    const promptSummary = (0, $1oC0p.useMemo)(()=>(0, $e72X5.getPromptSummary)({
            workingOnValue: workingOnValue,
            workingOnSuggestion: workingOnSuggestion,
            goalValue: goalValue,
            goalSuggestion: goalSuggestion
        }), [
        goalSuggestion,
        goalValue,
        workingOnSuggestion,
        workingOnValue
    ]);
    const showInlinePreview = hideOriginalPrompt && !isPromptExiting && (0, $e72X5.shouldShowInlinePreview)({
        cgsDataLoading: cgsDataLoading,
        formattedCgsData: formattedCgsData
    });
    (0, $1oC0p.useEffect)(()=>{
        if (jiraFflV2Experiment.type === (0, $ea4mV.EnrollmentType).ENROLLED && !jiraFflV2ExposureFired) fireJiraFflV2Exposure();
    }, [
        jiraFflV2Experiment.type,
        jiraFflV2ExposureFired,
        fireJiraFflV2Exposure
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!cgsDataLoading || hideOriginalPrompt) return;
        setIsPromptExiting(true);
        setHideOriginalPrompt(true);
        window.setTimeout(()=>{
            setIsPromptExiting(false);
        }, (0, $e72X5.paidJiraAiBackgroundV2SlideMs));
    }, [
        cgsDataLoading,
        hideOriginalPrompt
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return; // be sure analyticsClient is available before firing event
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "PaidLandingJiraAiTemplate",
            attributes: {
                flow: "paidLandingJiraAi",
                variant: "v2"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e72X5.PaidJiraAiHeaderV2), {}),
            (!hideOriginalPrompt || isPromptExiting) && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1pfhckbl _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb _kqswh2mm _y3gn1h6o _19121cl4",
                            isPromptExiting && "_tzy4idpf _t9ec19xf _v56419l1 _lcxvglyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e72X5.PaidJiraAiBackgroundV2), {
                                shouldSlideOut: isPromptExiting
                            }),
                            (!hideOriginalPrompt || isPromptExiting) && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                ref: promptRef,
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1pbykb7n _1bsb18a4 _p12f1osq _195g1wug _tzy4kb7n _t9ec1kli _v56419l1",
                                    isPromptExiting && "_tzy4idpf _t9ec1qv5 _lcxvglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33kEK.PaidJiraAiTeamTypeMadLibPrompt), {
                                    ctaMessage: (0, $e72X5.messages).tryItOut
                                })
                            })
                        ]
                    }),
                    (!hideOriginalPrompt || isPromptExiting) && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            isPromptExiting && "_tzy4idpf _t9ec1kyj _v56419l1 _lcxvglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jYNiT.PaidJiraAiDisclaimer), {})
                    })
                ]
            }),
            showInlinePreview && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e72X5.InlinePreview), {
                cgsDataLoading: cgsDataLoading,
                isErrorFromCgs: isErrorFromCgs,
                hasSubmittedDefaultValues: hasSubmittedDefaultValues,
                promptSummary: promptSummary,
                formattedCgsData: formattedCgsData,
                spaceName: rawCgsData?.sampleIssues.spaceName,
                onTryAnotherPrompt: ()=>{
                    setIsPromptExiting(false);
                    setHideOriginalPrompt(false);
                    window.requestAnimationFrame(()=>{
                        promptRef.current?.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                    });
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4E3yC.PaidJiraAiBody), {})
        ]
    });
};
const $63cdd6d02720a2e7$export$2464f9fe3647b767 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUBSR.JiraAiFFLProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($63cdd6d02720a2e7$export$2bf0755ba7240c46, {})
    });

});
parcelRegister("4E3yC", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiBody", function () { return $48ae735f31d53976$export$ed242b92311bcd7d; });
/* paid-jira-ai-body.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $8LaTa = parcelRequire("8LaTa");

var $jkEFt = parcelRequire("jkEFt");
parcelRequire("aoV5a");
var $bSwKq = parcelRequire("bSwKq");

var $5IbWH = parcelRequire("5IbWH");

var $cf7Ff = parcelRequire("cf7Ff");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $7btsq = parcelRequire("7btsq");
const $48ae735f31d53976$var$jiraAiBodyStyles = null;
const $48ae735f31d53976$var$threeAlternatingImageTextCss = null;
const $48ae735f31d53976$var$paidCtaSectionCss = null;
const $48ae735f31d53976$export$ed242b92311bcd7d = ()=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonPropsHref = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const landingType = "jira-software-paid-ai";
    const tabsProps = {
        dataProductKey: "jiraSoftware-PaidLpJiraFfl",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.heading",
            defaultMessage: "Discover AI features that power your teams"
        }),
        tabStyles: {
            defaultBG: (0, $kbpa7.wacToken)("color.neutral.light0"),
            defaultText: (0, $kbpa7.wacToken)("color.extended.blue1000"),
            hoverBG: (0, $kbpa7.wacToken)("color.neutral.light0"),
            hoverText: (0, $kbpa7.wacToken)("color.extended.blue1000"),
            activeBG: (0, $kbpa7.wacToken)("color.extended.blue200"),
            activeText: (0, $kbpa7.wacToken)("color.extended.blue1000")
        },
        styles: {
            "--lp-tabs-hover": (0, $kbpa7.wacToken)("color.extended.blue200"),
            "--lp-tabs-unselected": (0, $kbpa7.wacToken)("color.neutral.light700")
        },
        tabs: [
            {
                textLabel: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.textLabel",
                    defaultMessage: "Plan"
                }),
                id: "plan",
                component: (0, $7btsq.Plan)()
            },
            {
                textLabel: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.textLabel",
                    defaultMessage: "Track"
                }),
                id: "track",
                component: (0, $7btsq.Track)()
            },
            {
                textLabel: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.textLabel",
                    defaultMessage: "Collaborate"
                }),
                id: "collaborate",
                component: (0, $7btsq.Collaborate)()
            },
            {
                textLabel: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.textLabel",
                    defaultMessage: "Report"
                }),
                id: "report",
                component: (0, $7btsq.Report)()
            }
        ]
    };
    const alternatingTextAndImageProps = {
        backgroundColor: (0, $kbpa7.wacToken)("color.extended.blue100"),
        imageWidth: "100%",
        imageTextSideRowOnePadding: "7.5rem 0 1rem",
        imageTextSideRowOnePaddingBelowLargeScreen: "7.5rem 0 1rem",
        imageTextSideRowTwoPadding: "1rem 0",
        imageTextSideRowThreePadding: "1rem 0 7.5rem",
        imageTextSideRowThreePaddingBelowLargeScreen: "1rem 0 7.5rem",
        rowPropsOdd: "7-5",
        rowPropsEven: "5-7",
        //Row 1
        rowOneHeader: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneHeader",
            defaultMessage: "Customize how your team\u2019s work flows"
        }),
        rowOneBody: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneBody",
            defaultMessage: "Set up, clean up, and automate even the most complicated project workflows."
        }),
        rowOneImageLink: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EZD9.webp",
        rowOneImageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneImageAltText",
            defaultMessage: "Jira boards"
        }),
        //Row 2
        rowTwoHeader: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextHeader",
            defaultMessage: "Stay on track \u2013 even when the track changes"
        }),
        rowTwoBody: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextBody",
            defaultMessage: "Use the timeline view to map out the big picture, communicate updates to stakeholders, and ensure your team stays on the same page."
        }),
        rowTwoImageLink: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EZD7.webp",
        rowTwoImageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowTwoImageAltText",
            defaultMessage: "Jira timeline view."
        }),
        //Row 3
        rowThreeHeader: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeHeader",
            defaultMessage: "Bye-bye, spreadsheets"
        }),
        rowThreeBody: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeBody",
            defaultMessage: "Keep every detail of a project centralized in real time so up-to-date info can flow freely across people, teams, and tools."
        }),
        rowThreeImageLink: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EZD8.webp",
        rowThreeImageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeImageAltText",
            defaultMessage: "Spreadsheets"
        })
    };
    const ctaProps = {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.ctaSection.header",
            defaultMessage: "Move fast, stay aligned, and build better - together"
        }),
        ctaProps: {
            buttonProps: {
                color: "blueprimary700",
                url: ctaButtonPropsHref,
                text: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.ctaSection.button",
                    defaultMessage: "Get it free"
                }),
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-container": "ctaSection",
                    "data-event-component": "linkButton",
                    "data-product-key": "jiraSoftware-PaidLpJiraFeatures"
                },
                size: "small"
            }
        },
        backgroundProperties: {
            textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
        }
    };
    const testimonialProps = {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.heading",
            defaultMessage: "Trusted by over 100,000 customers world-wide"
        }),
        logos: [
            {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5382nib232306760cxko3fu33yr03hc6.svg",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.squareAlt",
                    defaultMessage: "Square logo"
                }),
                loading: "lazy",
                width: 162,
                height: 40
            },
            {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8sh6x4kh58c7576am3gc70215abr77gu.svg",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.ebayAlt",
                    defaultMessage: "eBay logo"
                }),
                loading: "lazy",
                width: 99,
                height: 41
            },
            {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7l40fo7ky3ck1752eh0ti31556343388.svg",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.spotifyAlt",
                    defaultMessage: "Spotify logo"
                }),
                loading: "lazy",
                width: 163,
                height: 49
            },
            {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/0atd5rxku6yg42wfhx0b1jdrsusm532i.svg",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.ciscoAlt",
                    defaultMessage: "Cisco logo"
                }),
                loading: "lazy",
                width: 92,
                height: 49
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q5153f4"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "paid-lp-jsw-ffl",
            scrollTrackingEnabled: true,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cf7Ff.PaidTabsSection), {
                    ...tabsProps
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1nh073xg _1b6r1fw0 _vuss8pqr _18m21wto _17xw1hlo _p1061k92 _13031m1q _1of01hlo"
                    ]),
                    style: {
                        "--_1fssbon": (0, $6ZVlx.default)((1168 + (0, $jMhSx.GRID_FIXED_PADDING) * 2) / 16, "rem"),
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSwKq.ThreeAlternatingImageText), {
                        ...alternatingTextAndImageProps
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pal2qcg _14c7idpf _6vxh1wug _1rmzidpf _1igu1wug _17xwr3uz _1b6r8n31 _17e21k92 _10sl1k8s _1wty8pqr _zms51kwk _qpb11k8s _9kaf1kwk _1art1k8s _73hz8pqr _cokwidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5IbWH.PaidCtaSection), {
                        ctaProps: ctaProps,
                        landingType: landingType
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jkEFt.default), {
                    ...testimonialProps
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
            ]
        })
    });
};

});
parcelRegister("aoV5a", function(module, exports) {
$parcel$export(module.exports, "ThreeAlternatingImageText", function () { return (parcelRequire("bSwKq")).ThreeAlternatingImageText; });

var $bSwKq = parcelRequire("bSwKq");

});




parcelRegister("at85i", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $79f2e2331b9e0776$var$__DEV__ = false;
var $79f2e2331b9e0776$var$warning = function() {};
if ($79f2e2331b9e0776$var$__DEV__) {
    var $79f2e2331b9e0776$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $79f2e2331b9e0776$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $79f2e2331b9e0776$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $79f2e2331b9e0776$var$warning;

});

parcelRegister("4b05t", function(module, exports) {

var $jSt0M = parcelRequire("jSt0M");
var $30a841da5660bc0e$var$listeningFocusTrap = null;
function $30a841da5660bc0e$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $30a841da5660bc0e$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($30a841da5660bc0e$var$listeningFocusTrap) $30a841da5660bc0e$var$listeningFocusTrap.pause();
        $30a841da5660bc0e$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $30a841da5660bc0e$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $30a841da5660bc0e$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $30a841da5660bc0e$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $30a841da5660bc0e$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $30a841da5660bc0e$var$tryFocus(lastTabbableNode);
            return $30a841da5660bc0e$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $30a841da5660bc0e$var$tryFocus(firstTabbableNode);
        $30a841da5660bc0e$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $jSt0M(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $30a841da5660bc0e$var$tryFocus(lastTabbableNode);
        $30a841da5660bc0e$var$tryFocus(firstTabbableNode);
    }
}
function $30a841da5660bc0e$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $30a841da5660bc0e$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $30a841da5660bc0e$var$focusTrap;

});
parcelRegister("jSt0M", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $e78990932ff29185$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $e78990932ff29185$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("j9BEl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df1c100df26f3bb5$export$2e2bcd8739ae039; });

var $kFuqb = parcelRequire("kFuqb");

var $3oV3g = parcelRequire("3oV3g");

var $7t0tI = parcelRequire("7t0tI");
var $df1c100df26f3bb5$var$_process$env;
var $df1c100df26f3bb5$var$ExportedAnalyticsContext;
if (typeof $7t0tI !== 'undefined' && $7t0tI !== null && ($df1c100df26f3bb5$var$_process$env = {}, true) && $df1c100df26f3bb5$var$_process$env !== void 0 && $df1c100df26f3bb5$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']) $df1c100df26f3bb5$var$ExportedAnalyticsContext = (0, $3oV3g.default);
else $df1c100df26f3bb5$var$ExportedAnalyticsContext = (0, $kFuqb.default);
var $df1c100df26f3bb5$export$2e2bcd8739ae039 = $df1c100df26f3bb5$var$ExportedAnalyticsContext;

});
parcelRegister("kFuqb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0bf3c0a01f39e80$export$2e2bcd8739ae039; });

var $9GFoj = parcelRequire("9GFoj");

var $1itsa = parcelRequire("1itsa");

var $4A0Tr = parcelRequire("4A0Tr");

var $i1kpm = parcelRequire("i1kpm");

var $jfDAi = parcelRequire("jfDAi");

var $djanu = parcelRequire("djanu");

var $gc1Dl = parcelRequire("gc1Dl");

var $9c1Qf = parcelRequire("9c1Qf");

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $bEiDG = parcelRequire("bEiDG");
function $f0bf3c0a01f39e80$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f0bf3c0a01f39e80$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $gc1Dl.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gc1Dl.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $djanu.default)(this, result);
    };
}
function $f0bf3c0a01f39e80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $f0bf3c0a01f39e80$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func
};
var $f0bf3c0a01f39e80$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f0bf3c0a01f39e80$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, $jfDAi.default)(AnalyticsContext, _Component);
    var _super = $f0bf3c0a01f39e80$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, $1itsa.default)(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla;
            return [].concat((0, $9GFoj.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $4A0Tr.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $1oC0p.Component));
(0, $9c1Qf.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "contextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
(0, $9c1Qf.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "childContextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
var $f0bf3c0a01f39e80$export$2e2bcd8739ae039 = $f0bf3c0a01f39e80$var$AnalyticsContext;

});

parcelRegister("3oV3g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $279fde3eadf46ed4$export$2e2bcd8739ae039; });

var $9GFoj = parcelRequire("9GFoj");

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");

var $e1T86 = parcelRequire("e1T86");

var $j10Ql = parcelRequire("j10Ql");
var $279fde3eadf46ed4$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $j10Ql.useTrackedRef)(data);
    var analyticsContext = (0, $e1T86.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $1oC0p.useCallback)(function() {
        return [].concat((0, $9GFoj.default)(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
        value: value
    }, children);
};
var $279fde3eadf46ed4$export$2e2bcd8739ae039 = $279fde3eadf46ed4$var$AnalyticsContext;

});


parcelRegister("gHIMV", function(module, exports) {

var $24uwp = parcelRequire("24uwp");

var $7RbbL = parcelRequire("7RbbL");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $c2936778f0bf11fd$var$capitalize(string) {
    return $7RbbL($24uwp(string).toLowerCase());
}
module.exports = $c2936778f0bf11fd$var$capitalize;

});
parcelRegister("7RbbL", function(module, exports) {

var $iBcGo = parcelRequire("iBcGo");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5b86297e1fc1db25$var$upperFirst = $iBcGo('toUpperCase');
module.exports = $5b86297e1fc1db25$var$upperFirst;

});
parcelRegister("iBcGo", function(module, exports) {

var $ehULU = parcelRequire("ehULU");

var $ePM67 = parcelRequire("ePM67");

var $1GITV = parcelRequire("1GITV");

var $24uwp = parcelRequire("24uwp");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d8a585375440fb5a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $24uwp(string);
        var strSymbols = $ePM67(string) ? $1GITV(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ehULU(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $d8a585375440fb5a$var$createCaseFirst;

});
parcelRegister("ehULU", function(module, exports) {

var $ezuzU = parcelRequire("ezuzU");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a66eb0e6cce6b4e5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ezuzU(array, start, end);
}
module.exports = $a66eb0e6cce6b4e5$var$castSlice;

});
parcelRegister("ezuzU", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a9bc0dc53628b88a$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $a9bc0dc53628b88a$var$baseSlice;

});


parcelRegister("ePM67", function(module, exports) {
/** Used to compose unicode character classes. */ var $accb234eacd9a37f$var$rsAstralRange = '\\ud800-\\udfff', $accb234eacd9a37f$var$rsComboMarksRange = '\\u0300-\\u036f', $accb234eacd9a37f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $accb234eacd9a37f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $accb234eacd9a37f$var$rsComboRange = $accb234eacd9a37f$var$rsComboMarksRange + $accb234eacd9a37f$var$reComboHalfMarksRange + $accb234eacd9a37f$var$rsComboSymbolsRange, $accb234eacd9a37f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $accb234eacd9a37f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $accb234eacd9a37f$var$reHasUnicode = RegExp('[' + $accb234eacd9a37f$var$rsZWJ + $accb234eacd9a37f$var$rsAstralRange + $accb234eacd9a37f$var$rsComboRange + $accb234eacd9a37f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $accb234eacd9a37f$var$hasUnicode(string) {
    return $accb234eacd9a37f$var$reHasUnicode.test(string);
}
module.exports = $accb234eacd9a37f$var$hasUnicode;

});

parcelRegister("1GITV", function(module, exports) {

var $3VH6A = parcelRequire("3VH6A");

var $ePM67 = parcelRequire("ePM67");

var $aYfG6 = parcelRequire("aYfG6");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $13ac8b161df780fb$var$stringToArray(string) {
    return $ePM67(string) ? $aYfG6(string) : $3VH6A(string);
}
module.exports = $13ac8b161df780fb$var$stringToArray;

});
parcelRegister("3VH6A", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2dc821c7632c8518$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $2dc821c7632c8518$var$asciiToArray;

});

parcelRegister("aYfG6", function(module, exports) {
/** Used to compose unicode character classes. */ var $7fcbab4f0bbb188c$var$rsAstralRange = '\\ud800-\\udfff', $7fcbab4f0bbb188c$var$rsComboMarksRange = '\\u0300-\\u036f', $7fcbab4f0bbb188c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7fcbab4f0bbb188c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7fcbab4f0bbb188c$var$rsComboRange = $7fcbab4f0bbb188c$var$rsComboMarksRange + $7fcbab4f0bbb188c$var$reComboHalfMarksRange + $7fcbab4f0bbb188c$var$rsComboSymbolsRange, $7fcbab4f0bbb188c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7fcbab4f0bbb188c$var$rsAstral = '[' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsCombo = '[' + $7fcbab4f0bbb188c$var$rsComboRange + ']', $7fcbab4f0bbb188c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7fcbab4f0bbb188c$var$rsModifier = '(?:' + $7fcbab4f0bbb188c$var$rsCombo + '|' + $7fcbab4f0bbb188c$var$rsFitz + ')', $7fcbab4f0bbb188c$var$rsNonAstral = '[^' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7fcbab4f0bbb188c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7fcbab4f0bbb188c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7fcbab4f0bbb188c$var$reOptMod = $7fcbab4f0bbb188c$var$rsModifier + '?', $7fcbab4f0bbb188c$var$rsOptVar = '[' + $7fcbab4f0bbb188c$var$rsVarRange + ']?', $7fcbab4f0bbb188c$var$rsOptJoin = '(?:' + $7fcbab4f0bbb188c$var$rsZWJ + '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair
].join('|') + ')' + $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + ')*', $7fcbab4f0bbb188c$var$rsSeq = $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + $7fcbab4f0bbb188c$var$rsOptJoin, $7fcbab4f0bbb188c$var$rsSymbol = '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral + $7fcbab4f0bbb188c$var$rsCombo + '?',
    $7fcbab4f0bbb188c$var$rsCombo,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair,
    $7fcbab4f0bbb188c$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7fcbab4f0bbb188c$var$reUnicode = RegExp($7fcbab4f0bbb188c$var$rsFitz + '(?=' + $7fcbab4f0bbb188c$var$rsFitz + ')|' + $7fcbab4f0bbb188c$var$rsSymbol + $7fcbab4f0bbb188c$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7fcbab4f0bbb188c$var$unicodeToArray(string) {
    return string.match($7fcbab4f0bbb188c$var$reUnicode) || [];
}
module.exports = $7fcbab4f0bbb188c$var$unicodeToArray;

});





parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});

parcelRegister("46Ma8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fdd15086956a812$var$_react = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2fdd15086956a812$var$_baseNew = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2fdd15086956a812$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fdd15086956a812$var$AddIcon = (props)=>/*#__PURE__*/ $2fdd15086956a812$var$_react.default.createElement($2fdd15086956a812$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$2fdd15086956a812$var$AddIcon.displayName = 'AddIcon';
var $2fdd15086956a812$var$_default = module.exports.default = $2fdd15086956a812$var$AddIcon;

});

parcelRegister("5oMeU", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $119FI = parcelRequire("119FI");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $3ee49cf968a053d8$var$baseGet(object, path) {
    path = $hLLeA(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$119FI(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $3ee49cf968a053d8$var$baseGet;

});

parcelRegister("4EAwS", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $36373bd43f9f4b21$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5oMeU(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $36373bd43f9f4b21$var$get;

});

parcelRegister("5RBBI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $444f1300adfdb621$var$_react = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $444f1300adfdb621$var$_baseNew = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $444f1300adfdb621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $444f1300adfdb621$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $444f1300adfdb621$var$_react.default.createElement($444f1300adfdb621$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$444f1300adfdb621$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $444f1300adfdb621$var$_default = module.exports.default = $444f1300adfdb621$var$ChevronDownIcon;

});

parcelRegister("9tc44", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e502e4b67b18fd0$var$_react = $6e502e4b67b18fd0$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6e502e4b67b18fd0$var$_baseNew = $6e502e4b67b18fd0$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6e502e4b67b18fd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e502e4b67b18fd0$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $6e502e4b67b18fd0$var$_react.default.createElement($6e502e4b67b18fd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$6e502e4b67b18fd0$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $6e502e4b67b18fd0$var$_default = module.exports.default = $6e502e4b67b18fd0$var$CheckboxCheckedIcon;

});

parcelRegister("4se1R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0749aecb688ec01c0962b8f7fb609ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33e4a8d142e55a34$var$_react = $33e4a8d142e55a34$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33e4a8d142e55a34$var$_baseNew = $33e4a8d142e55a34$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $33e4a8d142e55a34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33e4a8d142e55a34$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $33e4a8d142e55a34$var$_react.default.createElement($33e4a8d142e55a34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$33e4a8d142e55a34$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $33e4a8d142e55a34$var$_default = module.exports.default = $33e4a8d142e55a34$var$StatusInformationIcon;

});

parcelRegister("7surG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56e2c3c1a9226f96$var$_react = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56e2c3c1a9226f96$var$_baseNew = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $56e2c3c1a9226f96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56e2c3c1a9226f96$var$PersonIcon = (props)=>/*#__PURE__*/ $56e2c3c1a9226f96$var$_react.default.createElement($56e2c3c1a9226f96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$56e2c3c1a9226f96$var$PersonIcon.displayName = 'PersonIcon';
var $56e2c3c1a9226f96$var$_default = module.exports.default = $56e2c3c1a9226f96$var$PersonIcon;

});

parcelRegister("gvZeq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c05f09ee49282e55$var$_react = $c05f09ee49282e55$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c05f09ee49282e55$var$_baseNew = $c05f09ee49282e55$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c05f09ee49282e55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c05f09ee49282e55$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c05f09ee49282e55$var$_react.default.createElement($c05f09ee49282e55$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$c05f09ee49282e55$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c05f09ee49282e55$var$_default = module.exports.default = $c05f09ee49282e55$var$PeopleGroupIcon;

});

parcelRegister("LlYs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08e56f7bc5f7a423$var$_react = $08e56f7bc5f7a423$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $08e56f7bc5f7a423$var$_baseNew = $08e56f7bc5f7a423$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $08e56f7bc5f7a423$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08e56f7bc5f7a423$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $08e56f7bc5f7a423$var$_react.default.createElement($08e56f7bc5f7a423$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$08e56f7bc5f7a423$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $08e56f7bc5f7a423$var$_default = module.exports.default = $08e56f7bc5f7a423$var$InformationCircleIcon;

});

parcelRegister("4szpS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33f53fe53f7c5942$var$_react = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33f53fe53f7c5942$var$_baseNew = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $33f53fe53f7c5942$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33f53fe53f7c5942$var$BacklogIcon = (props)=>/*#__PURE__*/ $33f53fe53f7c5942$var$_react.default.createElement($33f53fe53f7c5942$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$33f53fe53f7c5942$var$BacklogIcon.displayName = 'BacklogIcon';
var $33f53fe53f7c5942$var$_default = module.exports.default = $33f53fe53f7c5942$var$BacklogIcon;

});

parcelRegister("26k9M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $187bc709663ecc73$var$_react = $187bc709663ecc73$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $187bc709663ecc73$var$_baseNew = $187bc709663ecc73$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $187bc709663ecc73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $187bc709663ecc73$var$BoardIcon = (props)=>/*#__PURE__*/ $187bc709663ecc73$var$_react.default.createElement($187bc709663ecc73$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$187bc709663ecc73$var$BoardIcon.displayName = 'BoardIcon';
var $187bc709663ecc73$var$_default = module.exports.default = $187bc709663ecc73$var$BoardIcon;

});

parcelRegister("3GRvb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2afecbb2c786369d$var$_react = $2afecbb2c786369d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2afecbb2c786369d$var$_baseNew = $2afecbb2c786369d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2afecbb2c786369d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2afecbb2c786369d$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $2afecbb2c786369d$var$_react.default.createElement($2afecbb2c786369d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$2afecbb2c786369d$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $2afecbb2c786369d$var$_default = module.exports.default = $2afecbb2c786369d$var$ListChecklistIcon;

});

parcelRegister("PQhz5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09bd51b6223980e7$var$_react = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $09bd51b6223980e7$var$_baseNew = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $09bd51b6223980e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09bd51b6223980e7$var$PageIcon = (props)=>/*#__PURE__*/ $09bd51b6223980e7$var$_react.default.createElement($09bd51b6223980e7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$09bd51b6223980e7$var$PageIcon.displayName = 'PageIcon';
var $09bd51b6223980e7$var$_default = module.exports.default = $09bd51b6223980e7$var$PageIcon;

});

parcelRegister("fLF1J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7ab11e61c51605b$var$_react = $b7ab11e61c51605b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b7ab11e61c51605b$var$_baseNew = $b7ab11e61c51605b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $b7ab11e61c51605b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7ab11e61c51605b$var$TimelineIcon = (props)=>/*#__PURE__*/ $b7ab11e61c51605b$var$_react.default.createElement($b7ab11e61c51605b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$b7ab11e61c51605b$var$TimelineIcon.displayName = 'TimelineIcon';
var $b7ab11e61c51605b$var$_default = module.exports.default = $b7ab11e61c51605b$var$TimelineIcon;

});

parcelRegister("djHSy", function(module, exports) {
$parcel$export(module.exports, "Context", function () { return $9b1f1627d56ad4e6$export$841858b892ce1f4c; });

var $1oC0p = parcelRequire("1oC0p");

var $iLhGt = parcelRequire("iLhGt");
const $9b1f1627d56ad4e6$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext({
    globalRegistry: (0, $iLhGt.defaultRegistry),
    retrieveStore: (Store)=>(0, $iLhGt.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("iLhGt", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", function () { return $da8a557b4bf7f386$export$acb47f32da33501e; });
$parcel$export(module.exports, "defaultRegistry", function () { return $da8a557b4bf7f386$export$9d726ae4880b1060; });

var $5SdS7 = parcelRequire("5SdS7");

var $19KTt = parcelRequire("19KTt");

var $4h8Lm = parcelRequire("4h8Lm");
const $da8a557b4bf7f386$export$e4d628ba0054221b = '__global__';
class $da8a557b4bf7f386$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $da8a557b4bf7f386$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $5SdS7.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $4h8Lm.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $19KTt.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $da8a557b4bf7f386$export$9d726ae4880b1060 = new $da8a557b4bf7f386$export$acb47f32da33501e();

});
parcelRegister("5SdS7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $446cc194a1624a36$export$2e2bcd8739ae039; });
const $446cc194a1624a36$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $446cc194a1624a36$export$2e2bcd8739ae039 = $446cc194a1624a36$var$supports;

});

parcelRegister("19KTt", function(module, exports) {
$parcel$export(module.exports, "bindActions", function () { return $0d7b01ce9c6a9ee9$export$5ee1d46cd0883a22; });

var $7EDZa = parcelRequire("7EDZa");
const $0d7b01ce9c6a9ee9$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $0d7b01ce9c6a9ee9$var$warnings = new WeakMap();
const $0d7b01ce9c6a9ee9$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $7EDZa.default).devtools ? $0d7b01ce9c6a9ee9$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$0d7b01ce9c6a9ee9$var$warnings.has(actionFn)) $0d7b01ce9c6a9ee9$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $0d7b01ce9c6a9ee9$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $0d7b01ce9c6a9ee9$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});
parcelRegister("7EDZa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $592b492760646f40$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
const $592b492760646f40$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $592b492760646f40$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))),
    devtools: false,
    middlewares: new Set(),
    mutator: $592b492760646f40$var$defaultMutator
};
var $592b492760646f40$export$2e2bcd8739ae039 = $592b492760646f40$var$defaults;

});


parcelRegister("4h8Lm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $31cf8c17d087a0dd$export$2e2bcd8739ae039; });

var $l7oft = parcelRequire("l7oft");

var $iltul = parcelRequire("iltul");

var $7EDZa = parcelRequire("7EDZa");

var $beVz1 = parcelRequire("beVz1");
function $31cf8c17d087a0dd$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $beVz1.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $l7oft.default)(storeState, (0, $7EDZa.default).middlewares);
    return storeState;
}
var $31cf8c17d087a0dd$export$2e2bcd8739ae039 = (0, $iltul.default)($31cf8c17d087a0dd$var$createStoreState);

});
parcelRegister("l7oft", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f5fd0fb4f3f37e08$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");

var $8p4Wo = parcelRequire("8p4Wo");
const $f5fd0fb4f3f37e08$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $8p4Wo.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $7EDZa.default).mutator);
var $f5fd0fb4f3f37e08$export$2e2bcd8739ae039 = $f5fd0fb4f3f37e08$var$applyMiddleware;

});
parcelRegister("8p4Wo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61e47da7d6a27804$export$2e2bcd8739ae039; });

var $iEBLg = parcelRequire("iEBLg");
const $61e47da7d6a27804$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $iEBLg.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $61e47da7d6a27804$export$2e2bcd8739ae039 = $61e47da7d6a27804$var$updateMiddleware;

});
parcelRegister("iEBLg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9494103866cad1b$export$2e2bcd8739ae039; });
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $d9494103866cad1b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $d9494103866cad1b$var$CACHE = new WeakMap();
function $d9494103866cad1b$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($d9494103866cad1b$var$CACHE.has(objA)) keysA = $d9494103866cad1b$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $d9494103866cad1b$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($d9494103866cad1b$var$CACHE.has(objB)) keysB = $d9494103866cad1b$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $d9494103866cad1b$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$d9494103866cad1b$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("iltul", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d5b10ff816f52ca9$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");
const $d5b10ff816f52ca9$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $d5b10ff816f52ca9$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $7EDZa.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $7EDZa.default).devtools === 'function' ? (0, $7EDZa.default).devtools(storeState) : {};
                        devTools = $d5b10ff816f52ca9$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $d5b10ff816f52ca9$export$2e2bcd8739ae039 = $d5b10ff816f52ca9$var$withDevtools;

});

parcelRegister("beVz1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82eda785b72bac58$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");

var $9PrlP = parcelRequire("9PrlP");

var $5SdS7 = parcelRequire("5SdS7");
const $82eda785b72bac58$var$QUEUE = [];
let $82eda785b72bac58$var$scheduled;
function $82eda785b72bac58$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $7EDZa.default).batchUpdates || !(0, $5SdS7.default).scheduling()) return (0, $9PrlP.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$82eda785b72bac58$var$QUEUE.includes(fn)) $82eda785b72bac58$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($82eda785b72bac58$var$scheduled) return;
    $82eda785b72bac58$var$scheduled = (0, $9PrlP.batch)(()=>{
        let queueFn;
        while(queueFn = $82eda785b72bac58$var$QUEUE.shift())queueFn();
        $82eda785b72bac58$var$scheduled = null;
    });
}

});
parcelRegister("9PrlP", function(module, exports) {
$parcel$export(module.exports, "batch", function () { return $727e17d26f80e91e$export$712ea50be43a7858; });
/* eslint-disable import/no-unresolved */ 
var $gUjjH = parcelRequire("gUjjH");

var $jEVVm = parcelRequire("jEVVm");

var $7EDZa = parcelRequire("7EDZa");

var $5SdS7 = parcelRequire("5SdS7");
let $727e17d26f80e91e$var$isInsideBatchedSchedule = false;
function $727e17d26f80e91e$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $7EDZa.default).batchUpdates || !(0, $5SdS7.default).scheduling() || $727e17d26f80e91e$var$isInsideBatchedSchedule) return (0, $gUjjH.unstable_batchedUpdates)(fn);
    $727e17d26f80e91e$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $jEVVm.unstable_scheduleCallback)((0, $jEVVm.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $gUjjH.unstable_batchedUpdates)(fn);
        $727e17d26f80e91e$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("jEVVm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9BZqy"));

});
parcelRegister("9BZqy", function(module, exports) {
$parcel$export(module.exports, "unstable_now", function () { return $6ff737efae05bc89$export$c4744153514ff05d; }, function (v) { return $6ff737efae05bc89$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7; }, function (v) { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ff737efae05bc89$export$e26fe2ed2fa76875; }, function (v) { return $6ff737efae05bc89$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ff737efae05bc89$export$502329bbf4b505b1; }, function (v) { return $6ff737efae05bc89$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ff737efae05bc89$export$6e3807111c4874c4; }, function (v) { return $6ff737efae05bc89$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ff737efae05bc89$export$c27134553091fb3a; }, function (v) { return $6ff737efae05bc89$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ff737efae05bc89$export$33ee1acdc04fd2a2; }, function (v) { return $6ff737efae05bc89$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ff737efae05bc89$export$b00a404bbd5edef2; }, function (v) { return $6ff737efae05bc89$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ff737efae05bc89$export$d66a1c1c77bd778b; }, function (v) { return $6ff737efae05bc89$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ff737efae05bc89$export$d3dfb8e4810cb555; }, function (v) { return $6ff737efae05bc89$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ff737efae05bc89$export$72fdf0e06517287b; }, function (v) { return $6ff737efae05bc89$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ff737efae05bc89$export$816d2913ae6b83b1; }, function (v) { return $6ff737efae05bc89$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ff737efae05bc89$export$61bcfe829111a1d0; }, function (v) { return $6ff737efae05bc89$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ff737efae05bc89$export$7ee8c9beb337bc3f; }, function (v) { return $6ff737efae05bc89$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ff737efae05bc89$export$b5836b71941fa3ed; }, function (v) { return $6ff737efae05bc89$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ff737efae05bc89$export$cf845f2c119da08a; }, function (v) { return $6ff737efae05bc89$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ff737efae05bc89$export$c4744153514ff05d;
var $6ff737efae05bc89$export$3e506c1ccc9cc1a7;
var $6ff737efae05bc89$export$e26fe2ed2fa76875;
var $6ff737efae05bc89$export$502329bbf4b505b1;
var $6ff737efae05bc89$export$6e3807111c4874c4;
var $6ff737efae05bc89$export$c27134553091fb3a;
var $6ff737efae05bc89$export$33ee1acdc04fd2a2;
var $6ff737efae05bc89$export$b00a404bbd5edef2;
var $6ff737efae05bc89$export$d66a1c1c77bd778b;
var $6ff737efae05bc89$export$d3dfb8e4810cb555;
var $6ff737efae05bc89$export$72fdf0e06517287b;
var $6ff737efae05bc89$export$816d2913ae6b83b1;
var $6ff737efae05bc89$export$61bcfe829111a1d0;
var $6ff737efae05bc89$export$7ee8c9beb337bc3f;
var $6ff737efae05bc89$export$b5836b71941fa3ed;
var $6ff737efae05bc89$export$cf845f2c119da08a;
"use strict";
function $6ff737efae05bc89$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6ff737efae05bc89$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6ff737efae05bc89$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6ff737efae05bc89$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6ff737efae05bc89$var$compare(left, last)) rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6ff737efae05bc89$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6ff737efae05bc89$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ff737efae05bc89$var$localPerformance = performance;
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localPerformance.now();
    };
} else {
    var $6ff737efae05bc89$var$localDate = Date, $6ff737efae05bc89$var$initialTime = $6ff737efae05bc89$var$localDate.now();
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localDate.now() - $6ff737efae05bc89$var$initialTime;
    };
}
var $6ff737efae05bc89$var$taskQueue = [], $6ff737efae05bc89$var$timerQueue = [], $6ff737efae05bc89$var$taskIdCounter = 1, $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = 3, $6ff737efae05bc89$var$isPerformingWork = !1, $6ff737efae05bc89$var$isHostCallbackScheduled = !1, $6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$needsPaint = !1, $6ff737efae05bc89$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6ff737efae05bc89$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6ff737efae05bc89$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6ff737efae05bc89$var$advanceTimers(currentTime) {
    for(var timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue);
        else if (timer.startTime <= currentTime) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue), timer.sortIndex = timer.expirationTime, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, timer);
        else break;
        timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
    }
}
function $6ff737efae05bc89$var$handleTimeout(currentTime) {
    $6ff737efae05bc89$var$isHostTimeoutScheduled = !1;
    $6ff737efae05bc89$var$advanceTimers(currentTime);
    if (!$6ff737efae05bc89$var$isHostCallbackScheduled) {
        if (null !== $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue)) $6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6ff737efae05bc89$var$isMessageLoopRunning = !1, $6ff737efae05bc89$var$taskTimeoutID = -1, $6ff737efae05bc89$var$frameInterval = 5, $6ff737efae05bc89$var$startTime = -1;
function $6ff737efae05bc89$var$shouldYieldToHost() {
    return $6ff737efae05bc89$var$needsPaint ? !0 : $6ff737efae05bc89$export$c4744153514ff05d() - $6ff737efae05bc89$var$startTime < $6ff737efae05bc89$var$frameInterval ? !1 : !0;
}
function $6ff737efae05bc89$var$performWorkUntilDeadline() {
    $6ff737efae05bc89$var$needsPaint = !1;
    if ($6ff737efae05bc89$var$isMessageLoopRunning) {
        var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
        $6ff737efae05bc89$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6ff737efae05bc89$var$isHostCallbackScheduled = !1;
                $6ff737efae05bc89$var$isHostTimeoutScheduled && ($6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1);
                $6ff737efae05bc89$var$isPerformingWork = !0;
                var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
                try {
                    b: {
                        $6ff737efae05bc89$var$advanceTimers(currentTime);
                        for($6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue); null !== $6ff737efae05bc89$var$currentTask && !($6ff737efae05bc89$var$currentTask.expirationTime > currentTime && $6ff737efae05bc89$var$shouldYieldToHost());){
                            var callback = $6ff737efae05bc89$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6ff737efae05bc89$var$currentTask.callback = null;
                                $6ff737efae05bc89$var$currentPriorityLevel = $6ff737efae05bc89$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6ff737efae05bc89$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6ff737efae05bc89$var$currentTask.callback = continuationCallback;
                                    $6ff737efae05bc89$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6ff737efae05bc89$var$currentTask === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                                $6ff737efae05bc89$var$advanceTimers(currentTime);
                            } else $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                            $6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue);
                        }
                        if (null !== $6ff737efae05bc89$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
                            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel, $6ff737efae05bc89$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline() : $6ff737efae05bc89$var$isMessageLoopRunning = !1;
        }
    }
}
var $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6ff737efae05bc89$var$localSetImmediate) $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetImmediate($6ff737efae05bc89$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ff737efae05bc89$var$channel = new MessageChannel(), $6ff737efae05bc89$var$port = $6ff737efae05bc89$var$channel.port2;
    $6ff737efae05bc89$var$channel.port1.onmessage = $6ff737efae05bc89$var$performWorkUntilDeadline;
    $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
        $6ff737efae05bc89$var$port.postMessage(null);
    };
} else $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetTimeout($6ff737efae05bc89$var$performWorkUntilDeadline, 0);
};
function $6ff737efae05bc89$var$requestHostTimeout(callback, ms) {
    $6ff737efae05bc89$var$taskTimeoutID = $6ff737efae05bc89$var$localSetTimeout(function() {
        callback($6ff737efae05bc89$export$c4744153514ff05d());
    }, ms);
}
$6ff737efae05bc89$export$3e506c1ccc9cc1a7 = 5;
$6ff737efae05bc89$export$e26fe2ed2fa76875 = 1;
$6ff737efae05bc89$export$502329bbf4b505b1 = 4;
$6ff737efae05bc89$export$6e3807111c4874c4 = 3;
$6ff737efae05bc89$export$c27134553091fb3a = null;
$6ff737efae05bc89$export$33ee1acdc04fd2a2 = 2;
$6ff737efae05bc89$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6ff737efae05bc89$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ff737efae05bc89$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6ff737efae05bc89$export$d3dfb8e4810cb555 = function() {
    return $6ff737efae05bc89$var$currentPriorityLevel;
};
$6ff737efae05bc89$export$72fdf0e06517287b = function(eventHandler) {
    switch($6ff737efae05bc89$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$816d2913ae6b83b1 = function() {
    $6ff737efae05bc89$var$needsPaint = !0;
};
$6ff737efae05bc89$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6ff737efae05bc89$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$timerQueue, priorityLevel), null === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && priorityLevel === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue) && ($6ff737efae05bc89$var$isHostTimeoutScheduled ? ($6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1) : $6ff737efae05bc89$var$isHostTimeoutScheduled = !0, $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, priorityLevel), $6ff737efae05bc89$var$isHostCallbackScheduled || $6ff737efae05bc89$var$isPerformingWork || ($6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6ff737efae05bc89$export$b5836b71941fa3ed = $6ff737efae05bc89$var$shouldYieldToHost;
$6ff737efae05bc89$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
        $6ff737efae05bc89$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});







parcelRegister("cVxfO", function(module, exports) {
$parcel$export(module.exports, "createHook", function () { return $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24; });

var $1oC0p = parcelRequire("1oC0p");

var $ixLXc = parcelRequire("ixLXc");

var $djHSy = parcelRequire("djHSy");

var $82g7P = parcelRequire("82g7P");
const $96949a7b8ed8e0eb$var$EMPTY_SELECTOR = ()=>undefined;
const $96949a7b8ed8e0eb$var$DEFAULT_SELECTOR = (state)=>state;
function $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $1oC0p.useContext)((0, $djHSy.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $1oC0p.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $1oC0p.useMemo)(()=>selector ? (0, $82g7P.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $96949a7b8ed8e0eb$var$EMPTY_SELECTOR : $96949a7b8ed8e0eb$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $1oC0p.useState)({})[1];
        const getSnapshot = (0, $1oC0p.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $ixLXc.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $96949a7b8ed8e0eb$export$7c643e1d6648e418(Store) {
    const useHook = $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $96949a7b8ed8e0eb$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("ixLXc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bOBs2"));

});
parcelRegister("bOBs2", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", function () { return $89a16a416bb12add$export$306c0aa65ff9ec16; }, function (v) { return $89a16a416bb12add$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89a16a416bb12add$export$306c0aa65ff9ec16;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $89a16a416bb12add$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $89a16a416bb12add$var$k = "function" === typeof Object.is ? Object.is : $89a16a416bb12add$var$h, $89a16a416bb12add$var$l = $1oC0p.useState, $89a16a416bb12add$var$m = $1oC0p.useEffect, $89a16a416bb12add$var$n = $1oC0p.useLayoutEffect, $89a16a416bb12add$var$p = $1oC0p.useDebugValue;
function $89a16a416bb12add$var$q(a, b) {
    var d = b(), f = $89a16a416bb12add$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $89a16a416bb12add$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $89a16a416bb12add$var$m(function() {
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $89a16a416bb12add$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $89a16a416bb12add$var$p(d);
    return d;
}
function $89a16a416bb12add$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$89a16a416bb12add$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $89a16a416bb12add$var$t(a, b) {
    return b();
}
var $89a16a416bb12add$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $89a16a416bb12add$var$t : $89a16a416bb12add$var$q;
$89a16a416bb12add$export$306c0aa65ff9ec16 = void 0 !== $1oC0p.useSyncExternalStore ? $1oC0p.useSyncExternalStore : $89a16a416bb12add$var$u;

});


parcelRegister("82g7P", function(module, exports) {
$parcel$export(module.exports, "getSelectorInstance", function () { return $5d9b04c7903768eb$export$38d24f3c60944dd5; });

var $lrKV1 = parcelRequire("lrKV1");
function $5d9b04c7903768eb$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $lrKV1.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $lrKV1.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $5d9b04c7903768eb$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $5d9b04c7903768eb$var$cache = new WeakMap();
function $5d9b04c7903768eb$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$5d9b04c7903768eb$var$cache.has(storeState)) $5d9b04c7903768eb$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $5d9b04c7903768eb$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("lrKV1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9d083a877bb8b60$export$2e2bcd8739ae039; });

var $iEBLg = parcelRequire("iEBLg");
function $f9d083a877bb8b60$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $f9d083a877bb8b60$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $iEBLg.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$f9d083a877bb8b60$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $f9d083a877bb8b60$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $f9d083a877bb8b60$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $iEBLg.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("dv8pz", function(module, exports) {
$parcel$export(module.exports, "createStore", function () { return $9d44b1f8bf314c4a$export$f51a9068ac82ea43; });

var $ekT4F = parcelRequire("ekT4F");
function $9d44b1f8bf314c4a$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $ekT4F.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $9d44b1f8bf314c4a$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $9d44b1f8bf314c4a$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("ekT4F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a6fda7907ddc7134$export$2e2bcd8739ae039; });
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a6fda7907ddc7134$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            containerId: containerId,
            actionSubjectId: "pricingPlanCta",
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});

parcelRegister("2tb46", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return (parcelRequire("2ivuE")).ContentBlock; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("2ivuE")).ContentBlock; });

var $2ivuE = parcelRequire("2ivuE");

});
parcelRegister("2ivuE", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return $20f7f25677f4cd05$export$eb38b3b9c7f5f31b; });
/* content-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $20Gca = parcelRequire("20Gca");

var $5qUgh = parcelRequire("5qUgh");

var $6SdoX = parcelRequire("6SdoX");

var $7y4Rg = parcelRequire("7y4Rg");
parcelRequire("jmley");
var $gfjAv = parcelRequire("gfjAv");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $fJP6M = parcelRequire("fJP6M");

var $imIsw = parcelRequire("imIsw");
function $20f7f25677f4cd05$var$getHeaderTag(text, header, lozenge, lozengeAppearance) {
    const headerTag = header ? header : "h3";
    const headerText = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            text,
            lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ahbqftgi _1e0c1o8l"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _s7n4nkob"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                        appearance: lozengeAppearance,
                        children: lozenge
                    })
                })
            })
        ]
    });
    const style = lozenge ? {
        style: {
            display: "inline-block"
        }
    } : null;
    return /*#__PURE__*/ (0, $1oC0p.createElement)(headerTag, style, headerText);
}
/* Gives p tag  so that page structure follows HTML semantic ordering */ function $20f7f25677f4cd05$var$getEyebrowTag(// @ts-ignore
headerType, eyebrowText) {
    return /*#__PURE__*/ (0, $1oC0p.createElement)(`p`, {
        className: "contentBlock-eyebrow"
    }, eyebrowText);
}
function $20f7f25677f4cd05$var$renderLinks({ ctaProps: ctaProps, product: product, edition: edition }) {
    if (!ctaProps) return null;
    let firstLink;
    if ("buttonProps" in ctaProps && "text" in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
        ...ctaProps.buttonProps
    });
    else if ("buttonProps" in ctaProps && "variant" in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
        ...ctaProps.buttonProps
    });
    else if ("primaryLinkProps" in ctaProps && ctaProps.primaryLinkProps) firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        ...ctaProps.primaryLinkProps
    });
    const secondaryLink = "secondaryLinkProps" in ctaProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        ...ctaProps.secondaryLinkProps
    }) : null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
        intentType: "button",
        containerId: "ctaSection",
        edition: edition,
        productKey: product?.key,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: "contentBlock-linkFlex",
            children: [
                firstLink,
                secondaryLink
            ]
        })
    });
}
/**
 * This method retrieves either the eyebrow or icon decoration. If both are present, the icon is returned.
 * @param headerType
 */ const $20f7f25677f4cd05$var$getDecoration = (headerType, eyebrowText, iconName, iconColor, iconSize)=>{
    if (iconName) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Icon), {
        name: iconName,
        color: iconColor,
        size: iconSize
    });
    else if (eyebrowText) return $20f7f25677f4cd05$var$getEyebrowTag(headerType, eyebrowText);
    return null;
};
const $20f7f25677f4cd05$var$getImage = (pictureProps, imageLink, imageAltText, aspectRatio)=>{
    if (pictureProps) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
            ...pictureProps
        })
    });
    else if (imageLink && imageAltText) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Image), {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        })
    });
    else return null;
};
const $20f7f25677f4cd05$var$isHtml = (text)=>{
    return text.startsWith("<") && text.endsWith(">") && text.includes("</");
};
const $20f7f25677f4cd05$export$eb38b3b9c7f5f31b = ({ headerText: headerText, isBannerRichText: isBannerRichText = false, lozenge: lozenge, lozengeAppearance: lozengeAppearance = "inprogress", bodyText: bodyText, bodyComponent: bodyComponent, headerType: headerType = "h3", eyebrowText: eyebrowText, className: className = "", imageLink: imageLink, imageAltText: imageAltText, pictureProps: pictureProps, iconName: iconName, iconColor: iconColor, iconSize: iconSize, ctaProps: ctaProps, aspectRatio: aspectRatio = "1/1", orientation: orientation, cardStyle: cardStyle, isCentered: isCentered = false, horizontalRule: horizontalRule })=>{
    const { product: product, edition: edition } = (0, $7y4Rg.useProductIntent)();
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            isBannerRichText && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && !cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            `content-block ${className}`
        ]),
        style: {
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
        },
        children: [
            $20f7f25677f4cd05$var$getImage(pictureProps, imageLink, imageAltText, aspectRatio),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "text-section",
                children: [
                    headerText && $20f7f25677f4cd05$var$getHeaderTag(headerText, headerType, lozenge, lozengeAppearance),
                    $20f7f25677f4cd05$var$getDecoration(headerType, eyebrowText, iconName, iconColor, iconSize),
                    horizontalRule && /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                        className: (0, $2jatx.default)([
                            "_4t3iyh40 _p12f1fra"
                        ])
                    }),
                    bodyText ? typeof bodyText === "string" && $20f7f25677f4cd05$var$isHtml(bodyText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6SdoX.SanitizedRichText), {
                        innerHTML: bodyText
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "contentBlock-body",
                        children: bodyText
                    }) : null,
                    !bodyText && bodyComponent && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "contentBlock-body",
                        children: bodyComponent
                    }),
                    $20f7f25677f4cd05$var$renderLinks({
                        ctaProps: ctaProps,
                        product: product,
                        edition: edition
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("kaZQn", function(module, exports) {
$parcel$export(module.exports, "TabGroup", function () { return (parcelRequire("2CA9S")).TabGroup; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("2CA9S")).TabGroup; });

var $2CA9S = parcelRequire("2CA9S");

});
parcelRegister("2CA9S", function(module, exports) {
$parcel$export(module.exports, "TabGroup", function () { return $0e9f48a434f4cddf$export$85fd4ed3b8ca1010; });
/* tab-group.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $1ka2O = parcelRequire("1ka2O");
parcelRequire("fl7Kz");
var $92jF6 = parcelRequire("92jF6");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");

var $imIsw = parcelRequire("imIsw");
parcelRequire("8EEDU");
var $hBYvx = parcelRequire("hBYvx");
const $0e9f48a434f4cddf$var$bannerStyle = null;
const $0e9f48a434f4cddf$var$TabGroupStyle = null;
const $0e9f48a434f4cddf$var$quoteSidebar = null;
const $0e9f48a434f4cddf$var$tabPanel = null;
const $0e9f48a434f4cddf$var$contentBlockStyle = null;
const $0e9f48a434f4cddf$var$cardRules = {
    6: 1,
    5: 2,
    4: 2,
    3: 3,
    2: 4
};
const $0e9f48a434f4cddf$var$CardStyleDisplay = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        children: tab.cards.map((card, index)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), {
                ...card,
                aspectRatio: tab.cards.length < 3 ? "16/9" : "3/2"
            }, index);
        })
    });
};
const $0e9f48a434f4cddf$export$625d95e4189a6523 = (props)=>{
    const tabDisplay = props.tab.display;
    let elementToDisplay = null;
    if ("videoProps" in tabDisplay && tabDisplay.videoProps.videoLink?.length) elementToDisplay = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBYvx.Video), {
        ...tabDisplay.videoProps
    });
    else if ("imageProps" in tabDisplay && tabDisplay.imageProps.src?.length && tabDisplay.imageProps.alt?.length) elementToDisplay = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Image), {
        ...tabDisplay.imageProps,
        alt: tabDisplay.imageProps.alt
    });
    else if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(tabDisplay)) elementToDisplay = tabDisplay;
    return elementToDisplay;
};
const $0e9f48a434f4cddf$export$82b8d343c504672 = (props)=>{
    const backgroundImageColor = props.colors?.quoteColor ? `linear-gradient(90deg, transparent, ${props.colors.quoteColor})` : "transparent";
    const quoteWrapperClass = props.isDisplayInSmScreen ? "quote-wrapper isDisplayInSmScreen" : "quote-wrapper";
    const quoteStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_y3gn1e5h _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _ca0q1ul9 _u5f312am _n3td1ul9 _19bvidpf _2rko1ygb _1itk1mlj _urbdidpf _bh33qgp8 _z1c11pz4 _1r1x8n31 _sjb1gktf _1pntidpf _1pugidpf _s3jyidpf _177hangw _1i5midpf _utopidpf _rggridpf _1ie3idpf _14sxoxwj _1uc8angw _sugaglyw _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _p0bo1ule",
            quoteWrapperClass
        ]),
        style: {
            "--_xnxqej": (0, $6ZVlx.default)(backgroundImageColor),
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
        },
        children: [
            props.image ? props.image : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-blurb",
                children: props.quote
            }),
            props.name ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-name",
                children: props.name
            }) : null,
            props.company ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-company",
                children: props.company
            }) : null
        ]
    });
};
const $0e9f48a434f4cddf$var$QuoteTextImage = (tab, colors)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
        layout: "4-8",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h"
                ]),
                children: [
                    tab.headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: tab.headerTextType ?? "h3",
                        iconName: tab.iconName,
                        className: (0, $2jatx.default)([
                            "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3"
                        ])
                    }) : null,
                    tab.quote ? /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$export$82b8d343c504672, {
                        image: tab.quoteImageProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Image), {
                            ...tab.quoteImageProps,
                            alt: tab.quoteImageProps.alt
                        }),
                        quote: tab.quote,
                        name: tab.name,
                        company: tab.company,
                        isDisplayInSmScreen: tab.isDisplayQuoteInSmScreen || false,
                        colors: colors
                    }) : null,
                    tab.ctaProps && tab.ctaProps.primaryLinkProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        "aria-label": tab.ctaProps.primaryLinkProps.ariaLabel,
                        ...tab.ctaProps.primaryLinkProps
                    }) : null
                ]
            }),
            $0e9f48a434f4cddf$export$625d95e4189a6523({
                tab: tab
            })
        ]
    });
};
const $0e9f48a434f4cddf$var$TextImageFullWidth = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            children: [
                tab.headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3",
                        "content-block"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: "h2",
                        isCentered: true
                    })
                }) : null,
                $0e9f48a434f4cddf$export$625d95e4189a6523({
                    tab: tab
                })
            ]
        })
    });
};
const $0e9f48a434f4cddf$var$TabContent = (tabContentType, tab, tabsLength, colors)=>{
    const cardRule = $0e9f48a434f4cddf$var$cardRules[tabsLength];
    switch(tabContentType){
        case "custom":
            if (!("component" in tab)) throw new Error("Must provide a `customComponent` JSX node");
            return tab.component;
        case "cards":
            if (!("cards" in tab)) throw new Error("Must provide an array of card values in the `cards` tab prop");
            else if (tab.cards.length > cardRule) throw new Error(`For a group of ${tabsLength} tabs, no more than ${cardRule} cards per tab`);
            return $0e9f48a434f4cddf$var$CardStyleDisplay(tab);
        case "quoteTextImage":
            if (!("display" in tab)) throw new Error("Please provide image or video props");
            return $0e9f48a434f4cddf$var$QuoteTextImage(tab, colors);
        case "textImageFullWidth":
            if (!("display" in tab)) throw new Error("Please provide image or video props");
            return $0e9f48a434f4cddf$var$TextImageFullWidth(tab);
        default:
            return null;
    }
};
const $0e9f48a434f4cddf$var$updateURL = (tabId)=>{
    const newParams = new URLSearchParams(window.location.search);
    if (tabId) {
        newParams.set("tab", tabId);
        window.history.pushState({}, "", `?${newParams.toString()}`);
    }
};
const $0e9f48a434f4cddf$var$getTabStyle = (colors, isActive)=>{
    if (isActive) return {
        backgroundColor: colors?.activeBG || (0, $kbpa7.wacToken)("color.extended.blue200"),
        color: colors?.activeText || (0, $kbpa7.wacToken)("color.extended.blue1000"),
        borderColor: colors?.activeBG || (0, $kbpa7.wacToken)("color.extended.blue200"),
        hoverBG: colors?.activeBG || (0, $kbpa7.wacToken)("color.extended.blue200"),
        hoverText: colors?.activeText || (0, $kbpa7.wacToken)("color.extended.blue1000"),
        activeBGColor: colors?.activeBG || (0, $kbpa7.wacToken)("color.extended.blue200"),
        hoverBGColor: colors?.activeBG || (0, $kbpa7.wacToken)("color.extended.blue200")
    };
    return {
        backgroundColor: colors?.defaultBG || (0, $kbpa7.wacToken)("color.neutral.light100"),
        color: colors?.defaultText || (0, $kbpa7.wacToken)("color.extended.blue1000"),
        borderColor: "transparent",
        hoverBG: colors?.hoverBG || (0, $kbpa7.wacToken)("color.neutral.light200"),
        hoverText: colors?.hoverText || (0, $kbpa7.wacToken)("color.extended.blue1000"),
        activeBGColor: colors?.activeBG || (0, $kbpa7.wacToken)("color.extended.blue200"),
        hoverBGColor: colors?.hoverBG || (0, $kbpa7.wacToken)("color.neutral.light200")
    };
};
const $0e9f48a434f4cddf$var$TabGroupInner = ({ index: index, currentTab: currentTab, tab: tab, colors: colors, dataProductKey: dataProductKey, onDesktopClickHandler: onDesktopClickHandler, setCurrentTab: setCurrentTab })=>{
    const isActive = index === currentTab;
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        role: "tab",
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-controls": tab.id,
        id: tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-label-english": tab.dataLabelEnglish,
        "data-product-key": dataProductKey,
        onClick: (event)=>{
            setCurrentTab(index);
            $0e9f48a434f4cddf$var$updateURL(tab.id);
            if (onDesktopClickHandler) onDesktopClickHandler(event);
        },
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: [
            tab.iconBefore ?? tab.iconBefore,
            tab.isForceDisplayTextLabelOnPill ? tab.textLabel : tab.elementLabel ? tab.elementLabel : "headerText" in tab ? tab.headerText : tab.textLabel
        ]
    }, `tab-${index}-${tab.id}`);
};
const $0e9f48a434f4cddf$var$TabOption = ({ index: index, currentTab: currentTab, tab: tab, colors: colors, dataProductKey: dataProductKey })=>{
    const isActive = index === currentTab;
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
        "data-index": index,
        "data-id": tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-product-key": dataProductKey,
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-describedby": `tab-${tab.id}`,
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: tab.isForceDisplayTextLabelOnPill ? tab.textLabel : tab.elementLabel ? tab.elementLabel : "headerText" in tab ? tab.headerText : tab.textLabel
    }, `option-${index}-${tab.id}`);
};
const $0e9f48a434f4cddf$var$TabSelect = ({ id: id, currentTab: currentTab, tabs: tabs, colors: colors, updateURL: updateURL, onMobileChangeHandler: onMobileChangeHandler, setCurrentTab: setCurrentTab, dataProductKey: dataProductKey })=>{
    const isActive = true; // Always active for TabSelect
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    const handleChange = (event)=>{
        const selectedIndex = event?.target?.selectedOptions[0]?.dataset["index"];
        const selectedId = event?.target?.selectedOptions[0]?.dataset["id"];
        setCurrentTab(Number(selectedIndex));
        updateURL(selectedId);
        if (onMobileChangeHandler) onMobileChangeHandler(event);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("select", {
        id: id,
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn",
            "select"
        ]),
        value: tabs[currentTab]?.textLabel || tabs[0]?.textLabel,
        onChange: handleChange,
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: tabs.map((tab, index)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabOption, {
                index: index,
                tab: tab,
                colors: colors,
                dataProductKey: dataProductKey,
                currentTab: currentTab
            }, `option-${index}-${tab.id}`);
        })
    });
};
const $0e9f48a434f4cddf$export$85fd4ed3b8ca1010 = (props)=>{
    const { tabContentType: tabContentType, tabs: tabs, colors: colors, id: id, label: label, dataProductKey: dataProductKey, onDesktopClickHandler: onDesktopClickHandler, onMobileChangeHandler: onMobileChangeHandler, banner: banner } = props;
    const location = (0, $1ka2O.useLocation)();
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(()=>{
        const params = new URLSearchParams(location.search ?? window.location.search);
        const paramID = params.get("tab");
        const matchingTab = tabs.findIndex((tab)=>{
            return tab.id === paramID;
        });
        if (matchingTab >= 0) return matchingTab;
        return 0;
    });
    if (!id || !label) throw new Error('"id" and "label" props are required for accessibility!');
    if (tabs.length > 6 || tabs.length < 1) throw new Error("Must have a minimum of 1 and a maximum of 6 tabs per group!");
    const tabsMap = tabs.reduce(function(map, obj, index) {
        map[index] = obj;
        return map;
    }, {});
    // eslint-disable-next-line react/no-unstable-nested-components
    const MobileSelect = ()=>{
        const selectContainerColor = colors?.activeText ? colors.activeText : (0, $kbpa7.wacToken)("color.extended.blue1000");
        const selectContainerStyles = null;
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bah1h6o _suga1txw _181nglyw _12xhh2mm _d7qx1osq _c2wd1pna _qj6jstnw _14z6gktf _7x8didpf _jm44idpf _wppf1wug _6mc91wug _1yyz1wug _c8mx1wug _1vd7171q",
                "select-container"
            ]),
            style: {
                "--_1uth3n3": (0, $6ZVlx.default)(selectContainerColor)
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "select-container-inner",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                        htmlFor: id,
                        "aria-label": label,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabSelect, {
                            id: id,
                            currentTab: currentTab,
                            tabs: tabs,
                            colors: colors,
                            updateURL: $0e9f48a434f4cddf$var$updateURL,
                            setCurrentTab: setCurrentTab,
                            dataProductKey: dataProductKey,
                            onMobileChangeHandler: onMobileChangeHandler
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "15",
                        height: "8",
                        viewBox: "0 0 15 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M1.5 1L7.5 7L13.5 1",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq",
            "tab-group"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tablist",
                className: (0, $2jatx.default)([
                    "_sugaglyw _1cj31txw _196r1h6o _270t1g80 _wmdl7vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: "tab-group-inner",
                        children: [
                            tabs.map((tab, index)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabGroupInner, {
                                    tab: tab,
                                    index: index,
                                    colors: colors,
                                    dataProductKey: dataProductKey,
                                    onDesktopClickHandler: onDesktopClickHandler,
                                    setCurrentTab: setCurrentTab,
                                    currentTab: currentTab
                                }, `tab-${index}-${tab.id}`);
                            }),
                            banner && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1crf _syazcd5j _11q717la _y3gn1h6o _1bsb1osq _1dyzt94y _k48pni7l _vwz4f6fq _ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _1p1dangw"
                                ]),
                                style: {
                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                },
                                children: banner
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)(MobileSelect, {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "tab-panels",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkgktf _2hwx1wug _otyridpf _18u01wug _mderglyw",
                        "tab-panel"
                    ]),
                    "aria-hidden": false,
                    id: `tab-${tabsMap[currentTab]?.id}`,
                    children: $0e9f48a434f4cddf$var$TabContent(tabContentType, tabsMap[currentTab], tabs.length, colors)
                }, `tabpanel-${currentTab}-${tabsMap[currentTab]?.id}`)
            })
        ]
    });
};

});
parcelRegister("fl7Kz", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("92jF6")).Card; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("92jF6")).Card; });

var $92jF6 = parcelRequire("92jF6");

});
parcelRegister("92jF6", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b6adcd00aae9005f$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");
const $b6adcd00aae9005f$var$containerStyles = null;
const $b6adcd00aae9005f$var$contentBlockStyles = null;
const $b6adcd00aae9005f$var$barStyles = null;
const $b6adcd00aae9005f$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor ?? "#ffffff";
    const cardBackTextColor = textColor ?? "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor ?? "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $6ZVlx.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $6ZVlx.default)(cardBackTextColor),
            "--_8vvi5m": (0, $6ZVlx.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2jatx.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("8EEDU", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("hBYvx")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("hBYvx")).Video; });

var $hBYvx = parcelRequire("hBYvx");

});
parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return {
        maxWidth: "100%",
        ...aspectRatioCSS
    };
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});




parcelRegister("1RK9J", function(module, exports) {
$parcel$export(module.exports, "getFreePriceCalc", function () { return $9f9b50f36097439e$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $9f9b50f36097439e$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $9f9b50f36097439e$export$2bd1dff4b72a4894; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");
const $9f9b50f36097439e$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ieLA0.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: "0",
                formattedUnitsAvailableInTier: "0",
                formattedUnitLimitLower: "0",
                formattedUnitLimitUpper: "0",
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $9f9b50f36097439e$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $1oC0p.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $hrGO1.SpecialPlanNames).STANDARD ? "" : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $9f9b50f36097439e$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ieLA0", function(module, exports) {
$parcel$export(module.exports, "getFormattedPrice", function () { return $db8d9502e3c15040$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $db8d9502e3c15040$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $db8d9502e3c15040$export$4f6f7f43804883a5; });
const $db8d9502e3c15040$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $db8d9502e3c15040$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === "JPY";
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? "ja-JP" : "en-US", {
        style: "currency",
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $db8d9502e3c15040$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, false);
const $db8d9502e3c15040$export$716b461c5fe22c57 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, true);
const $db8d9502e3c15040$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("69Lp1", function(module, exports) {
$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $eeff08f2d55148ea$export$99b3bd15b49bca3d; });

var $6AKYt = parcelRequire("6AKYt");
const $eeff08f2d55148ea$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering?.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $6AKYt.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === "MONTHLY" && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === "ANNUAL" && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === "MONTHLY" && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === "ANNUAL" && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("6AKYt", function(module, exports) {
$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $ba494f9c4080e515$export$1fb00d50ed2ce89c; });

var $hrGO1 = parcelRequire("hrGO1");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $ba494f9c4080e515$var$formatCentsToDollars = (value, currency)=>{
    if (currency === "USD" && value) return value / 100;
    return value;
};
const $ba494f9c4080e515$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $hrGO1.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $ba494f9c4080e515$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $ba494f9c4080e515$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        "MONTH",
        "YEAR"
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === "COMMERCIAL" && pricingPlan.activatedWithReason === "DEFAULT_PRICING" && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $ba494f9c4080e515$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("8dsKS", function(module, exports) {
$parcel$export(module.exports, "calculatePrice", function () { return $9c8fafac440a889f$export$8f857d3e1dbdf9cf; });

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $cuq2S = parcelRequire("cuq2S");

var $fmcUV = parcelRequire("fmcUV");
const $9c8fafac440a889f$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $9c8fafac440a889f$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = "en-US") {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        return (a.unitLimitLower ?? 0) - (b.unitLimitLower ?? 0);
    });
    let matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === "MONTHLY" || tierPricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT ? (0, $fmcUV.default) : (0, $cuq2S.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $fmcUV.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = finalTier?.unitLimitUpper || 0;
        matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $cuq2S.default);
    }
    const fmtUnit = (amount)=>(0, $ieLA0.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ieLA0.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("cuq2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20e5665ddc9d914c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $20e5665ddc9d914c$export$3a875854e1248ca4; });

var $8q2jX = parcelRequire("8q2jX");
function $20e5665ddc9d914c$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $20e5665ddc9d914c$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("8q2jX", function(module, exports) {
$parcel$export(module.exports, "getLocalUnitPrice", function () { return $032de19fb775a510$export$e4a3f0ac75d6f09; });
const $032de19fb775a510$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>prices.find(({ currency: currency })=>currency === currencyISOCode)?.unitPrice || 0;

});


parcelRegister("fmcUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e064390e0d1f8ae6$export$2e2bcd8739ae039; });

var $hrGO1 = parcelRequire("hrGO1");

var $8q2jX = parcelRequire("8q2jX");
function $e064390e0d1f8ae6$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: tiers[0]?.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});



parcelRegister("aSr2F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7eb3ec80aea1436f$var$_react = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7eb3ec80aea1436f$var$_baseNew = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $7eb3ec80aea1436f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7eb3ec80aea1436f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7eb3ec80aea1436f$var$_react.default.createElement($7eb3ec80aea1436f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$7eb3ec80aea1436f$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $7eb3ec80aea1436f$var$_default = module.exports.default = $7eb3ec80aea1436f$var$CheckMarkIcon;

});

parcelRegister("dEFIL", function(module, exports) {
$parcel$export(module.exports, "EnhancedBannerAlert", function () { return $41ab4e6d9e0b9eaf$export$e2bb4f4abc9a31da; });
/* enhanced-banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $2gCne = parcelRequire("2gCne");
const $41ab4e6d9e0b9eaf$export$e2bb4f4abc9a31da = (bannerInfo)=>{
    const bannerStorageItem = `BannerAlert_dismiss-${bannerInfo.identifier}`;
    const closeIconDataEventProps = {
        "data-product-key": bannerInfo.productKey,
        "data-event-component": "button",
        "data-event-container": "announcementBanner",
        "data-event": "clicked",
        "data-label": "Close",
        "data-label-english": "Close"
    };
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    const mobileClass = bannerInfo.mobileTextThirdScreen ? "three-screen" : "two-screen";
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    let mobileProps = bannerInfo.imageProps;
    if (bannerInfo.imageMobileProps && bannerInfo.imageMobileProps.src) mobileProps = bannerInfo.imageMobileProps;
    const bannerBgPreset = bannerInfo.backgroundPreset ? `bg-${bannerInfo.backgroundPreset}` : `bg-none`;
    const bannerType = bannerInfo.bannerType ? `banner-type-${bannerInfo.bannerType}` : "banner-type-default";
    const bgLinkColor = bannerInfo.backgroundPreset === "gwp-5090-banners" ? "bgBlackBlue" : "bgWhite";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1ybm _kqswh2mm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _85i5yh40 _189eh5ge _1dqonqa1 _5pio1p9q _nzmgglyw _1auo1lef _21w0idpf _15641crf _s4s5idpf _1qlo1crf _7j8l1lk2 _jw2n1wug _1yvc1wug _19z9gktf _nue91vuk _1lrfidpf _pytjidpf _smywidpf _4tf1idpf _1dkqidpf _1i8zidpf _1twsidpf _c7u0idpf _1u1bjk2v _1876mq8p _gsz9mgnk _evayglyw _lhr7161t _1cmq12iu _88w1cd5j _5vmz1ejb _3kek1ejb _190eni2e _wb1217a9 _vb1gvgh6 _1at2oyge _49yzdf70 _cfy01ule _18901k92 _1aavidpf _72q2idpf _11sc1y44 _i4q0idpf _n8ff1cby _qho21j28 _1w7d1hlo _sqps1ybm _iawm1hlo _abydglyw _6c4acd5j _udn3glyw _2fl2idpf _1kn8cd5j _1vxmcd5j _1mafcd5j _waepcd5j _1y8xcd5j _1ur0cd5j _ojfccd5j _1yaacd5j _11zscd5j _1s05cd5j _6rr71ybm _fsy11ybm _sx881ybm _1s7h1ybm _1gudcd5j _1m8acd5j _1lcvcd5j _v05mcd5j _lkhdni7l _pu49ni7l _162fni7l _19ycni7l _102q1hbo _2utfmgnk _1vm51dlf _1e74altx _1o3a1izt _1blmu4dp _1si213i1 _1k051ms4 _1yip1f51 _6zpp1f51 _eyt5xchc _nxj7u58z _7w4fcd5j _xfs2idpf _17es1rga _lfur1dgx _1t0kmgnk _ejrwidpf _1m4lanty _7ax8uuw1 _1ww71tcg _cfnoftgi _ogm61et3 _ve7k1ule _1mt7kfja _76j711ux _1dxgidpf _1i4jt1wm _ne8lqiko _1it7ys9h _umq2mgvx _16471dnu _1uhmmr2s _6cysidpf _yo8p1tcg _17pqqslr _ti1kp3fh _onmtn7od",
                `${bannerBgPreset} ${bannerType}`
            ]),
            "data-dismissed": isHidden ? "true" : undefined,
            "data-testid": "banner-alert-container",
            style: {
                ...bannerInfo.customCSS,
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
                "--_e0fbx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple500")),
                "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900")),
                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700")),
                "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                "--_jxcf9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.saffron")),
                "--_b9m2cq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.green")),
                "--_1lpv4ka": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.lime")),
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0c1txw _2lx2vrvc _zulpzwfg _kqswh2mm _6rth12gs _sugaglyw",
                                    "desktop-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                            image: {
                                                width: 209,
                                                ...bannerInfo.imageProps
                                            },
                                            style: {
                                                maxWidth: "100%",
                                                height: "auto"
                                            },
                                            forceEagerLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_191w1xtt _4t3i1osq _sugaglyw",
                                            "line"
                                        ]),
                                        style: {
                                            "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1bsb1osq _1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpzwfg _na0i1bp4 _dh1a1y6m _2osn14y2 _ag851h6o _10ca1q9c"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                    "body-md"
                                                ]),
                                                children: bannerInfo.text
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                bgColor: bgLinkColor,
                                                text: bannerInfo.linkText,
                                                "aria-label": bannerInfo.linkText,
                                                href: bannerInfo.linkUrl,
                                                type: "primary",
                                                dataEventProps: bannerInfo.dataEventProps
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0cglyw _2lx21bp4 _4cvr1h6o _suga1txw",
                                    "mobile-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _p12f1osq _18zr7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                        image: {
                                                            width: 180,
                                                            ...mobileProps
                                                        },
                                                        style: {
                                                            maxWidth: "100%",
                                                            height: "auto"
                                                        },
                                                        forceEagerLoad: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileText
                                                })
                                            }),
                                            bannerInfo.mobileTextThirdScreen && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju251onc",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileTextThirdScreen
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                        bgColor: bgLinkColor,
                                        text: bannerInfo.linkText,
                                        "aria-label": bannerInfo.linkText,
                                        href: bannerInfo.linkUrl,
                                        type: "primary",
                                        dataEventProps: bannerInfo.dataEventProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                bannerInfo.bannerType !== "lifted" && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    className: (0, $2jatx.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _rjxpidpf _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz",
                        `close-button-symbol`
                    ]),
                    "data-testid": "close-button",
                    "aria-label": "Close",
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, "1");
                    },
                    ...closeIconDataEventProps,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Cross), {
                        size: "24"
                    })
                })
            ]
        })
    });
};
const $41ab4e6d9e0b9eaf$var$scrollUpTwoScreens = null;
const $41ab4e6d9e0b9eaf$var$scrollUpThreeScreens = null;
const $41ab4e6d9e0b9eaf$var$desktopContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$mobileContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$desktopLogoStyles = null;
const $41ab4e6d9e0b9eaf$var$marqueeContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItemStyle = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem1Styles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem2Styles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem3Styles = null;
const $41ab4e6d9e0b9eaf$var$containerStyles = null;
const $41ab4e6d9e0b9eaf$var$contentStyles = null;
const $41ab4e6d9e0b9eaf$var$pStyle = null;
const $41ab4e6d9e0b9eaf$var$lineStyle = null;
const $41ab4e6d9e0b9eaf$var$closeStyles = null;

});

parcelRegister("a8Jhy", function(module, exports) {
$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return $15488782d37e40da$export$89ad02e8b5e6fb05; });
$parcel$export(module.exports, "Adg4SectionDivider", function () { return $15488782d37e40da$export$2446497a3d298a13; });
/* section-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
var $15488782d37e40da$export$89ad02e8b5e6fb05 = /*#__PURE__*/ function(SECTION_DIVIDER_VARIATION) {
    SECTION_DIVIDER_VARIATION["NORMAL"] = "normal";
    SECTION_DIVIDER_VARIATION["REVERSE"] = "reverse";
    SECTION_DIVIDER_VARIATION["FLIP"] = "flip";
    SECTION_DIVIDER_VARIATION["REVERSE_FLIP"] = "reverse-flip";
    return SECTION_DIVIDER_VARIATION;
}({});
const $15488782d37e40da$export$2446497a3d298a13 = ({ bgColor: bgColor = "#1868DB", colorAgainst: colorAgainst = "#FFF", desktopHeight: desktopHeight = 120, tabletHeight: tabletHeight = 80, mobileHeight: mobileHeight = 60, variation: variation })=>{
    const sectionDividerStyles = null;
    const colorBehindDividerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1tls"
        ]),
        style: {
            "--_1gwlqo7": (0, $6ZVlx.default)(colorAgainst)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_mkrzsrs8 _11q7bs0x _4t3iepwt _1vkh1mjl _tnruenus",
                variation === "reverse" && "_mkrz1fra",
                variation === "flip" && "_mkrz1n6g",
                variation === "reverse-flip" && "_mkrz1vud"
            ]),
            style: {
                "--_1w9snyi": (0, $6ZVlx.default)(bgColor),
                "--_qqqbix": (0, $6ZVlx.default)(desktopHeight, "px"),
                "--_1ly4yra": (0, $6ZVlx.default)(tabletHeight, "px"),
                "--_klg1fm": (0, $6ZVlx.default)(mobileHeight, "px")
            }
        })
    });
};

});

parcelRegister("k1xqL", function(module, exports) {
$parcel$export(module.exports, "Adg4SectionDivider", function () { return (parcelRequire("a8Jhy")).Adg4SectionDivider; });
$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return (parcelRequire("a8Jhy")).SECTION_DIVIDER_VARIATION; });
parcelRequire("a8Jhy");

});

parcelRegister("53RJr", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("jVACb")).BannerAlert; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("jVACb")).BannerAlert; });

var $jVACb = parcelRequire("jVACb");

});
parcelRegister("jVACb", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return $8326461e03189c88$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");

var $2gCne = parcelRequire("2gCne");
const $8326461e03189c88$var$containerStyles = null;
const $8326461e03189c88$var$contentStyles = null;
const $8326461e03189c88$var$closeIconStyles = null;
const $8326461e03189c88$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $8e22h.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $2jatx.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $2jatx.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("lzfAX", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return (parcelRequire("9D78w")).ProductNavBar; });
$parcel$export(module.exports, "ProductNavLink", function () { return (parcelRequire("5xvRI")).ProductNavLink; });

var $9D78w = parcelRequire("9D78w");

var $5xvRI = parcelRequire("5xvRI");

var $7z8Jg = parcelRequire("7z8Jg");

});
parcelRegister("9D78w", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return $b545d9db2ee66805$export$6bfdc568e00f9e3d; });
/* product-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $5RBBI = parcelRequire("5RBBI");

var $kbpa7 = parcelRequire("kbpa7");

var $aHkxS = parcelRequire("aHkxS");

var $jMhSx = parcelRequire("jMhSx");

var $2ve7k = parcelRequire("2ve7k");

var $fJP6M = parcelRequire("fJP6M");
const $b545d9db2ee66805$var$navigationWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarCss = null;
const $b545d9db2ee66805$var$logoAndLinksCss = null;
const $b545d9db2ee66805$var$keyframeChevron = null;
const $b545d9db2ee66805$var$removeKeyframeChevron = null;
const $b545d9db2ee66805$var$dropdownSlideInAnimation = null;
const $b545d9db2ee66805$var$dropdownSlideOutAnimation = null;
const $b545d9db2ee66805$var$listItemCss = null;
const $b545d9db2ee66805$var$buttonWrapper = null;
const $b545d9db2ee66805$var$linkAndButtonWrapper = null;
const $b545d9db2ee66805$var$buttonStyle = null;
const $b545d9db2ee66805$var$contactSalesButtonStyle = null;
const $b545d9db2ee66805$var$logoDimensions = {
    confluence: 157,
    jiraservicemanagement: 280,
    jira: 80,
    jirasoftware: 80
};
const $b545d9db2ee66805$export$6bfdc568e00f9e3d = (props)=>{
    const intl = (0, $8e22h.default)();
    const isShowFreeHrefButton = props.showFreeHrefButton ?? true;
    const isShowContactSalesHrefButton = props.showContactSalesHrefButton ?? false;
    const showTextWithoutLogo = props.showTextWithoutLogo ?? false;
    const [activeDropdown, setActive] = (0, $1oC0p.useState)(null);
    const [buttonType, setButtonType] = (0, $1oC0p.useState)("secondary");
    const location = (0, $2ve7k.useLocation)();
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        activeDropdown,
        props.showFreeHrefButton
    ]);
    const handleScroll = ()=>{
        setButtonType(window.scrollY > 56 ? "primary" : "secondary");
    };
    const getItFreeText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    const getContactSalesText = intl.formatMessage({
        id: "productNavBar.contact-sales-button",
        defaultMessage: "Contact sales"
    });
    const dropdownCss = [
        null,
        !activeDropdown && null,
        activeDropdown && null
    ];
    const mobileCategoriesWrapperCss = [
        null,
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    const renderSelectionItems = (isMobile)=>{
        const categoriesWrapperCss = [
            !isMobile && null
        ];
        return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                !isMobile && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _18s8119w _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mjbglyw"
            ]),
            children: props.children && (0, $1oC0p.Children).map(props.children, (child, index)=>child ? /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                        isSelected: child.props.isSelected || (0, $2ve7k.isEqualUnlocalizedPathname)(child.props.href, location.pathname),
                        isMobile: isMobile
                    })
                }, index) : null)
        });
    };
    const renderDropdownButton = ()=>{
        if (props.children) return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: ()=>setActive(!activeDropdown),
            className: (0, $2jatx.default)([
                "_1e0cglyw _80omtlke _bfhk1j28 _19itglyw _syaz1ep1 _1q5112x7 _1752xy5q _w8l5xy5q _48hmq7pw _1mjb1ule",
                !activeDropdown && "",
                !activeDropdown && "_1px1k4ed",
                activeDropdown && "",
                activeDropdown && "_1px1qbue"
            ]),
            style: {
                "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                label: ""
            })
        });
        return null;
    };
    const logoWrapperCss = [
        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === "" && null,
        null
    ];
    const textWrapperCss = null;
    const textCss = null;
    const boxShadowCss = props.productName !== "confluence" && props.productName !== "jira" && null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1bsb1osq _152tidpf _1pby11wp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1y6m _11q7cd5j _1e0c1txw _2lx2vrvc _1bah1h6o",
                    props.productName !== "confluence" && props.productName !== "jira" && "_16qsg1bn"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _165t1wqb _10jx1fra _1yag119w _1vkh8vuz _13zno7np _em6nh2mm _4ik0kb7n _1gdevrvc _navj1g80 _tnru1wug _15tx119w",
                        "productNavBar"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw"
                            ]),
                            children: [
                                showTextWithoutLogo ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        "_4t3i12am _syazvejh _4cvr1h6o _1e0c1txw _2lx2vrvc"
                                    ]),
                                    style: {
                                        "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb166g _k48pbfng"
                                        ]),
                                        children: props.ariaLabel
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === "" && "_1bsb2lms",
                                        "_4cvr1h6o _1e0c1txw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                                        brand: props.productName,
                                        type: "logo",
                                        appearance: "brand",
                                        height: "48",
                                        width: $b545d9db2ee66805$var$logoDimensions[props.productName]
                                    })
                                }),
                                renderDropdownButton(),
                                renderSelectionItems(false)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: [
                                isShowFreeHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _ca0qo7ao _u5f3idpf _n3tdo7ao _19bvidpf",
                                        "showFreeHrefButton"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                                        text: getItFreeText,
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getItFreeText,
                                        dataEventProps: {
                                            "data-event-container": "navbar",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-label": getItFreeText,
                                            "data-label-english": "Get it free",
                                            "data-product-key": props.dataProductKey,
                                            "data-track-event": `${props.dataProductKey}.get-it-free-button-clicked`
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ])
                                    })
                                }),
                                isShowContactSalesHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "showContactSalesHrefButton",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                                        text: getContactSalesText,
                                        color: "yellow",
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getContactSalesText,
                                        dataEventProps: {
                                            "data-event-container": "navbar",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-label": getContactSalesText,
                                            "data-product-key": props.dataProductKey
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _11q71qli _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ]),
                                        style: {
                                            "--_u1whbc": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.saffron400"))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _bfhk1rga _179r1k0a _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    activeDropdown === null && "_1h6du4vp _mqm21k0a",
                    activeDropdown && "",
                    activeDropdown && "_c71l8stt _y44v18yz _1h6dvejh _mqm2yzqy",
                    !activeDropdown && "",
                    !activeDropdown && "_y44v1eb4 _1h6du4vp _mqm2yzqy",
                    "mobileCategoriesWrapper"
                ]),
                style: {
                    "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
                    "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000")),
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                },
                children: renderSelectionItems(true)
            })
        ]
    });
};
var $b545d9db2ee66805$export$2e2bcd8739ae039 = $b545d9db2ee66805$export$6bfdc568e00f9e3d;

});

parcelRegister("5xvRI", function(module, exports) {
$parcel$export(module.exports, "ProductNavLink", function () { return $3331e0af5dabfddc$export$df4f9873dfab197b; });
/* product-navlink.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $3331e0af5dabfddc$var$linkStyle = null;
const $3331e0af5dabfddc$export$df4f9873dfab197b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_18ywh2mm _9c4j1l7b _1hw71ule _19tb1j6v _1la1kb7n _8bvm119w _i7kgzu5n _5i9qrbzz _1x5rusvi _1qxa59zy _1unt1r31 _jsn2glyw _1b4hnqa1 _1mcc10vn _1ry4oelr _906b1osq _1nzh1xjh _1euc119w _3uyxrbzz _1u7j19bv _c12j1r31 _1udz8stv _4ba5nqa1 _1u6y1r31 _14ifglyw _f3mxnqa1 _1sinoelr _jhsausvi _c3hm4m1f _1ohxni7l _4mi7nclz _b4f8nclz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            className: props.isSelected ? "selected" : "",
            href: props.href,
            ...props.dataEventProps,
            "data-label": props.label,
            children: props.label
        })
    });
};
var $3331e0af5dabfddc$export$2e2bcd8739ae039 = $3331e0af5dabfddc$export$df4f9873dfab197b;

});

parcelRegister("7z8Jg", function(module, exports) {
/* product-navdropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $92PV0 = parcelRequire("92PV0");

var $gw3Bt = parcelRequire("gw3Bt");
const $96f8f1342a672b0a$var$parentItemStyle = null;
const $96f8f1342a672b0a$var$dropdownStyle = null;
const $96f8f1342a672b0a$var$listStyle = null;
const $96f8f1342a672b0a$var$headerStyle = null;
const $96f8f1342a672b0a$var$listItemStyle = null;
const $96f8f1342a672b0a$var$linkStyle = null;
const $96f8f1342a672b0a$var$mobileDropdownStyle = null;
const $96f8f1342a672b0a$export$39cc2d4a9bc14e7d = ({ label: label, isMobile: isMobile = false, groups: groups, dataProductKey: dataProductKey = "jiraSoftware" })=>{
    const [isDropdownVisible, setDropdownVisible] = (0, $1oC0p.useState)(false);
    const [isMobileDropdownVisible, setMobileDropdownVisible] = (0, $1oC0p.useState)(false);
    const dropdownRef = (0, $1oC0p.useRef)(null);
    (0, $gw3Bt.useOutsideEvent)(dropdownRef, "click", ()=>setDropdownVisible(false));
    (0, $gw3Bt.useOutsideEvent)(dropdownRef, "focusin", ()=>setDropdownVisible(false));
    const innerRef = (0, $1oC0p.useRef)(null);
    (0, $gw3Bt.useOutsideEvent)(innerRef, "click", ()=>setDropdownVisible(false));
    (0, $gw3Bt.useOutsideEvent)(innerRef, "focusin", ()=>setDropdownVisible(false));
    const handleTouchEnd = (event)=>{
        event.preventDefault();
        setMobileDropdownVisible((state)=>!state);
    };
    const handleClick = ()=>setMobileDropdownVisible((state)=>!state);
    const handleMouseEnter = ()=>setDropdownVisible(true);
    const handleMouseLeave = ()=>setDropdownVisible(false);
    const handleKeyUp = (event)=>{
        if (event.key === "Enter") setDropdownVisible((state)=>!state);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (isDropdownVisible || isMobileDropdownVisible) (0, $92PV0.Tracking).autoTrackLinks(true);
    }, [
        isDropdownVisible,
        isMobileDropdownVisible
    ]);
    const renderGroups = (dataProductKey)=>groups?.map(({ header: header, items: items, hideHeader: hideHeader }, groupIndex)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h5", {
                            className: (0, $2jatx.default)([
                                "_1e0c1ule _ca0q1y44 _u5f31ul9 _n3td1y44 _19bv1ul9 _o5721q9c _4bfu1r31 _1hmsglyw _ajmmnqa1 _1wyb1j6v _syaz1bqd _19pk1crf _2hwxidpf _otyridpf _18u0idpf _1p1dangw _k48p1fw0 _vwz410nf _1dyzt94y"
                            ]),
                            children: header
                        })
                    }),
                    items.map(({ label: itemLabel, labelEnglish: itemLabelEnglish, href: href, isSelected: isSelected }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1pfh1crf _6rth1crf _1ohxni7l _ym7n1bqd _zgzju67f"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1j6v _vwz4851k _1e0c1ule _ca0q1y44 _u5f31ul9 _n3td1y44 _19bv1ul9 _o5721q9c _4bfu1r31 _1hmsglyw _ajmmnqa1 _syazrbzz _1l4er3uz _irr3rbzz _30l3u67f",
                                    isSelected ? "selected" : ""
                                ]),
                                href: href,
                                id: `dropdown-${label.toLowerCase()}-${index}`,
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "navbarDropdownLink",
                                "data-product-key": dataProductKey,
                                "data-label": itemLabel,
                                "data-label-english": itemLabelEnglish,
                                children: itemLabel
                            })
                        }, `${itemLabel}-${index}`))
                ]
            }, `${header}-${groupIndex}`));
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: dropdownRef,
                onTouchEnd: handleTouchEnd,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onClick: handleClick,
                onFocus: handleMouseEnter,
                onKeyUp: handleKeyUp,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        id: `dropdown-${label.toLowerCase()}`,
                        href: "#",
                        "data-event": "clicked",
                        "data-label": label,
                        "data-event-component": "linkButton",
                        "data-event-container": "navbarDropdown",
                        "data-product-key": dataProductKey,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _152t1l7b _1e0c1txw _4cvr1h6o _1wyb1j6v _vwz4kb7n _syazrbzz _30l3oelr _1b75y6p2 _rtay4h09 _16m51fys _1nbi1f51 _1l3vb3bt _1m5l1o8l _1t6ii2wt _1k6s1crf _1dqh1crf _d6wu1vv5 _1j5e4h09 _1y3ib3bt _1mhxi2wt _1nwwi2wt _fl6h1axk _l23r1axk _u5pl1kw7 _ytugq07a _gs6s19bv _1t7gbf4l _7wutjyd4 _k11laqso _1vie3iz4 _ue5g119w _1yagzu5n _1gs5usvi _v9tz59zy _1s4p1osq _6ssj1xjh _17p3119w _1a5h19bv",
                            isMobileDropdownVisible ? "open" : ""
                        ]),
                        children: label
                    }),
                    !isMobile && isDropdownVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: innerRef,
                        className: (0, $2jatx.default)([
                            "_bfhku67f _19itulfz _2rko1y44 _16qsg1bn _kqswstnw _152t1osq _1e021ssb _t9ec1e6q _1pbyzo7u"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_qtt8glyw _bozgidpf _1q5114y2 _85i514y2 _kqswh2mm _1pbykb7n _1rusu67f _iajmidpf _1g0vidpf _1fkr1osq _z5wt1ssb _14h81fby _1kt9f705 _kfgtidpf _1mp4idpf _1cs8stnw _dsq4glyw _7dwzzr6s _15l21hqi _1bqq1mrw _1guf1osq _g0nf1ssb _eq43105i _aetrf705 _1qdgidpf _z0aiidpf _18postnw _11fnglyw _1cteu67f _clh3zr6s"
                            ]),
                            children: renderGroups(dataProductKey)
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: isMobile && isMobileDropdownVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: innerRef,
                    className: (0, $2jatx.default)([
                        "_1hziidpf _3n4midpf _ltofidpf _k7zyidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        children: renderGroups(dataProductKey)
                    })
                }) : null
            })
        ]
    });
};
var $96f8f1342a672b0a$export$2e2bcd8739ae039 = $96f8f1342a672b0a$export$39cc2d4a9bc14e7d;

});


parcelRegister("4Jdkw", function(module, exports) {
$parcel$export(module.exports, "ADG4CtaWithPolygonBackground", function () { return $07707e85aaf85d14$export$eacf4ba154ffd9bb; });
/* cta-with-polygon-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $5qUgh = parcelRequire("5qUgh");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $07707e85aaf85d14$var$ctaStyles = null;
const $07707e85aaf85d14$var$h3Styles = null;
const $07707e85aaf85d14$var$typographyOverrides = null;
const $07707e85aaf85d14$var$polygonStyles = null;
const $07707e85aaf85d14$export$eacf4ba154ffd9bb = ({ header: header, paragraph: paragraph, ctaText: ctaText, ctaUrl: ctaUrl, ctaLabel: ctaLabel, productKey: productKey, backgroundColor: backgroundColor = "#101214", buttonVariant: buttonVariant = "secondary", buttonColor: buttonColor = "white" })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : 0;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_p12f1git _18s84p42 _y3gn1h6o",
                "_syaz121t _6rth4cqu",
                sectionIsVisible ? "is-visible" : ""
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    "--background-color": backgroundColor
                },
                className: (0, $2jatx.default)([
                    "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci",
                    "polygon"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1fu0 _vwz41da2 _1cqs1h67 _1jw853lb _1bys1fu0",
                                    "_syaz121t _6rth4cqu",
                                    "header h3"
                                ]),
                                style: {
                                    marginBottom: noParagraphSpacing,
                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_syaz121t _6rth4cqu",
                                        ".body-lg"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                    },
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                variant: buttonVariant,
                                color: buttonColor,
                                colorAgainst: backgroundColor == "#101214" ? "black" : "other",
                                href: ctaUrl,
                                dataEventProps: {
                                    "data-product-key": productKey,
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "ctaSection",
                                    "data-label-english": ctaLabel
                                },
                                className: (0, $2jatx.default)([
                                    "_6rthzwfg"
                                ]),
                                children: ctaText
                            })
                        ]
                    })
                })
            })
        })
    });
};

});

parcelRegister("cDJ3u", function(module, exports) {
$parcel$export(module.exports, "SimpleImageTextSide", function () { return (parcelRequire("50aZ0")).SimpleImageTextSide; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("50aZ0")).SimpleImageTextSide; });

var $50aZ0 = parcelRequire("50aZ0");

});
parcelRegister("50aZ0", function(module, exports) {
$parcel$export(module.exports, "SimpleImageTextSide", function () { return $52a85b4e5fd4de41$export$c449191a6146bc15; });
/* simple-image-text-side.tsx generated by @compiled/babel-plugin v0.28.8 */ //@ts-nocheck

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
const $52a85b4e5fd4de41$var$simpleImageTextSideStyle = null;
const $52a85b4e5fd4de41$var$RenderImage = ({ imageLink: imageLink, imageAltText: imageAltText, aspectRatio: aspectRatio })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        },
        className: (0, $2jatx.default)([
            "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _688gkb7n"
        ])
    });
const $52a85b4e5fd4de41$var$RenderContent = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText, headerType: headerType, lozenge: lozenge, bodyText: bodyText, ctaProps: ctaProps, horizontalRule: horizontalRule, linkText: linkText, linkUrl: linkUrl })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                eyebrowText: eyebrowText,
                headerText: headerText,
                isBannerRichText: isBannerRichText,
                headerType: headerType,
                lozenge: lozenge,
                bodyText: bodyText,
                ctaProps: ctaProps,
                horizontalRule: horizontalRule
            }),
            linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                text: linkText,
                href: linkUrl,
                type: "primary"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1jab1ylp _3fdxglyw _5jnq1ylp _uknx7vkz _b9s91ylp"
                ])
            })
        ]
    });
const $52a85b4e5fd4de41$export$c449191a6146bc15 = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText = false, headerType: headerType = "h2", lozenge: lozenge, bodyText: bodyText, linkText: linkText, linkUrl: linkUrl, imageLink: imageLink, imageAltText: imageAltText, imagePosition: imagePosition, className: className = "", ctaProps: ctaProps, aspectRatio: aspectRatio, horizontalRule: horizontalRule = false, alignItems: alignItems = "center", rowProps: rowProps = "6-6", backgroundColor: backgroundColor = "transparent", margin: margin = "80px 0" })=>{
    const renderImageProps = {
        imageLink: imageLink,
        imageAltText: imageAltText,
        aspectRatio: aspectRatio
    };
    const renderContentProps = {
        eyebrowText: eyebrowText,
        headerText: headerText,
        isBannerRichText: isBannerRichText,
        headerType: headerType,
        lozenge: lozenge,
        bodyText: bodyText,
        ctaProps: ctaProps,
        horizontalRule: horizontalRule,
        linkText: linkText,
        linkUrl: linkUrl
    };
    const first = imagePosition === "left" ? /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderImage, {
        ...renderImageProps
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderContent, {
        ...renderContentProps
    });
    const second = imagePosition === "left" ? /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderContent, {
        ...renderContentProps
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderImage, {
        ...renderImageProps
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _1kmx7vkz _1ggmidpf _1ykz7vkz _1maeidpf _i6jx1wqb _1lh7idpf _z3nc1wqb _wpaiidpf",
            className
        ]),
        style: {
            "--bkgd-color": backgroundColor,
            "--margin": margin,
            "backgroundColor": "var(--bkgd-color, transparent)",
            "margin": "var(--margin, 0)"
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
            layout: rowProps,
            alignItems: alignItems,
            children: [
                first,
                second
            ]
        })
    });
};

});


parcelRegister("4Gm7Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("eDLrr")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("eDLrr")).Icon; });

var $eDLrr = parcelRequire("eDLrr");

});
parcelRegister("eDLrr", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $aa89821955d62a1a$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $aa89821955d62a1a$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $aa89821955d62a1a$var$svgStyles = null;
var $aa89821955d62a1a$var$iconStyles = null;
var $aa89821955d62a1a$var$smallIconStyles = null;
var $aa89821955d62a1a$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $aa89821955d62a1a$var$baseHcmStyles = null;
var $aa89821955d62a1a$var$scaleSize = null;
var $aa89821955d62a1a$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $aa89821955d62a1a$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $aa89821955d62a1a$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $aa89821955d62a1a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $aa89821955d62a1a$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $2jatx.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $aa89821955d62a1a$var$coreSizeSmall[spacing] : $aa89821955d62a1a$var$coreSizeMedium[spacing]
        ])
    }));
});
var $aa89821955d62a1a$export$2e2bcd8739ae039 = $aa89821955d62a1a$export$f04a61298a47a40f;

});


parcelRegister("7Mywp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $017651bb71402a74$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $017651bb71402a74$export$2e2bcd8739ae039(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? '' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId, color = _ref.color, Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("1jakU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f3f95565cbe1133$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $6SmMc = parcelRequire("6SmMc");

var $7Mywp = parcelRequire("7Mywp");
function $0f3f95565cbe1133$export$2e2bcd8739ae039(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? 'Story' : _ref$label, size = _ref.size, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7Mywp.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6SmMc))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});
parcelRegister("6SmMc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5019742af55a1f0c$var$_react = $5019742af55a1f0c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5019742af55a1f0c$var$_baseNew = $5019742af55a1f0c$var$_interopRequireDefault((parcelRequire("4Gm7Q")));
function $5019742af55a1f0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5019742af55a1f0c$var$StoryIcon = (props)=>/*#__PURE__*/ $5019742af55a1f0c$var$_react.default.createElement($5019742af55a1f0c$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$5019742af55a1f0c$var$StoryIcon.displayName = 'StoryIcon';
var $5019742af55a1f0c$var$_default = module.exports.default = $5019742af55a1f0c$var$StoryIcon;

});


parcelRegister("iyuye", function(module, exports) {

var $erWD3 = parcelRequire("erWD3");

var $ih96c = parcelRequire("ih96c");
/** Error message constants. */ var $d82319cd6e5631ad$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $d82319cd6e5631ad$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($d82319cd6e5631ad$var$FUNC_ERROR_TEXT);
    if ($ih96c(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $erWD3(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $d82319cd6e5631ad$var$throttle;

});

parcelRegister("7H8sx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35a8ca9f503841cffe12f1ff6d6bb3be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59a31c6591dcb8cb$var$_react = $59a31c6591dcb8cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $59a31c6591dcb8cb$var$_baseNew = $59a31c6591dcb8cb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $59a31c6591dcb8cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59a31c6591dcb8cb$var$CameraIcon = (props)=>/*#__PURE__*/ $59a31c6591dcb8cb$var$_react.default.createElement($59a31c6591dcb8cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.4.8A.75.75 0 0 1 6 .5h4a.75.75 0 0 1 .6.3l1.275 1.7h1.375A2.75 2.75 0 0 1 16 5.25V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.25A2.75 2.75 0 0 1 2.75 2.5h1.375zM6.375 2 5.1 3.7a.75.75 0 0 1-.6.3H2.75c-.69 0-1.25.56-1.25 1.25V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5.25c0-.69-.56-1.25-1.25-1.25H11.5a.75.75 0 0 1-.6-.3L9.625 2zM8 6.5A1.75 1.75 0 1 0 8 10a1.75 1.75 0 0 0 0-3.5M4.75 8.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0" clip-rule="evenodd"/>`
    }, props));
$59a31c6591dcb8cb$var$CameraIcon.displayName = 'CameraIcon';
var $59a31c6591dcb8cb$var$_default = module.exports.default = $59a31c6591dcb8cb$var$CameraIcon;

});

parcelRegister("9dCmO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b6316d01b13082f$var$_react = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6b6316d01b13082f$var$_baseNew = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6b6316d01b13082f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b6316d01b13082f$var$CommentIcon = (props)=>/*#__PURE__*/ $6b6316d01b13082f$var$_react.default.createElement($6b6316d01b13082f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$6b6316d01b13082f$var$CommentIcon.displayName = 'CommentIcon';
var $6b6316d01b13082f$var$_default = module.exports.default = $6b6316d01b13082f$var$CommentIcon;

});

parcelRegister("ppCkT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04c634faffce0aa7$var$_react = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $04c634faffce0aa7$var$_baseNew = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $04c634faffce0aa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04c634faffce0aa7$var$DepartmentIcon = (props)=>/*#__PURE__*/ $04c634faffce0aa7$var$_react.default.createElement($04c634faffce0aa7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$04c634faffce0aa7$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $04c634faffce0aa7$var$_default = module.exports.default = $04c634faffce0aa7$var$DepartmentIcon;

});

parcelRegister("b2tob", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8096adab141a7275$var$_react = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8096adab141a7275$var$_baseNew = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8096adab141a7275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8096adab141a7275$var$EditIcon = (props)=>/*#__PURE__*/ $8096adab141a7275$var$_react.default.createElement($8096adab141a7275$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$8096adab141a7275$var$EditIcon.displayName = 'EditIcon';
var $8096adab141a7275$var$_default = module.exports.default = $8096adab141a7275$var$EditIcon;

});

parcelRegister("eMDDH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac344be6bebfa432$var$_react = $ac344be6bebfa432$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ac344be6bebfa432$var$_baseNew = $ac344be6bebfa432$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ac344be6bebfa432$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac344be6bebfa432$var$FeedbackIcon = (props)=>/*#__PURE__*/ $ac344be6bebfa432$var$_react.default.createElement($ac344be6bebfa432$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ac344be6bebfa432$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $ac344be6bebfa432$var$_default = module.exports.default = $ac344be6bebfa432$var$FeedbackIcon;

});

parcelRegister("cB1fn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92b9e8622fafa0ab$var$_react = $92b9e8622fafa0ab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $92b9e8622fafa0ab$var$_baseNew = $92b9e8622fafa0ab$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $92b9e8622fafa0ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92b9e8622fafa0ab$var$FileIcon = (props)=>/*#__PURE__*/ $92b9e8622fafa0ab$var$_react.default.createElement($92b9e8622fafa0ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$92b9e8622fafa0ab$var$FileIcon.displayName = 'FileIcon';
var $92b9e8622fafa0ab$var$_default = module.exports.default = $92b9e8622fafa0ab$var$FileIcon;

});

parcelRegister("6zF1U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c95d69c59142f9b$var$_react = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c95d69c59142f9b$var$_baseNew = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4c95d69c59142f9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c95d69c59142f9b$var$LightbulbIcon = (props)=>/*#__PURE__*/ $4c95d69c59142f9b$var$_react.default.createElement($4c95d69c59142f9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$4c95d69c59142f9b$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $4c95d69c59142f9b$var$_default = module.exports.default = $4c95d69c59142f9b$var$LightbulbIcon;

});

parcelRegister("6ED9p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0140140442510c7f$var$_react = $0140140442510c7f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0140140442510c7f$var$_baseNew = $0140140442510c7f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $0140140442510c7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0140140442510c7f$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $0140140442510c7f$var$_react.default.createElement($0140140442510c7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$0140140442510c7f$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $0140140442510c7f$var$_default = module.exports.default = $0140140442510c7f$var$ListBulletedIcon;

});

parcelRegister("5WMok", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4547e807fcbff5a7$var$_react = $4547e807fcbff5a7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4547e807fcbff5a7$var$_baseNew = $4547e807fcbff5a7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4547e807fcbff5a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4547e807fcbff5a7$var$RefreshIcon = (props)=>/*#__PURE__*/ $4547e807fcbff5a7$var$_react.default.createElement($4547e807fcbff5a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$4547e807fcbff5a7$var$RefreshIcon.displayName = 'RefreshIcon';
var $4547e807fcbff5a7$var$_default = module.exports.default = $4547e807fcbff5a7$var$RefreshIcon;

});

parcelRegister("dTWad", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ed8782c3681aeb$var$_react = $a1ed8782c3681aeb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1ed8782c3681aeb$var$_baseNew = $a1ed8782c3681aeb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a1ed8782c3681aeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1ed8782c3681aeb$var$RoadmapIcon = (props)=>/*#__PURE__*/ $a1ed8782c3681aeb$var$_react.default.createElement($a1ed8782c3681aeb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$a1ed8782c3681aeb$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $a1ed8782c3681aeb$var$_default = module.exports.default = $a1ed8782c3681aeb$var$RoadmapIcon;

});

parcelRegister("dJqoM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ff3f48be8ac951c$var$_react = $9ff3f48be8ac951c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9ff3f48be8ac951c$var$_baseNew = $9ff3f48be8ac951c$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $9ff3f48be8ac951c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ff3f48be8ac951c$var$TaskIcon = (props)=>/*#__PURE__*/ $9ff3f48be8ac951c$var$_react.default.createElement($9ff3f48be8ac951c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$9ff3f48be8ac951c$var$TaskIcon.displayName = 'TaskIcon';
var $9ff3f48be8ac951c$var$_default = module.exports.default = $9ff3f48be8ac951c$var$TaskIcon;

});

parcelRegister("gjva1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be06978ded12aba7$var$_react = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $be06978ded12aba7$var$_baseNew = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $be06978ded12aba7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be06978ded12aba7$var$TeamsIcon = (props)=>/*#__PURE__*/ $be06978ded12aba7$var$_react.default.createElement($be06978ded12aba7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$be06978ded12aba7$var$TeamsIcon.displayName = 'TeamsIcon';
var $be06978ded12aba7$var$_default = module.exports.default = $be06978ded12aba7$var$TeamsIcon;

});

parcelRegister("HMZ3r", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("ftgEA")).ContentPlatformImage; });

var $ftgEA = parcelRequire("ftgEA");

});
parcelRegister("ftgEA", function(module, exports) {
$parcel$export(module.exports, "ContentPlatformImage", function () { return $93bafa18ccb06246$export$f8e4eb6f7b9af79c; });

var $7VQPk = parcelRequire("7VQPk");

var $imIsw = parcelRequire("imIsw");
const $93bafa18ccb06246$export$f8e4eb6f7b9af79c = ({ contentType: contentType, src: src, alt: alt, baseWidth: baseWidth, ...rest })=>{
    const queryPairs = [];
    let srcSet = [];
    if (contentType === "image/png") {
        queryPairs.push("fm=webp");
        if (baseWidth) {
            srcSet = (0, $imIsw.getSrcSet)(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        loading: "lazy",
        ...rest,
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(",") : undefined,
        alt: alt
    }));
};

});


parcelRegister("4Fnxt", function(module, exports) {
$parcel$export(module.exports, "Stats", function () { return $cac0a62c179e6d20$export$3cdec2bba15e3523; });
/* stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $6iKF0 = parcelRequire("6iKF0");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");
const $cac0a62c179e6d20$var$earthStyles = null;
const $cac0a62c179e6d20$export$cc52242338d2406f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1e02idpf _152txard _bna71wug _rtys1osq _t9ec1u9r _1h1t1ekt _tnru1wug _1rfm12eq _xaejlc6t _1eg616tw _95u51a2f"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/435e558616x6e3c2jvth65jiq2vusf20.webp",
                alt: "",
                width: 700,
                height: 700
            }
        })
    });
};
const $cac0a62c179e6d20$var$easeOutQuad = (t)=>t * (2 - t);
const $cac0a62c179e6d20$var$frameDuration = 1000 / 60;
const $cac0a62c179e6d20$var$AnimateCount = ({ children: children = "0", duration: duration = 2000 })=>{
    const countTo = parseInt(children, 10);
    const [count, setCount] = (0, $1oC0p.useState)(0);
    (0, $1oC0p.useEffect)(()=>{
        let frame = 0;
        const totalFrames = Math.round(duration / $cac0a62c179e6d20$var$frameDuration);
        const counter = setInterval(()=>{
            frame++;
            const progress = $cac0a62c179e6d20$var$easeOutQuad(frame / totalFrames);
            setCount(countTo * progress);
            if (frame === totalFrames) clearInterval(counter);
        }, $cac0a62c179e6d20$var$frameDuration);
        return ()=>clearInterval(counter);
    }, [
        countTo,
        duration
    ]);
    return Math.floor(count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const $cac0a62c179e6d20$export$3cdec2bba15e3523 = (statsProps)=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_p12f1git _19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswh2mm _1pbykb7n _ca0qymf6 _u5f3idpf _n3td53f4 _19bvidpf _1reo15vq _18m915vq _11q71rga _mkrz13pj _1vth1g58 _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _srwz1ylp"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1q51gktf _85i5gktf _1gde1bp4",
                    "wrapper"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1q511ul9 _p12f1osq _1e0c1txw _4cvr1y6m _zulp1ylp _kqswh2mm _1t19idpf _p7vbidpf _1rhg1w8u _19wggktf _1gde1bp4 _1u2q1wqb",
                            "text-wrapper"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1ssb _1fe7kb7n _12ihkb7n _1a1xf1ug _1rfm1osq",
                                    "fifty"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb8pqr _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.headerText
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_ect4qlpn _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz17la",
                                            "_1wyb1qf2 _g4miqd8k _1lzo1bc9",
                                            "big-stat"
                                        ]),
                                        style: {
                                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1bjw",
                                                    "big-stat"
                                                ]),
                                                style: {
                                                    "--_1shjtka": (0, $6ZVlx.default)(statsProps.bigStat.statColor ? statsProps.bigStat.statColor : (0, $kbpa7.wacToken)("color.primary.black"))
                                                },
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                                                        fallback: null,
                                                        children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$var$AnimateCount, {
                                                            children: statsProps.bigStat.stat
                                                        }) : statsProps.bigStat.stat
                                                    })
                                                ]
                                            }),
                                            statsProps.bigStat.statSymbol && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1y4s"
                                                ]),
                                                style: {
                                                    "--_1bnfnau": (0, $6ZVlx.default)(statsProps.bigStat.statSymbol?.symbolCharacterColor ? statsProps.bigStat.statSymbol.symbolCharacterColor : (0, $kbpa7.wacToken)("color.primary.black"))
                                                },
                                                children: statsProps.bigStat.statSymbol?.symbolCharacter
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.bigStat.statText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1r5k _1e0c1txw _zulpgktf _2lx21bp4 _y4ti1ylp _1fe7kb7n _12ihkb7n _1a1xf1ug _chtuidpf",
                                    "thirty"
                                ]),
                                children: statsProps.littleStats.map((statObj, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _bozggktf",
                                            "stat-wrapper"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswstnw _4t3i1osq _11q71hlo _1bsbyh40 _1e02idpf"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_ect4qlpn _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz17la",
                                                    "_1wybxxch",
                                                    "little-stat"
                                                ]),
                                                style: {
                                                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                    className: (0, $2jatx.default)([
                                                        "_syazoodi"
                                                    ]),
                                                    style: {
                                                        "--_11wxpl2": (0, $6ZVlx.default)(statObj.statColor ? statObj.statColor : (0, $kbpa7.wacToken)("color.primary.black"))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                                                            fallback: null,
                                                            children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$var$AnimateCount, {
                                                                children: statObj.stat
                                                            }) : statObj.stat
                                                        }),
                                                        statObj.statSymbol && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_syaz16k1"
                                                            ]),
                                                            style: {
                                                                "--_1nxvphm": (0, $6ZVlx.default)(statObj.statSymbol?.symbolCharacterColor ? statObj.statSymbol.symbolCharacterColor : (0, $kbpa7.wacToken)("color.primary.black"))
                                                            },
                                                            children: statObj.statSymbol?.symbolCharacter
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: statObj.statText
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1h1tgbua _kqswh2mm _rjxpidpf _u7coidpf _152tidpf _4t3i1osq _1e0c1txw _1bah1h6o _mmgkgktf _1rfm1osq _tnru68cl _srwzidpf _476d1ylp _1t06idpf _1jc21gwv _10jx1gwv",
                            "earth-contents"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$export$cc52242338d2406f, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _1o2w1n0t _rjxp3ll0 _p5ce1x96 _1l7d176h _xaej15qf _1rfm68cl _tnru1wug",
                                    "blob"
                                ]),
                                width: "102",
                                height: "95",
                                "aria-hidden": "true",
                                viewBox: "0 0 102 95",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M97.6377 58.2134C98.2297 54.8868 98.5329 51.356 98.5329 47.6063C98.5329 43.8566 98.2152 40.2236 97.6233 36.8533C94.057 16.8063 80.2829 4.44834 60.9645 1.28226C57.6726 0.742421 54.2074 0.46521 50.6123 0.46521C47.0172 0.46521 43.2632 0.771614 39.8414 1.34063C20.5085 4.60885 6.74887 16.923 3.18262 36.8533C2.57621 40.2236 2.27301 43.7982 2.27301 47.6063C2.27301 51.4143 2.57621 54.8868 3.16818 58.2134C6.70555 78.1144 20.4797 90.4578 39.8414 93.726C43.2632 94.3096 46.8728 94.6014 50.6123 94.6014C54.3518 94.6014 57.6726 94.3242 60.9645 93.7844C80.3118 90.6037 94.1148 78.2312 97.6521 58.2134H97.6377Z",
                                        fill: "#FCA700"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                                className: (0, $2jatx.default)([
                                    "_1bsbutna _4t3i1wug _kqswstnw _1e021nh5 _u7co1228 _sugaglyw",
                                    "lightning"
                                ]),
                                width: "131",
                                height: "139",
                                "aria-hidden": "true",
                                viewBox: "0 0 131 139",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M20.4793 61.2896C11.5228 63.9778 10.6462 63.8696 8.14861 74.6224C5.48565 77.7767 3.98043 82.2375 2.50009 87.7471C1.52422 89.9276 8.05758 89.112 4.36913 89.8361C6.75918 90.66 13.6813 90.2023 14.4338 91.2343C10.9604 99.0243 8.42147 107.638 6.13066 115.911C6.18028 130.151 27.1036 98.5582 29.5102 96.5941C30.7176 93.1152 44.2806 78.484 38.1442 78.1761C29.196 76.6947 23.4234 81.4636 30.1387 69.8369C30.2793 69.3875 33.3061 62.3049 32.6197 60.1909C28.0133 62.1883 27.0788 70.1864 24.2752 74.5474C19.5778 80.881 28.6253 81.9463 32.6114 81.3554C32.5618 82.2875 36.1345 80.7562 35.2909 82.7037C30.1718 90.2606 12.9866 112.723 13.028 112.765C11.7296 115.611 9.81084 116.752 9.33117 115.861C9.04172 115.328 18.2546 92.6159 19.5117 89.6947C20.5289 86.1243 14.2436 86.9482 14.2436 86.9482C14.2436 86.9482 14.897 87.2727 16.7578 87.3226C14.8143 87.8969 9.87707 87.1396 6.51115 86.8733C7.08179 81.7382 13.7061 65.3676 13.7061 65.3676C13.7061 65.3676 27.7817 64.2191 31.3378 59.9662C28.7245 59.7415 24.3001 61.0649 20.471 61.2979L20.4793 61.2896Z",
                                        fill: "#101214"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M128.71 53.5661L129.636 51.8599C129.934 51.294 130.314 50.7031 130.413 50.1954C130.537 49.6877 130.521 49.2633 130.488 48.9138C130.48 48.8139 130.488 48.7556 130.438 48.6391C130.397 48.5225 130.306 48.3894 130.248 48.3395C130.116 48.2313 129.983 48.1147 129.818 47.9982C129.487 47.7735 129.065 47.5322 128.47 47.424C127.858 47.3408 127.205 47.2908 126.576 47.2159C123.392 46.8913 120.216 46.5667 117.082 46.2505C114.138 45.9425 111.227 45.6346 108.341 45.335C105.76 45.052 103.205 44.7774 100.691 44.5027C100.492 44.4528 100.178 44.5193 100.137 44.253C100.153 44.0283 100.31 43.8369 100.393 43.6455C100.972 42.3971 101.543 41.1571 102.113 39.9336C103.395 37.1955 104.644 34.5239 105.86 31.9189C108.316 26.7256 110.689 21.8236 112.972 17.2878L112.699 17.5541C112.889 17.2295 113.303 16.1393 113.576 15.9479C113.923 14.9075 114.436 13.4843 115.039 11.9113C115.345 11.129 115.66 10.3051 115.982 9.47285L116.47 8.22446C116.76 7.53368 117.041 6.85116 117.322 6.17702C117.653 5.36141 117.702 4.6707 117.653 4.06315C117.587 3.43063 117.347 2.78144 116.958 2.27376C116.189 1.21679 114.948 0.800607 114.088 0.867188C113.063 1.14183 112.219 1.35825 111.632 1.51638C111.326 1.63289 111.086 1.7245 110.913 1.78276C110.789 1.82437 110.731 1.8493 110.731 1.8493C106.794 3.33905 102.626 4.49591 98.4578 5.61114C98.4578 5.61114 97.0768 5.87744 94.8769 6.31021C93.7687 6.5266 92.462 6.78464 91.0065 7.07593C90.2787 7.22574 89.5096 7.39216 88.7157 7.55861C88.3187 7.64184 87.9052 7.74169 87.4834 7.84988C87.0865 7.94975 86.6896 8.05795 86.2843 8.16614C83.0673 8.99008 79.4202 9.78077 76.1535 11.1124C74.5243 11.7699 73.0026 12.5771 71.729 13.4843C70.4472 14.3915 69.4216 15.4152 68.6939 16.3473C66.6181 18.4696 65.0798 21.008 63.8228 23.613C62.5575 26.2263 61.5733 28.9228 60.5974 31.5943C59.6464 34.2826 58.6292 36.8626 57.5458 39.5008L54.3536 47.3907C54.3536 47.3907 49.4163 60.7236 48.4156 64.9348C48.0931 66.2831 47.8864 67.4066 47.7871 68.2472C48.1841 68.2139 48.7382 68.1889 49.4328 68.1806C50.6899 65.9085 52.6582 61.3311 55.4452 53.7408C55.5527 53.5993 55.8008 53.1084 55.8918 53.0668C57.0744 49.6378 58.3315 46.2838 59.6465 42.9547C60.3163 41.2985 60.9862 39.6424 61.656 37.9862C62.3507 36.2967 62.9958 34.5821 63.6243 32.9176C64.8896 29.5886 66.1467 26.3178 67.7842 23.4132C68.6029 21.9651 69.5126 20.6085 70.5546 19.4267C71.5967 18.2365 72.7297 17.2711 74.086 16.4389C73.8213 16.3224 74.086 15.9145 74.4995 15.8479L74.5243 16.1808C76.3189 14.999 78.2789 14.2666 80.181 13.6924C82.0914 13.1181 83.9853 12.7103 85.8874 12.2609L87.3181 11.9113L88.7157 11.5452C89.6254 11.3205 90.5352 11.0957 91.4697 10.871C93.3801 10.3966 95.3814 9.84733 97.5233 9.11493C97.5068 9.12326 96.6053 9.71416 96.5888 9.7308C100.037 8.97344 103.627 8.15785 107.398 7.15081C108.341 6.88448 109.292 6.62649 110.259 6.32688C110.739 6.18539 111.227 6.03554 111.715 5.86909L112.145 5.72767L112.236 5.69435C112.352 5.64441 112.509 5.57783 112.616 5.69435C112.732 5.80254 112.658 5.96065 112.6 6.08549C109.813 12.3025 106.877 18.869 103.883 25.5521C102.32 29.0476 100.74 32.5681 99.1691 36.0969C98.3834 37.8613 97.5978 39.6257 96.8121 41.3818L95.8527 43.5206C95.6625 43.9284 95.4971 44.3446 95.431 44.7275C95.3648 45.1103 95.3649 45.4515 95.3897 45.7595C95.4145 46.3587 95.828 47.1993 96.3408 47.6321C96.5806 47.8484 96.837 47.9983 97.1595 48.1647C97.4903 48.3145 97.879 48.4394 98.3173 48.4893C105.239 49.1801 111.988 49.8542 118.521 50.5117C120.068 50.6615 121.598 50.8113 123.119 50.9528L124.252 51.061L124.74 51.1026H124.839L125.269 51.1275C125.327 51.1442 125.451 51.0943 125.46 51.1858L125.377 51.3689L125.195 51.76C124.906 52.3177 124.608 52.867 124.318 53.4246C123.979 54.0654 123.648 54.7063 123.293 55.3305L123.417 55.2056V55.2888C123.649 54.9726 123.963 54.5066 124.327 53.9073C124.674 53.3497 125.087 52.6838 125.534 51.9515C125.724 51.6851 125.956 51.3606 126.212 50.9778C126.262 50.8779 126.378 50.7947 126.378 50.6782C126.328 50.5866 126.204 50.6199 126.121 50.5783C125.915 50.5367 125.716 50.4951 125.517 50.4618C125.294 50.4202 125.071 50.3785 124.864 50.3369C124.393 50.2703 123.938 50.2038 123.5 50.1455C122.59 50.0207 121.763 49.9041 121.052 49.8126C119.638 49.6212 118.72 49.4963 118.72 49.4963C120.109 49.4547 121.523 49.463 122.946 49.5046C123.64 49.5379 124.343 49.5629 125.046 49.5962C125.592 49.6212 126.163 49.6544 126.742 49.6961L127.618 49.7709C127.693 49.7792 127.767 49.771 127.833 49.7959C127.899 49.8209 127.949 49.8958 127.932 49.9707C127.874 50.1038 127.8 50.2287 127.734 50.3536C127.453 50.8613 127.172 51.3772 126.882 51.8932C126.551 52.4758 126.212 53.0667 125.873 53.6493C125.501 54.2985 125.129 54.9476 124.732 55.5884C123.136 58.1352 121.564 60.7152 119.886 63.212C119.067 64.477 118.248 65.7338 117.438 66.9822C116.611 68.2222 115.8 69.4623 115.023 70.7107L114.742 70.4277C117.512 66.1749 119.629 62.1717 120.44 60.5571C115.593 68.2639 108.068 79.6908 99.8224 90.4602C95.7453 95.8783 91.4531 101.105 87.5 105.816C85.5069 108.154 83.6213 110.393 81.8185 112.399C80.9253 113.414 80.0735 114.388 79.263 115.312C78.4443 116.227 77.6669 117.093 76.9391 117.9C77.2037 117.842 78.1548 116.718 79.2382 115.578C80.3133 114.429 81.4959 113.223 82.3229 113.056C81.5786 113.888 80.8261 114.721 80.0818 115.545C79.3292 116.36 78.5684 117.176 77.8241 117.983C77.0715 118.79 76.3271 119.589 75.5911 120.38C74.8468 121.162 74.086 121.92 73.3416 122.661C72.8951 122.211 74.7641 120.646 75.0205 120.222C74.3093 120.788 72.1094 122.952 68.7187 126.114C67.0151 127.687 65.055 129.552 62.789 131.541C62.5161 131.782 62.2432 132.024 61.9703 132.273L61.7718 132.44C61.6312 132.531 61.532 132.681 61.3666 132.714C61.2012 132.739 61.0275 132.631 60.9614 132.465C60.8869 132.29 60.9944 132.115 61.0358 131.948C61.6395 129.901 62.268 127.754 62.9131 125.54C63.6822 122.96 64.4927 120.305 65.3446 117.6C67.0482 112.191 68.9006 106.573 70.8606 100.963C72.8124 95.3539 74.8716 89.7445 76.9474 84.3348C77.9811 81.63 79.0232 78.975 80.0569 76.395L80.4374 75.4296L80.6276 74.9469C80.6607 74.8636 80.6938 74.8054 80.7186 74.6889L80.8013 74.3227C81.0246 73.3406 81.2479 72.3668 81.4712 71.4014C81.5787 70.9187 81.6944 70.436 81.8019 69.9616L81.9674 69.2459L82.0501 68.8881C82.0583 68.8298 82.0914 68.7632 82.0832 68.7216C82.0584 68.6633 82.0087 68.6633 81.9591 68.6384C81.2313 68.3471 80.5036 68.0557 79.7841 67.7644C77.7 67.8477 75.6656 67.9226 73.6807 67.9975C72.2418 68.0391 70.8359 68.0724 69.4796 68.1057C66.767 68.1639 64.2198 68.1889 61.8959 68.1889C57.2398 68.1723 53.4522 68.164 50.8719 68.1557C50.3426 68.1557 49.8794 68.1557 49.4494 68.1557C49.2757 68.4719 49.1186 68.7382 48.9698 68.9629C49.8216 69.1128 50.9545 69.2792 52.4266 69.4789L51.5086 69.7619C56.082 70.0698 60.2584 70.253 64.501 70.4194C66.6181 70.4943 68.7517 70.5692 70.9516 70.6525C72.0515 70.6858 73.168 70.7274 74.3093 70.769C74.8799 70.7856 75.4588 70.8106 76.0377 70.8272C76.4512 70.8522 76.8647 70.8771 77.2865 70.9021C77.394 70.8938 77.4932 70.8855 77.5759 70.8772C78.2706 70.8189 78.3451 70.8355 78.6759 70.5276C79.0067 70.461 79.6517 70.3445 79.7261 70.203C79.8502 70.1031 79.9991 70.0116 80.1645 69.9367C80.2141 69.9201 80.3299 69.8785 80.3299 69.9367C80.3299 69.97 80.3299 70.0199 80.3216 70.0781C80.2803 70.3029 80.1645 70.6857 80.0074 71.1268C79.6931 72.0173 79.2217 73.0743 78.9819 73.7235C78.1549 72.5416 75.2273 79.3828 72.5809 87.1395C69.8931 94.8712 67.5443 103.469 66.8331 105.433C65.452 105.832 64.2198 113.214 63.0289 115.461C63.0372 115.278 63.1116 114.13 63.1281 113.98C62.7891 114.463 61.9538 117.026 60.9945 120.48C60.5148 122.203 59.9937 124.15 59.4727 126.156C58.9352 128.295 58.3811 130.5 57.8518 132.606C57.703 133.255 57.6368 133.821 57.6202 134.346C57.612 134.878 57.8105 135.427 58.1744 135.844C58.8773 136.709 60.1427 136.925 60.9779 136.501C61.7553 136.06 62.4582 135.394 63.0867 134.795C63.6491 134.271 64.1453 133.813 64.5588 133.438C66.0971 132.048 66.4692 131.907 64.7408 133.987C71.4147 128.528 78.742 121.678 86.1437 113.705C93.5702 105.757 100.972 96.6024 108.035 86.79C115.081 76.961 121.688 66.3996 127.61 55.6551L128.743 53.5661H128.71Z",
                                        fill: "#101214"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $cac0a62c179e6d20$var$wrapperStyle = null;
const $cac0a62c179e6d20$var$earthContents = null;
const $cac0a62c179e6d20$var$blobStyles = null;
const $cac0a62c179e6d20$var$lightningStyles = null;
const $cac0a62c179e6d20$var$TextWrapperStyles = null;
const $cac0a62c179e6d20$var$fiftyStyles = null;
const $cac0a62c179e6d20$var$h2Styles = null;
const $cac0a62c179e6d20$var$statStyles = null;
const $cac0a62c179e6d20$var$bigStatStyles = null;
const $cac0a62c179e6d20$var$littleStatStyles = null;
const $cac0a62c179e6d20$var$statTextStyles = null;
const $cac0a62c179e6d20$var$thirtyStyles = null;
const $cac0a62c179e6d20$var$statWrapperStyles = null;
const $cac0a62c179e6d20$var$dividerStyles = null;
const $cac0a62c179e6d20$var$statsStyles = null;

});

parcelRegister("6VSBC", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3872cd7d84b2ef7a$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3872cd7d84b2ef7a$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");
const $3872cd7d84b2ef7a$var$logoWrapperStyles = null;
const $3872cd7d84b2ef7a$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3872cd7d84b2ef7a$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive == "overview",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise")
        },
        {
            globalLinksKey: "success",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.success",
                defaultMessage: "Success"
            }),
            hasSubnav: false,
            isActive: isActive == "success",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise/success")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive == "resources",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise/resources")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: (0, $kooLp.useLocalizedHref)("/enterprise"),
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "EnterpriseLandingPage.label",
                defaultMessage: "Enterprise"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-enterprise",
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features")
        })
    });
};
var $3872cd7d84b2ef7a$export$2e2bcd8739ae039 = $3872cd7d84b2ef7a$export$e36ad2737327f9c;

});

parcelRegister("2lwXu", function(module, exports) {
$parcel$export(module.exports, "ArrowRightNoCircle", function () { return $bbe047a4ec4aed29$export$c6abe79c9e2193ff; });

var $7VQPk = parcelRequire("7VQPk");
const $bbe047a4ec4aed29$export$c6abe79c9e2193ff = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});

parcelRegister("leqii", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f74f4d43cffd7f04$var$_react = $f74f4d43cffd7f04$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f74f4d43cffd7f04$var$_baseNew = $f74f4d43cffd7f04$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f74f4d43cffd7f04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f74f4d43cffd7f04$var$EpicIcon = (props)=>/*#__PURE__*/ $f74f4d43cffd7f04$var$_react.default.createElement($f74f4d43cffd7f04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$f74f4d43cffd7f04$var$EpicIcon.displayName = 'EpicIcon';
var $f74f4d43cffd7f04$var$_default = module.exports.default = $f74f4d43cffd7f04$var$EpicIcon;

});

parcelRegister("hGxEi", function(module, exports) {

var $iCQu6 = parcelRequire("iCQu6");

var $24uwp = parcelRequire("24uwp");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ce0075e69d454d18$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ce0075e69d454d18$var$rsComboMarksRange = '\\u0300-\\u036f', $ce0075e69d454d18$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ce0075e69d454d18$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ce0075e69d454d18$var$rsComboRange = $ce0075e69d454d18$var$rsComboMarksRange + $ce0075e69d454d18$var$reComboHalfMarksRange + $ce0075e69d454d18$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ce0075e69d454d18$var$rsCombo = '[' + $ce0075e69d454d18$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ce0075e69d454d18$var$reComboMark = RegExp($ce0075e69d454d18$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ce0075e69d454d18$var$deburr(string) {
    string = $24uwp(string);
    return string && string.replace($ce0075e69d454d18$var$reLatin, $iCQu6).replace($ce0075e69d454d18$var$reComboMark, '');
}
module.exports = $ce0075e69d454d18$var$deburr;

});
parcelRegister("iCQu6", function(module, exports) {

var $6V9cT = parcelRequire("6V9cT");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $037fd0776303ae37$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $037fd0776303ae37$var$deburrLetter = $6V9cT($037fd0776303ae37$var$deburredLetters);
module.exports = $037fd0776303ae37$var$deburrLetter;

});
parcelRegister("6V9cT", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $509f35426b22b824$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $509f35426b22b824$var$basePropertyOf;

});



parcelRegister("lXgpb", function(module, exports) {

var $gHIMV = parcelRequire("gHIMV");

var $dNNx2 = parcelRequire("dNNx2");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $ffbbd5682208087f$var$camelCase = $dNNx2(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $gHIMV(word) : word);
});
module.exports = $ffbbd5682208087f$var$camelCase;

});
parcelRegister("dNNx2", function(module, exports) {

var $5r99q = parcelRequire("5r99q");

var $hGxEi = parcelRequire("hGxEi");

var $cGaAm = parcelRequire("cGaAm");
/** Used to compose unicode capture groups. */ var $a0c645f3644bc61c$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $a0c645f3644bc61c$var$reApos = RegExp($a0c645f3644bc61c$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $a0c645f3644bc61c$var$createCompounder(callback) {
    return function(string) {
        return $5r99q($cGaAm($hGxEi(string).replace($a0c645f3644bc61c$var$reApos, '')), callback, '');
    };
}
module.exports = $a0c645f3644bc61c$var$createCompounder;

});
parcelRegister("5r99q", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3f56928ff1fa1456$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3f56928ff1fa1456$var$arrayReduce;

});

parcelRegister("cGaAm", function(module, exports) {

var $agIzJ = parcelRequire("agIzJ");

var $2fyoH = parcelRequire("2fyoH");

var $24uwp = parcelRequire("24uwp");

var $51QbK = parcelRequire("51QbK");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $93b19e4fcd969484$var$words(string, pattern, guard) {
    string = $24uwp(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2fyoH(string) ? $51QbK(string) : $agIzJ(string);
    return string.match(pattern) || [];
}
module.exports = $93b19e4fcd969484$var$words;

});
parcelRegister("agIzJ", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $779df9bff564b02d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $779df9bff564b02d$var$asciiWords(string) {
    return string.match($779df9bff564b02d$var$reAsciiWord) || [];
}
module.exports = $779df9bff564b02d$var$asciiWords;

});

parcelRegister("2fyoH", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $1a37aa184b5f841b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1a37aa184b5f841b$var$hasUnicodeWord(string) {
    return $1a37aa184b5f841b$var$reHasUnicodeWord.test(string);
}
module.exports = $1a37aa184b5f841b$var$hasUnicodeWord;

});

parcelRegister("51QbK", function(module, exports) {
/** Used to compose unicode character classes. */ var $3a9587500dbb7d28$var$rsAstralRange = '\\ud800-\\udfff', $3a9587500dbb7d28$var$rsComboMarksRange = '\\u0300-\\u036f', $3a9587500dbb7d28$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3a9587500dbb7d28$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3a9587500dbb7d28$var$rsComboRange = $3a9587500dbb7d28$var$rsComboMarksRange + $3a9587500dbb7d28$var$reComboHalfMarksRange + $3a9587500dbb7d28$var$rsComboSymbolsRange, $3a9587500dbb7d28$var$rsDingbatRange = '\\u2700-\\u27bf', $3a9587500dbb7d28$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3a9587500dbb7d28$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3a9587500dbb7d28$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3a9587500dbb7d28$var$rsPunctuationRange = '\\u2000-\\u206f', $3a9587500dbb7d28$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3a9587500dbb7d28$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3a9587500dbb7d28$var$rsVarRange = '\\ufe0e\\ufe0f', $3a9587500dbb7d28$var$rsBreakRange = $3a9587500dbb7d28$var$rsMathOpRange + $3a9587500dbb7d28$var$rsNonCharRange + $3a9587500dbb7d28$var$rsPunctuationRange + $3a9587500dbb7d28$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3a9587500dbb7d28$var$rsApos = "['\u2019]", $3a9587500dbb7d28$var$rsBreak = '[' + $3a9587500dbb7d28$var$rsBreakRange + ']', $3a9587500dbb7d28$var$rsCombo = '[' + $3a9587500dbb7d28$var$rsComboRange + ']', $3a9587500dbb7d28$var$rsDigits = '\\d+', $3a9587500dbb7d28$var$rsDingbat = '[' + $3a9587500dbb7d28$var$rsDingbatRange + ']', $3a9587500dbb7d28$var$rsLower = '[' + $3a9587500dbb7d28$var$rsLowerRange + ']', $3a9587500dbb7d28$var$rsMisc = '[^' + $3a9587500dbb7d28$var$rsAstralRange + $3a9587500dbb7d28$var$rsBreakRange + $3a9587500dbb7d28$var$rsDigits + $3a9587500dbb7d28$var$rsDingbatRange + $3a9587500dbb7d28$var$rsLowerRange + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3a9587500dbb7d28$var$rsModifier = '(?:' + $3a9587500dbb7d28$var$rsCombo + '|' + $3a9587500dbb7d28$var$rsFitz + ')', $3a9587500dbb7d28$var$rsNonAstral = '[^' + $3a9587500dbb7d28$var$rsAstralRange + ']', $3a9587500dbb7d28$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3a9587500dbb7d28$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3a9587500dbb7d28$var$rsUpper = '[' + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3a9587500dbb7d28$var$rsMiscLower = '(?:' + $3a9587500dbb7d28$var$rsLower + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsMiscUpper = '(?:' + $3a9587500dbb7d28$var$rsUpper + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsOptContrLower = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3a9587500dbb7d28$var$rsOptContrUpper = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3a9587500dbb7d28$var$reOptMod = $3a9587500dbb7d28$var$rsModifier + '?', $3a9587500dbb7d28$var$rsOptVar = '[' + $3a9587500dbb7d28$var$rsVarRange + ']?', $3a9587500dbb7d28$var$rsOptJoin = '(?:' + $3a9587500dbb7d28$var$rsZWJ + '(?:' + [
    $3a9587500dbb7d28$var$rsNonAstral,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + ')*', $3a9587500dbb7d28$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3a9587500dbb7d28$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3a9587500dbb7d28$var$rsSeq = $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + $3a9587500dbb7d28$var$rsOptJoin, $3a9587500dbb7d28$var$rsEmoji = '(?:' + [
    $3a9587500dbb7d28$var$rsDingbat,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsSeq;
/** Used to match complex or compound words. */ var $3a9587500dbb7d28$var$reUnicodeWord = RegExp([
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsMiscUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper + $3a9587500dbb7d28$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsMiscLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower,
    $3a9587500dbb7d28$var$rsUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper,
    $3a9587500dbb7d28$var$rsOrdUpper,
    $3a9587500dbb7d28$var$rsOrdLower,
    $3a9587500dbb7d28$var$rsDigits,
    $3a9587500dbb7d28$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3a9587500dbb7d28$var$unicodeWords(string) {
    return string.match($3a9587500dbb7d28$var$reUnicodeWord) || [];
}
module.exports = $3a9587500dbb7d28$var$unicodeWords;

});




parcelRegister("9b72g", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return (parcelRequire("atyps")).BitbucketNav; });
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return (parcelRequire("fv5hW")).WhyBitbucketSubnav; });
parcelRequire("atyps");
parcelRequire("fv5hW");

});
parcelRegister("atyps", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return $46b40aa87e150696$export$374e7235418bdbdb; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9b72g");
var $fv5hW = parcelRequire("fv5hW");
const $46b40aa87e150696$var$BitbucketLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.BitbucketLogo), {
        appearance: "brand"
    });
};
const $46b40aa87e150696$export$374e7235418bdbdb = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=bitbucket&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).BITBUCKET,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $kooLp.useLocalizedHref)("/software/bitbucket/enterprise/data-center");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/bitbucket/pricing");
    const links = [
        {
            globalLinksKey: "whyBitbucket",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.whyBitbucket",
                defaultMessage: "Why Bitbucket"
            }),
            productKey: "bitbucket",
            hasSubnav: true,
            dropdownType: "why-bitbucket"
        },
        {
            globalLinksKey: "self-hosted",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.selfhosted",
                defaultMessage: "Self-Hosted"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: dataCenterHref
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productKey: "bitbucket",
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.bitbucket-logo",
                defaultMessage: "Bitbucket logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "whyBitbucket",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.whyBitbucket",
                        defaultMessage: "Why Bitbucket"
                    }),
                    containerStyles: {
                        width: "fit-content",
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fv5hW.WhyBitbucketSubnav), {
                        productKey: "bitbucket"
                    })
                },
                {
                    globalLinksKey: "self-hosted",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.selfhosted",
                        defaultMessage: "Self-Hosted"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: dataCenterHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-bitbucket",
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});

parcelRegister("fv5hW", function(module, exports) {
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $e0ef30a4e223c9fa$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $e0ef30a4e223c9fa$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: "solution",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.solution",
                defaultMessage: "Solution"
            }),
            items: [
                {
                    id: "ci-cd",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.work-management",
                        defaultMessage: "CI/CD"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/pipelines")
                },
                {
                    id: "cloud-security",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.cloud-security",
                        defaultMessage: "Cloud Security"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/cloud-security")
                },
                {
                    id: "dev-sec-ops",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.dev-sec-ops",
                        defaultMessage: "DevSecOps"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/devsecops")
                },
                {
                    id: "code-review",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.it-service-management",
                        defaultMessage: "Code Review"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/code-review")
                },
                {
                    id: "jira-integrations",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.agile-devops",
                        defaultMessage: "Jira Integrations"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/jira/bitbucket-integration")
                }
            ]
        },
        plans: {
            id: "plans",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.plans",
                defaultMessage: "Plans"
            }),
            items: [
                {
                    id: "bitbucket-cloud-premium",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium",
                        defaultMessage: "Bitbucket Cloud Premium"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/premium")
                }
            ]
        }
    };
}
const $e0ef30a4e223c9fa$export$7b115720fff1fb0d = ({ productKey: productKey = "bitbucket" })=>{
    const intl = (0, $8e22h.default)();
    const bitbucketLinks = $e0ef30a4e223c9fa$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk1rga"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("bMbri", function(module, exports) {
$parcel$export(module.exports, "differenceInCalendarDays", function () { return $892d0cfd68028b95$export$4a02e9c37dab4871; });

var $kxmHU = parcelRequire("kxmHU");

var $32VtV = parcelRequire("32VtV");

var $59xhD = parcelRequire("59xhD");

var $eV9M6 = parcelRequire("eV9M6");
function $892d0cfd68028b95$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $32VtV.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $eV9M6.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, $eV9M6.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $kxmHU.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $kxmHU.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $59xhD.millisecondsInDay));
}
var // Fallback for modularized imports:
$892d0cfd68028b95$export$2e2bcd8739ae039 = $892d0cfd68028b95$export$4a02e9c37dab4871;

});
parcelRegister("kxmHU", function(module, exports) {
$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $ef3880e8be2c0e44$export$113002b5eff6e430; });

var $frdJf = parcelRequire("frdJf");
function $ef3880e8be2c0e44$export$113002b5eff6e430(date) {
    const _date = (0, $frdJf.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});
parcelRegister("frdJf", function(module, exports) {
$parcel$export(module.exports, "toDate", function () { return $b3d406e92ed7bfa5$export$e67a095c620b86fe; });

var $hs1PO = parcelRequire("hs1PO");
function $b3d406e92ed7bfa5$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $hs1PO.constructFrom)(context || argument, argument);
}
var // Fallback for modularized imports:
$b3d406e92ed7bfa5$export$2e2bcd8739ae039 = $b3d406e92ed7bfa5$export$e67a095c620b86fe;

});
parcelRegister("hs1PO", function(module, exports) {
$parcel$export(module.exports, "constructFrom", function () { return $cb467981594e0de1$export$ead8a1812b171991; });

var $59xhD = parcelRequire("59xhD");
function $cb467981594e0de1$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $59xhD.constructFromSymbol) in date) return date[0, $59xhD.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$cb467981594e0de1$export$2e2bcd8739ae039 = $cb467981594e0de1$export$ead8a1812b171991;

});
parcelRegister("59xhD", function(module, exports) {
$parcel$export(module.exports, "millisecondsInWeek", function () { return $3c079c6c1f76c043$export$4fad13613e88edc8; });
$parcel$export(module.exports, "millisecondsInDay", function () { return $3c079c6c1f76c043$export$b76b1809a2898f9a; });
$parcel$export(module.exports, "constructFromSymbol", function () { return $3c079c6c1f76c043$export$2a7b97929c48d47d; });
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $3c079c6c1f76c043$export$dfd9b671c89acc8e = 7;
const $3c079c6c1f76c043$export$3913210603d8e9ae = 365.2425;
const $3c079c6c1f76c043$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $3c079c6c1f76c043$export$4dec998e48f9c246 = -$3c079c6c1f76c043$export$81caae6e1cc7a622;
const $3c079c6c1f76c043$export$4fad13613e88edc8 = 604800000;
const $3c079c6c1f76c043$export$b76b1809a2898f9a = 86400000;
const $3c079c6c1f76c043$export$91246f0b9bd9beff = 60000;
const $3c079c6c1f76c043$export$7f72910d6dfd237a = 3600000;
const $3c079c6c1f76c043$export$397c2d5776aa9055 = 1000;
const $3c079c6c1f76c043$export$3633035e63cee86a = 525600;
const $3c079c6c1f76c043$export$ab7da2ccd1075c38 = 43200;
const $3c079c6c1f76c043$export$2423174df8cd3cd2 = 1440;
const $3c079c6c1f76c043$export$f2f5ae5a8e2d8f9f = 60;
const $3c079c6c1f76c043$export$3c58128db900d44e = 3;
const $3c079c6c1f76c043$export$80d7e435f744f319 = 12;
const $3c079c6c1f76c043$export$4db7641526e3241f = 4;
const $3c079c6c1f76c043$export$698aec755e92c695 = 3600;
const $3c079c6c1f76c043$export$a77c1a7ebebe2a5a = 60;
const $3c079c6c1f76c043$export$815a9362476d2fe3 = $3c079c6c1f76c043$export$698aec755e92c695 * 24;
const $3c079c6c1f76c043$export$34804a017b31e2fe = $3c079c6c1f76c043$export$815a9362476d2fe3 * 7;
const $3c079c6c1f76c043$export$7271e9e3478110d1 = $3c079c6c1f76c043$export$815a9362476d2fe3 * $3c079c6c1f76c043$export$3913210603d8e9ae;
const $3c079c6c1f76c043$export$8e6600bbdee7dabb = $3c079c6c1f76c043$export$7271e9e3478110d1 / 12;
const $3c079c6c1f76c043$export$be1dccf2de902d31 = $3c079c6c1f76c043$export$8e6600bbdee7dabb * 3;
const $3c079c6c1f76c043$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");

});




parcelRegister("32VtV", function(module, exports) {
$parcel$export(module.exports, "normalizeDates", function () { return $237e25a9bf646c99$export$9f53b88e82f64d8d; });

var $hs1PO = parcelRequire("hs1PO");
function $237e25a9bf646c99$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $hs1PO.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

});

parcelRegister("eV9M6", function(module, exports) {
$parcel$export(module.exports, "startOfDay", function () { return $adcdf89fbf1ce70d$export$63fa379ae8a9ba2; });

var $frdJf = parcelRequire("frdJf");
function $adcdf89fbf1ce70d$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $frdJf.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$adcdf89fbf1ce70d$export$2e2bcd8739ae039 = $adcdf89fbf1ce70d$export$63fa379ae8a9ba2;

});


parcelRegister("e0LCf", function(module, exports) {
$parcel$export(module.exports, "CollectionPricingHero", function () { return $2a773e3b9098f7a0$export$8065869e82d5a4c7; });
/* collection-pricing-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $8A3gV = parcelRequire("8A3gV");
const $2a773e3b9098f7a0$var$horizontalOrientationCss = null;
const $2a773e3b9098f7a0$var$verticalOrientationCss = null;
const $2a773e3b9098f7a0$var$logoCss = null;
const $2a773e3b9098f7a0$var$verticalLogoCss = null;
const $2a773e3b9098f7a0$export$8065869e82d5a4c7 = (props)=>{
    const orientation = props.orientation || "horizontal";
    const messages = (0, $8A3gV.useCollectionPricingHeroMessages)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1f2ygktf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1ns9 _p12fuoas"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1yt417la _1lp7vrvc _19wgxy5q _6yttgfpe"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: props.collectionImage.src,
                                    alt: props.collectionImage.alt,
                                    height: props.collectionImage.height,
                                    width: props.collectionImage.width
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulp1crf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect4bzd7 _1wyb19bv _k48p1nn1 _1p1dangw _syaz1yg0 _vwz47vkz _y3gn1h6o _uj6k18uv"
                                    ]),
                                    style: {
                                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                    },
                                    children: messages.includes
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        orientation === "horizontal" ? "_1e0c11p5 _yv0efsjm _2z05im57 _zulpxy5q _gy1pxy5q _1p57pxbi _ect41pz4 _k48p1nn1 _1wyb1wbj" : "_1e0c1txw _2lx21bp4 _zulppxbi"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                    },
                                    children: props.products.map((product, key)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                orientation === "horizontal" ? "_1e0c1txw _4cvr1h6o _zulp12x7 _1bsb1n5l" : "_1e0c1txw _4cvr1h6o _4t3igktf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                    image: {
                                                        src: product.image.src,
                                                        alt: product.image.alt
                                                    },
                                                    className: (0, $2jatx.default)([
                                                        "_y4ti9pc2"
                                                    ]),
                                                    style: {
                                                        height: "20px",
                                                        "--_s4yu5j": (0, $6ZVlx.default)(orientation === "vertical" ? "var(--ds-space-075, 6px)" : 0)
                                                    }
                                                }),
                                                product.name
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _mqm21djo"
                    ]),
                    style: {
                        "--_w9vrer": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1100"))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1hlo _1e0c1ule _y3gn1h6o _ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1fw0 _vwz41ou6 _1yt4zu5n"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                            },
                            children: messages.heading
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _1bah1h6o _zulpu2gc _19wgpxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k383m26br4w8fu6i68s0qbnym881f0wb.svg",
                                        name: messages.home,
                                        alt: messages.home
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r7k15161ensv07cht48h87c31ueh7sh3.svg",
                                        name: messages.goals,
                                        alt: messages.goals
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/51ht267g50ve2d3051aw8nrgs0k11ad6.svg",
                                        name: messages.teams,
                                        alt: messages.teams
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2pqaabre17cu7mx66ydvhplnbt4hh3ub.svg",
                                        name: messages.studio,
                                        alt: messages.studio
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/to7s6r4xr4564x6jhc134qhgevi13wo3.svg",
                                        name: messages.search,
                                        alt: messages.search
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe661ex05dvkmxul5nf4fi1e20hq8063.svg",
                                        name: messages.chat,
                                        alt: messages.chat
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8f6ta76fw1d04u40k8fp622i67154764.svg",
                                        name: messages.analytics,
                                        alt: messages.analytics
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/dv817l8n01hct543cmd030ksu3hfj0k6.svg",
                                        name: messages.admin,
                                        alt: messages.admin
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $2a773e3b9098f7a0$var$Subproduct = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3igktf _1bsbgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: props.src,
                            alt: props.alt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4bzd7 _1wybsm30 _zg8l4jg8 _k48p1nn1 _vwz41crf"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: props.name
            })
        ]
    });
};

});
parcelRegister("8A3gV", function(module, exports) {
$parcel$export(module.exports, "useCollectionPricingHeroMessages", function () { return $6e2ac6bb4e232ff3$export$7c226aa081048b2; });

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");
function $6e2ac6bb4e232ff3$export$7c226aa081048b2() {
    const intl = (0, $8e22h.default)();
    const hardcoded = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8279CollectionHeroIntl);
    if (hardcoded) return $6e2ac6bb4e232ff3$export$22298271baa6ded9(intl.locale);
    return {
        heading: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.platformAppsHeading",
            defaultMessage: "Plus all Atlassian Platform Apps"
        }),
        includes: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.includes",
            defaultMessage: "Includes"
        }),
        home: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.home.alt",
            defaultMessage: "Home"
        }),
        goals: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.goals",
            defaultMessage: "Goals"
        }),
        teams: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.teams",
            defaultMessage: "Teams"
        }),
        studio: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.studio",
            defaultMessage: "Studio"
        }),
        search: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.search",
            defaultMessage: "Search"
        }),
        chat: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.chat",
            defaultMessage: "Chat"
        }),
        analytics: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.analytics",
            defaultMessage: "Analytics"
        }),
        admin: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.admin",
            defaultMessage: "Admin"
        })
    };
}
function $6e2ac6bb4e232ff3$export$22298271baa6ded9(locale) {
    return $6e2ac6bb4e232ff3$var$MESSAGES[locale] ?? $6e2ac6bb4e232ff3$var$enMessages;
}
const $6e2ac6bb4e232ff3$var$enMessages = {
    home: "Home",
    heading: "Plus all Atlassian Platform Apps",
    includes: "Includes",
    goals: "Goals",
    teams: "Teams",
    studio: "Studio",
    search: "Search",
    chat: "Chat",
    analytics: "Analytics",
    admin: "Admin"
};
const $6e2ac6bb4e232ff3$var$MESSAGES = {
    en: $6e2ac6bb4e232ff3$var$enMessages,
    nl: {
        home: "Home",
        heading: "Plus alle Atlassian Platform-apps",
        includes: "Omvat",
        goals: "Doelstellingen",
        teams: "Teams",
        studio: "Studio",
        search: "Zoeken",
        chat: "Chat",
        analytics: "Analyses",
        admin: "Beheerder"
    },
    es: {
        home: "Inicio",
        heading: "Adem\xe1s de todas las aplicaciones de la plataforma de Atlassian",
        includes: "Incluye",
        goals: "Objetivos",
        teams: "Equipos",
        studio: "Studio",
        search: "Buscar",
        chat: "Chat",
        analytics: "An\xe1lisis",
        admin: "Administrativo"
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        heading: "\u0410 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B Atlassian",
        includes: "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442",
        goals: "\u0426\u0435\u043B\u0438",
        teams: "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
        studio: "\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F",
        search: "\u041F\u043E\u0438\u0441\u043A",
        chat: "\u0427\u0430\u0442",
        analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440"
    },
    fr: {
        home: "Accueil",
        heading: "Et toutes les apps de la plateforme Atlassian",
        includes: "Fonctionnalit\xe9s incluses",
        goals: "Objectifs",
        teams: "\xc9quipes",
        studio: "Studio",
        search: "Recherche",
        chat: "Chat",
        analytics: "Analyses",
        admin: "Administrateur"
    },
    ko: {
        home: "\uD648",
        heading: "\uBC0F \uBAA8\uB4E0 Atlassian \uD50C\uB7AB\uD3FC \uC571",
        includes: "\uD3EC\uD568 \uC0AC\uD56D",
        goals: "\uBAA9\uD45C",
        teams: "\uD300",
        studio: "\uC2A4\uD29C\uB514\uC624",
        search: "\uAC80\uC0C9",
        chat: "\uCC44\uD305",
        analytics: "\uBD84\uC11D",
        admin: "\uAD00\uB9AC\uC790"
    },
    br: {
        home: "In\xedcio",
        heading: "Al\xe9m de todos os apps da plataforma Atlassian",
        includes: "Inclui",
        goals: "Metas",
        teams: "Equipes",
        studio: "Studio",
        search: "Pesquisar",
        chat: "Bate-papo",
        analytics: "Dados de An\xe1lise",
        admin: "Admin"
    },
    pl: {
        home: "Strona g\u0142\xf3wna",
        heading: "Plus wszystkie aplikacje platformy Atlassian",
        includes: "Obejmuje",
        goals: "Cele",
        teams: "Zespo\u0142y",
        studio: "Studio",
        search: "Wyszukiwanie",
        chat: "Czat",
        analytics: "Analizy",
        admin: "Administrator"
    },
    de: {
        home: "Home",
        heading: "Plus alle Apps der Atlassian-Plattform",
        includes: "Beinhaltet",
        goals: "Ziele",
        teams: "Teams",
        studio: "Studio",
        search: "Suchen",
        chat: "Chat",
        analytics: "Analysen",
        admin: "Administrator"
    },
    zh: {
        home: "\u9996\u9875",
        heading: "\u4EE5\u53CA\u6240\u6709 Atlassian \u5E73\u53F0\u5E94\u7528",
        includes: "\u5305\u62EC",
        goals: "\u76EE\u6807",
        teams: "\u56E2\u961F",
        studio: "\u5DE5\u4F5C\u5BA4",
        search: "\u641C\u7D22",
        chat: "\u804A\u5929",
        analytics: "\u5206\u6790",
        admin: "\u7BA1\u7406\u5458"
    },
    it: {
        home: "Pagina iniziale",
        heading: "E tutte le app della piattaforma di Atlassian",
        includes: "Include",
        goals: "Obiettivi",
        teams: "Team",
        studio: "Studio",
        search: "Cerca",
        chat: "Chat",
        analytics: "Analisi",
        admin: "Amministratore"
    },
    ja: {
        home: "\u30DB\u30FC\u30E0",
        heading: "\u3055\u3089\u306B\u3059\u3079\u3066\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0 \u30A2\u30D7\u30EA",
        includes: "\u30A4\u30F3\u30AF\u30EB\u30FC\u30C9",
        goals: "\u76EE\u6A19",
        teams: "\u30C1\u30FC\u30E0",
        studio: "\u30B9\u30BF\u30B8\u30AA",
        search: "\u691C\u7D22",
        chat: "\u30C1\u30E3\u30C3\u30C8",
        analytics: "\u5206\u6790\u6A5F\u80FD",
        admin: "\u7BA1\u7406\u8005"
    }
};

});


parcelRegister("jfojT", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPricingHero", function () { return $e2d3685819b80935$export$11d510446f2a0235; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $e2d3685819b80935$export$11d510446f2a0235 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wwq35151x13e6200i5xc4qs5r21er0q5.svg",
            alt: "Teamwork Collection"
        },
        products: [
            {
                name: "Jira",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/36a5pi244g3e1j3540td888vgj855s0u/collections-teamwork-jira.svg",
                    alt: "Jira"
                }
            },
            {
                name: "Confluence",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/nj0wofvhj3q26f3vy866q801p5bbw83w/collections-teamwork-confluence.svg",
                    alt: "Confluence"
                }
            },
            {
                name: "Loom",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/138cux5d67t757a2ddy0l833ihe728l8/collections-teamwork-loom.svg",
                    alt: "Loom"
                }
            },
            {
                name: "Rovo",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/bijp0lf52qxqdt3257q0kj73t8d5681g.svg",
                    alt: "Rovo"
                }
            }
        ]
    });
};

});

parcelRegister("f2RFx", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionNavbar", function () { return $75474cece0afe122$export$8f1cb1d63697797a; });

var $7VQPk = parcelRequire("7VQPk");

var $l2QYX = parcelRequire("l2QYX");

var $lVpxp = parcelRequire("lVpxp");

var $bNHK1 = parcelRequire("bNHK1");
const $75474cece0afe122$export$8f1cb1d63697797a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.GlobalNav), {
        productKey: "home",
        compoundNav: {
            ...(0, $lVpxp.CollectionsCompoundSubNavProps)(),
            ctaUrl: (0, $bNHK1.CTA_URL_PATH)
        }
    });
};

});
parcelRegister("lVpxp", function(module, exports) {
$parcel$export(module.exports, "CollectionsCompoundSubNavProps", function () { return $41aac9f09a5b294b$export$7390cb3961621991; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $cR2Ov = parcelRequire("cR2Ov");

var $5yuBp = parcelRequire("5yuBp");
const $41aac9f09a5b294b$export$7390cb3961621991 = ()=>{
    const intl = (0, $8e22h.default)();
    const teamworkOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork");
    const teamworkFeaturesHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/features");
    const teamworkEnterpriseHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/enterprise");
    const teamworkPricingHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/pricing");
    const teamworkResourcesHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/resources");
    const strategyOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/strategy");
    const strategyDemoCenterHref = (0, $kooLp.useLocalizedHref)("/collections/strategy/demo-center");
    const strategyPricingHref = (0, $kooLp.useLocalizedHref)("/collections/strategy/pricing");
    const serviceOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/service");
    const servicePricingHref = (0, $kooLp.useLocalizedHref)("/collections/service/pricing");
    const softwareHref = (0, $kooLp.useLocalizedHref)("/collections/software");
    const collectionsHref = (0, $kooLp.useLocalizedHref)("/collections");
    // todo: GWP-8380 support collections subnav dropdown menu in mobile
    // 1024 == `media.below.md`, which is the mobile-display threshold
    // specified in services/wac-web/src/patterns/global-nav/src/nav-product-page.tsx
    const isMobile = (0, $5yuBp.useIsMobile)(1024);
    const hasSubnav = !isMobile;
    const props = {
        optionalClassName: "collections-nav",
        compoundSubNavTitle: "Collections",
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                href: teamworkOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.features",
                                        defaultMessage: "Features"
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: teamworkEnterpriseHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: teamworkPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.resources",
                                        defaultMessage: "Resources"
                                    }),
                                    href: teamworkResourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                href: strategyOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.demoCenter",
                                        defaultMessage: "Demo Center"
                                    }),
                                    href: strategyDemoCenterHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: strategyPricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "service",
                linkText: "Service",
                href: serviceOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: serviceOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: servicePricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "software",
                linkText: "Software",
                hasSubnav: false,
                href: softwareHref
            }
        ],
        isShowCta: false,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };
    return props;
};

});

parcelRegister("bNHK1", function(module, exports) {
$parcel$export(module.exports, "CTA_URL_PATH", function () { return $05e82cdc2e6c5ddf$export$d5587a12d9eea1dc; });
const $05e82cdc2e6c5ddf$export$d5587a12d9eea1dc = "/collections/strategy#contact";

});


parcelRegister("h1dGc", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionNavbar", function () { return $b27b8dfab4fc1019$export$693b523fb4eb0711; });

var $7VQPk = parcelRequire("7VQPk");

var $l2QYX = parcelRequire("l2QYX");

var $lVpxp = parcelRequire("lVpxp");
const $b27b8dfab4fc1019$export$693b523fb4eb0711 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.GlobalNav), {
        productKey: "home",
        compoundNav: {
            ...(0, $lVpxp.CollectionsCompoundSubNavProps)(),
            ctaUrl: "/collections/teamwork#contact"
        }
    });
};

});

parcelRegister("lgKym", function(module, exports) {
$parcel$export(module.exports, "CompassNav", function () { return $73340f47439b5afe$export$78e93448314ae49; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
const $73340f47439b5afe$var$CompassLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.CompassLogo), {
        appearance: "brand"
    });
};
const $73340f47439b5afe$export$78e93448314ae49 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=compass&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).COMPASS,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/compass/pricing");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "CompassPageTemplate.navbar.compass-logo",
                defaultMessage: "Compass logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "features",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.features",
                        defaultMessage: "Features"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: (0, $kooLp.useLocalizedHref)("/software/compass/features")
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-compass",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "features",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.features",
                                defaultMessage: "Features"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: (0, $kooLp.useLocalizedHref)("/software/compass/features")
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: pricingHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("g2lQR", function(module, exports) {
$parcel$export(module.exports, "GuardNav", function () { return $97dc5fc3d3238142$export$941339143e9f5522; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
const $97dc5fc3d3238142$var$GuardLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.GuardLogo), {
        appearance: "brand"
    });
};
const $97dc5fc3d3238142$export$941339143e9f5522 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = "https://admin.atlassian.com/atlassian-guard";
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $kooLp.useLocalizedHref)("/software/guard/capabilities");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/guard/pricing");
    const guideHref = (0, $kooLp.useLocalizedHref)("/software/guard/guide#getting-started");
    const demoHref = (0, $kooLp.useLocalizedHref)("/software/guard/demo");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "GuardPageTemplate.navbar.guard-logo",
                defaultMessage: "Guard logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "capabilities",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.capabilities",
                        defaultMessage: "Capabilities"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: capabilitiesHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: pricingHref
                },
                {
                    globalLinksKey: "guide",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.guide",
                        defaultMessage: "Guide"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: guideHref
                },
                {
                    globalLinksKey: "demo",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.demo",
                        defaultMessage: "Demo"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: demoHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-guard",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "capabilities",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.capabilities",
                                defaultMessage: "Capabilities"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: capabilitiesHref
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: pricingHref
                        },
                        {
                            globalLinksKey: "guide",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.guide",
                                defaultMessage: "Guide"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: guideHref
                        },
                        {
                            globalLinksKey: "demo",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.demo",
                                defaultMessage: "Demo"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: demoHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("aYwTu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a060b684c4f472c9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");
const $a060b684c4f472c9$var$JpdLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV2), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
};
const $a060b684c4f472c9$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/resources")
        }
    ];
    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const productNavGoToAppCta = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).productNavGoToAppCta);
    const isExperimentEnabled = productNavGoToAppCta.type === "enrolled" && productNavGoToAppCta.value === true;
    const ctaText = isExperimentEnabled ? intl.formatMessage({
        id: "productNavBar.openJPD",
        defaultMessage: "Open App"
    }) : intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
        productLogoUrl: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery"),
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraProductDiscoveryNavigation.logo-label",
            defaultMessage: "Jira Product Discovery logo"
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-jira-product-discovery",
                mobileLinksProps: links
            }
        ]
    });
};
$a060b684c4f472c9$var$JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";
var $a060b684c4f472c9$export$2e2bcd8739ae039 = $a060b684c4f472c9$var$JiraProductDiscoveryNavV2;

});

parcelRegister("aYVVm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $133256a5190381b7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $b31tm = parcelRequire("b31tm");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $cR2Ov = parcelRequire("cR2Ov");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $iSeHD = parcelRequire("iSeHD");

var $9KOR3 = parcelRequire("9KOR3");
const $133256a5190381b7$var$JiraServiceManagementLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV2), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
};
const $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2 = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const featuresHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/features");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/pricing");
    const itSupportHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/itsm-software");
    const itOperationsHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/it-operations");
    const enterpriseServiceManagementHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/features/enterprise-service-management");
    const customerServiceHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/customer-service-software");
    const hrHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/hr");
    const smallTeamsHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/help-desk-software-small-business-software");
    const premiumHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/premium");
    const enterpriseHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/enterprise");
    const technologyTelecomHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/technology-telecommunications");
    const financialServicesHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/financial-services");
    const retailHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/retail-ecommerce");
    const manufacturingHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/manufacturing");
    const itsmHref = (0, $kooLp.useLocalizedHref)("/itsm");
    const productGuideHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/product-guide");
    const resourcesHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/resources");
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    const templatesUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/service-management");
    const { fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)();
    const viewedUIEvent = (0, $1oC0p.useRef)(false);
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!viewedUIEvent.current && analyticsClient) {
            viewedUIEvent.current = true;
            fireUIEvent({
                action: "viewed",
                actionSubject: "jiraServiceManagementSoftwareNavV2"
            });
        }
    }, [
        analyticsClient,
        fireUIEvent
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: featuresHref
            },
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: pricingHref
            },
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                dropdownType: "solutions",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.useCases.header",
                                defaultMessage: "By use case"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itSupport",
                                        defaultMessage: "IT Support"
                                    }),
                                    href: itSupportHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itOperations",
                                        defaultMessage: "IT Operations"
                                    }),
                                    href: itOperationsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.businessTeams",
                                        defaultMessage: "Business Teams"
                                    }),
                                    href: enterpriseServiceManagementHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.customerService",
                                        defaultMessage: "Customer Service"
                                    }),
                                    href: customerServiceHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.humanResources",
                                        defaultMessage: "Human Resources"
                                    }),
                                    href: hrHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.capability.header",
                                defaultMessage: "By capability"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.smallTeams",
                                        defaultMessage: "Small Teams"
                                    }),
                                    href: smallTeamsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.premium",
                                        defaultMessage: "Premium"
                                    }),
                                    href: premiumHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: enterpriseHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.industry.customerService",
                                defaultMessage: "By industry"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.technologyTelecom",
                                        defaultMessage: "Technology & Telecom"
                                    }),
                                    href: technologyTelecomHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.financialServices",
                                        defaultMessage: "Financial Services"
                                    }),
                                    href: financialServicesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.retail",
                                        defaultMessage: "Retail"
                                    }),
                                    href: retailHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.manufacturing",
                                        defaultMessage: "Manufacturing"
                                    }),
                                    href: manufacturingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "resources",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.resources",
                    defaultMessage: "Resources"
                }),
                hasSubnav: true,
                dropdownType: "resources",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.resources.type.header",
                                defaultMessage: "By type"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.itsm",
                                        defaultMessage: "ITSM"
                                    }),
                                    href: itsmHref
                                },
                                {
                                    text: gwp7518NavIconUpdates ? intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide-gwp-7518",
                                        defaultMessage: "Guide"
                                    }) : intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide",
                                        defaultMessage: "Product Guide"
                                    }),
                                    href: productGuideHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.templates",
                                        defaultMessage: "Templates"
                                    }),
                                    href: templatesUrl
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.additionalResources",
                                        defaultMessage: "Additional Resources"
                                    }),
                                    href: resourcesHref
                                }
                            ]
                        }
                    ]
                })
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customerServiceHref,
        solutionsDropdownStyles,
        enterpriseHref,
        enterpriseServiceManagementHref,
        featuresHref,
        financialServicesHref,
        hrHref,
        intl,
        itOperationsHref,
        itSupportHref,
        itsmHref,
        manufacturingHref,
        premiumHref,
        pricingHref,
        productGuideHref,
        resourcesHref,
        retailHref,
        smallTeamsHref,
        technologyTelecomHref,
        templatesUrl
    ]);
    const signupLink = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        openCrossFlow,
        productNavCtaCTAClickFunction
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    // Check if JSM back-to-product hero experiment is active
    // If so, hide the "Get it free" button in the global nav
    const jsmHeroExperiment = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).gwp9973JSMBackToProductHero);
    const isJsmHeroExperimentActive = jsmHeroExperiment.type === "enrolled" && jsmHeroExperiment.value === true;
    const productNavGoToAppCta = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).productNavGoToAppCta);
    const isExperimentEnabled = productNavGoToAppCta.type === "enrolled" && productNavGoToAppCta.value === true;
    const ctaText = isExperimentEnabled ? intl.formatMessage({
        id: "productNavBar.openJSM",
        defaultMessage: "Open App"
    }) : intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            productLogoUrl: (0, $kooLp.useLocalizedHref)("/software/jira/service-management"),
            productLogoAriaLabel: "Jira Service Management",
            productPageNavLinks: links,
            isShowTryNowLink: isJsmHeroExperimentActive ? false : undefined,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-jira-service-management",
                    mobileLinksProps: links
                }
            ],
            isIncludeMobileCTA: !isJsmHeroExperimentActive,
            mobileCtaText: intl.formatMessage({
                id: "productNavBar.get-it-free-button",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            navigationTrynowCtaText: ctaText,
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "solutions",
                    menuPageObjects: links.find((link)=>link.globalLinksKey === "solutions")?.content
                },
                {
                    menuPageKey: "resources",
                    menuPageObjects: links.find((link)=>link.globalLinksKey === "resources")?.content
                }
            ]
        })
    });
};
var $133256a5190381b7$export$2e2bcd8739ae039 = $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2;

});

parcelRegister("1K6kz", function(module, exports) {
$parcel$export(module.exports, "LoomNav", function () { return $b0045c9e2971c8ff$export$e9541932877c1f74; });
$parcel$export(module.exports, "default", function () { return $b0045c9e2971c8ff$export$2e2bcd8739ae039; });
/* loom-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $8nFt2 = parcelRequire("8nFt2");

var $9KOR3 = parcelRequire("9KOR3");

var $32ng3 = parcelRequire("32ng3");

var $gWusH = parcelRequire("gWusH");

var $635dy = parcelRequire("635dy");
const $b0045c9e2971c8ff$var$wrapSubnav = (subnav)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1rjc1jfw _18zr1jfw"
                    ]),
                    children: subnav
                })
            })
        })
    });
};
const $b0045c9e2971c8ff$var$LoomLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "loomcircular",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.LoomAttributionLogo), {
        appearance: "brand"
    });
};
const $b0045c9e2971c8ff$export$e9541932877c1f74 = ()=>{
    const intl = (0, $8e22h.default)();
    const dropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            insetBlockStart: "4.25rem",
            transform: "translateX(-25%)"
        };
    }, []);
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium");
    const resourcesHref = (0, $kooLp.useLocalizedHref)("/software/loom/resources");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/loom/pricing");
    const desktopLinks = [
        {
            globalLinksKey: "features",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: true,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "solutions",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.resources",
                defaultMessage: "Solutions"
            }),
            hasSubnav: true,
            containerStyles: dropdownStyles,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "resources",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.useCases",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            href: resourcesHref
        },
        {
            globalLinksKey: "pricing",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            href: pricingHref
        }
    ];
    const mobileLinks = [
        ...desktopLinks.map((link)=>({
                globalLinksKey: link.globalLinksKey,
                productKey: link.productKey,
                linkText: link.linkText,
                hasSubnav: link.hasSubnav,
                href: link.href,
                dropdownType: link.globalLinksKey
            }))
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
        productKey: "loom",
        productLogoUrl: "/software/loom",
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "LoomPageTemplate.navbar.loom-logo",
            defaultMessage: "Loom logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productPageNavLinks: desktopLinks,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-loom",
                mobileLinksProps: mobileLinks
            }
        ],
        additionalMenuPageObjectsArray: [
            {
                menuPageKey: "features",
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})
            },
            {
                menuPageKey: "solutions",
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})
            }
        ]
    });
};
var $b0045c9e2971c8ff$export$2e2bcd8739ae039 = $b0045c9e2971c8ff$export$e9541932877c1f74;

});
parcelRegister("gWusH", function(module, exports) {
$parcel$export(module.exports, "LoomFeaturesSubnav", function () { return $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8; });
/* features-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $dfBhn = parcelRequire("dfBhn");
const $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8 = ()=>{
    const intl = (0, $8e22h.default)();
    const productKey = "loom";
    const loomLinks = {
        features: {
            id: "features",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.loomFeatures.links.features",
                defaultMessage: "Explore Features"
            }),
            items: [
                {
                    id: "meeting-notes",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.meeting-notes",
                        defaultMessage: "Meeting Notes"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/ai-meeting")
                },
                {
                    id: "screen-recorder",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screen-recorder",
                        defaultMessage: "Screen Recorder"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/screen-recorder")
                },
                {
                    id: "screenshots",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screenshots",
                        defaultMessage: "Screenshots"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/screenshot")
                },
                {
                    id: "loom-ai",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.loom-ai",
                        defaultMessage: "Loom AI"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/ai")
                },
                {
                    id: "editing",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.editing",
                        defaultMessage: "Editing"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/editing")
                }
            ]
        }
    };
    const linkColumns = Object.values(loomLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: linkColumns.map((column)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1p1dangw _syazmt5y _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                        ]),
                        style: {
                            "--_1ex89o1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark0")),
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: intl.formatMessage(column.title)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _umai1ylp"
                        ]),
                        children: column.items.map((link)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bpsp1nn1 _19tboxwj _43dsmt5y _qfs11r31 _s41oglyw _1k6pnqa1 _1caymt5y _1e0c1txw _4cvrh9n0"
                                ]),
                                style: {
                                    "--_1ex89o1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark0"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    type: "anchor",
                                    href: link.href,
                                    text: intl.formatMessage(link.text),
                                    ariaLabel: intl.formatMessage(link.text),
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "globalNavSubnav",
                                        "data-product-key": productKey
                                    }
                                })
                            }, link.id);
                        })
                    })
                ]
            }, column.id);
        })
    });
};

});

parcelRegister("635dy", function(module, exports) {
$parcel$export(module.exports, "LoomSolutionsSubnav", function () { return $7ae29eaf01c2e45b$export$e7b21fd28cd3f276; });
/* solutions-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $7ae29eaf01c2e45b$var$useLoomSolutionsLinks() {
    return {
        features: {
            id: "teams",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.solution",
                defaultMessage: "Teams"
            }),
            items: [
                {
                    id: "sales",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.sales",
                        defaultMessage: "Sales"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/sales")
                },
                {
                    id: "marketing",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.marketing",
                        defaultMessage: "Marketing"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/marketing")
                },
                {
                    id: "design",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.design",
                        defaultMessage: "Design"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/design")
                },
                {
                    id: "support",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.support",
                        defaultMessage: "Support"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/support")
                },
                {
                    id: "productmanagement",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.product-management",
                        defaultMessage: "Product Management"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/product-management")
                },
                {
                    id: "engineering",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.engineering",
                        defaultMessage: "Engineering"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/engineering")
                }
            ]
        },
        usecases: {
            id: "usecases",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.use-cases",
                defaultMessage: "Use cases"
            }),
            items: [
                {
                    id: "loom-jira",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-jira",
                        defaultMessage: "Loom + Jira"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/loom-jira")
                },
                {
                    id: "loom-confluence",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-confluence",
                        defaultMessage: "Loom + Confluence"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/loom-confluence")
                }
            ]
        },
        companysize: {
            id: "companysize",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.company-size",
                defaultMessage: "Company Size"
            }),
            items: [
                {
                    id: "enterprise",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/enterprise")
                }
            ]
        }
    };
}
const $7ae29eaf01c2e45b$export$e7b21fd28cd3f276 = ({ productKey: productKey = "loom" })=>{
    const intl = (0, $8e22h.default)();
    const loomSolutionLinks = $7ae29eaf01c2e45b$var$useLoomSolutionsLinks();
    const linkColumns = Object.values(loomSolutionLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkcd5j _fn1q1txw _12nx1bp4 _196i1ylp"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 3,
                        columnGap: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _umai1ylp"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("3wzIU", function(module, exports) {
$parcel$export(module.exports, "RovoNav", function () { return $d94e8e579fb0c00d$export$f7b51e35c95f667c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3o1l4 = parcelRequire("3o1l4");

var $bQjAr = parcelRequire("bQjAr");

var $2WL8B = parcelRequire("2WL8B");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $cR2Ov = parcelRequire("cR2Ov");

var $3riD8 = parcelRequire("3riD8");
const $d94e8e579fb0c00d$export$f7b51e35c95f667c = ()=>{
    const intl = (0, $8e22h.default)();
    const navLinks = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/features")
        },
        {
            globalLinksKey: "connectors",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.connectors",
                defaultMessage: "Connectors"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/connectors")
        },
        {
            globalLinksKey: "use-cases",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.use-cases",
                defaultMessage: "Use cases"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/use-cases")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: true,
            productKey: "rovo",
            containerPosition: "relative",
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                orientation: "column",
                contentSections: [
                    {
                        links: [
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.ai-adoption-resources",
                                    defaultMessage: "AI adoption resources"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("http://community.atlassian.com/learning/hub/rovo")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.admin-onboarding",
                                    defaultMessage: "Admin onboarding"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("/software/rovo/guides/admin-guide")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.end-user-onboarding",
                                    defaultMessage: "End-user onboarding"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("/software/rovo/guides/end-user-guide")
                            }
                        ]
                    }
                ]
            })
        },
        {
            globalLinksKey: "licensing",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.licensing",
                defaultMessage: "Licensing"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/licensing/rovo")
        }
    ];
    const { requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const { data: userSegments } = (0, $3o1l4.useUserSegments)();
    const isRovoEnabledCohort = (0, $2WL8B.useRovoEnabledCohort)();
    const isRovoInPlanList = userSegments?.[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]?.includes("rovo.ondemand");
    const defaultCTAUrl = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium");
    const isUserLoggedInAndCtasEnabledAndInPlan = isRovoInPlanList;
    const ctaText = intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.try-rovo",
        defaultMessage: "Try Rovo"
    });
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? "https://home.atlassian.com/chat" : defaultCTAUrl;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    const buttonVariant = isRovoEnabledCohort ? "secondary" : "primary";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            productLogoAriaLabel: intl.formatMessage({
                id: "RovoPageTemplate.navbar.rovo-logo",
                defaultMessage: "Rovo logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            navigationTrynowCtaButtonVariant: buttonVariant,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaButtonVariant: buttonVariant,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-rovo",
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("9xKEy", function(module, exports) {
$parcel$export(module.exports, "ChatWidgetProvider", function () { return $c6548387155117f6$export$a4cac963ae9f34ca; });
$parcel$export(module.exports, "default", function () { return $c6548387155117f6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jIe84 = parcelRequire("jIe84");
var $ac0eX = parcelRequire("ac0eX");
var $6NMje = parcelRequire("6NMje");
var $aCV3p = parcelRequire("aCV3p");

var $fuLgT = parcelRequire("fuLgT");

var $9dCmO = parcelRequire("9dCmO");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");

var $j2b52 = parcelRequire("j2b52");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $kEjoI = parcelRequire("kEjoI");

// Load omni-channel UI only on the client when widget is open to avoid SSR 503 (Tesseract)
const $c6548387155117f6$var$ChatWidgetOmniChannelUI = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("bS1lo")));

// Lazy-load analytics when fetchChatConnectionConfig succeeds (keeps @atlassian/omni-channel out of main bundle)
const $c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("50y75")));

// Lazy-load analytics when fetchToken fails (same chunk as customer-joined analytics)
const $c6548387155117f6$var$ChatWidgetTokenErrorAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("50y75")).then((m)=>({
            default: m.ChatWidgetTokenErrorAnalytics
        })));

// Lazy-load analytics when fetchChatConnectionConfig succeeds
const $c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("50y75")).then((m)=>({
            default: m.ChatWidgetConnectionConfigSuccessAnalytics
        })));

// Lazy-load analytics when fetchToken succeeds (channelPlatformTokenError empty or null)
const $c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("50y75")).then((m)=>({
            default: m.ChatWidgetTokenSuccessAnalytics
        })));
const $c6548387155117f6$export$8a240b2f27c2948f = (url)=>{
    try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname.replace(/\/+$/, "");
        if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
        return pathname.replace(/^\/+/, "");
    } catch  {
        const match = /\/\/[^/]+(\/[^#?]*)/.exec(url);
        if (match?.[1]) {
            let pathname = match[1].replace(/\/+$/, "");
            if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
            return pathname.replace(/^\/+/, "");
        }
        return "";
    }
};
const $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH = {
    "software/jira/product-discovery": {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/jira/service-management": {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/jira": {
        contactFlowId: "1825e6f7-75fc-47e2-b634-98923fa4a3b1",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom": {
        contactFlowId: "dc335c33-9da5-4291-842b-80956f53d2b7",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-confluence": {
        contactFlowId: "7cf56869-3db7-431e-8311-b524e6065934",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-jira": {
        contactFlowId: "199f4750-6436-4b88-a2db-c2b87c1bdaed",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/resources": {
        contactFlowId: "eadd2afc-29bb-4e9c-a0d6-370fd70186eb",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/ai-meeting": {
        contactFlowId: "364f6abb-5628-41c1-bf90-b3ca2486378d",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/editing": {
        contactFlowId: "a4addd51-eb96-46fc-b5a9-3f99c3d923de",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/company/contact/japan": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    }
};
const $c6548387155117f6$export$a8ad7472af635967 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    return $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath] ?? {
        contactFlowId: ""
    };
};
const $c6548387155117f6$export$b28607ea792e8283 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && Array.isArray(entry.formKey)) return entry.formKey;
    return [
        ""
    ];
};
const $c6548387155117f6$export$39f87d2399b576ea = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && typeof entry.attributes === "object" && entry.attributes !== null) return JSON.stringify(entry.attributes, null, 2);
    return "{}";
};
const $c6548387155117f6$export$c452173f1b4082d7 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    return normalizedPath === "ja" || normalizedPath.startsWith("ja/");
};
const $c6548387155117f6$export$8378cdc69cfc311a = (url)=>{
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading and trailing slashes, then split by '/' and filter out empty strings
        const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
        // Join with underscores
        return pathParts.join("_");
    } catch (error) {
        // If URL parsing fails, try to extract path manually
        const match = /\/\/[^\/]+(\/[^?#]*)/.exec(url);
        if (match && match[1]) {
            const pathname = match[1];
            const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
            return pathParts.join("_");
        }
        return "";
    }
};
const $c6548387155117f6$export$2b66390f6eecea5c = (payload)=>{
    const transformed = {};
    if (!payload) return transformed;
    Object.entries(payload).forEach(([key, value])=>{
        // Skip attachments
        if (key === "attachments") return;
        // Skip null or undefined values
        if (value === null || value === undefined) return;
        // Handle arrays - normalize to array of strings
        if (Array.isArray(value)) transformed[key] = value.map((v)=>{
            // If array element is an object (like {userEmail: "value"}), extract the first value
            if (typeof v === "object" && v !== null && !Array.isArray(v)) {
                const firstValue = Object.values(v)[0];
                return firstValue !== undefined ? String(firstValue) : String(v);
            }
            // Already a string or primitive
            return String(v);
        });
        else transformed[key] = [
            String(value)
        ];
    });
    return transformed;
};
const $c6548387155117f6$export$a40d7197cc58cf92 = (payload)=>{
    return JSON.stringify(payload);
};
const $c6548387155117f6$export$b13b32483d23f773 = (formValues, flowId, analyticsSessionId)=>{
    const metadata = {};
    if (analyticsSessionId) metadata["analyticsSessionId"] = analyticsSessionId;
    // Only include flowId if it has a value
    if (flowId) metadata["flowId"] = flowId;
    if (formValues?.contactEmail) metadata["email"] = formValues.contactEmail;
    return JSON.stringify(metadata);
};
const $c6548387155117f6$export$6999922c2cdd8944 = (chatConnectionConfigResponse)=>{
    const submitRequest = chatConnectionConfigResponse?.channelPlatform_createContact;
    return {
        channelPlatform_submitRequest: submitRequest
    };
};
function $c6548387155117f6$export$c0c7c314cc68764f(config) {
    const contact = config?.channelPlatform_createContact;
    return contact?.value?.contactId;
}
function $c6548387155117f6$export$f0671fd2506d780c(config) {
    const contact = config?.channelPlatform_createContact;
    const value = contact?.value;
    return {
        contactId: value?.contactId,
        participantId: value?.participantId,
        region: value?.region
    };
}
function $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail, isUserLoggedIn) {
    return {
        cst_support_forms_data_fieldDescMap: [
            '{"inquiry_category":"Inquiry Category","email":"Email","raised_obo_by":"Raised on behalf of by","language":"language","customer_working_hours":"Support Business Hours Select"}'
        ],
        customer_email: [
            isUserLoggedIn ? userEmail : ""
        ],
        authenticated: isUserLoggedIn ? null : [
            "No"
        ],
        email: [
            isUserLoggedIn ? userEmail : ""
        ],
        customer_status: [
            "Customer"
        ],
        cst_support_forms_data_formKey: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_formLabel: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_timezone: [
            "GMT+6"
        ],
        referral_url: [
            window.location.href
        ],
        language: [
            "en"
        ],
        is_partner_dc_exception: [
            "Customer not in SFDC"
        ],
        topic: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href)
        ],
        summary: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href).split("_").join(" ")
        ],
        support_channel: [
            "chat"
        ],
        inquiry_category: [
            "access_issues"
        ],
        cst_support_forms_data_contextId: [
            contextId
        ]
    };
}
function $c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasOpenCurrent, clientToken, clientWithToken) {
    return isWidgetOpen && !wasOpenCurrent && !!clientToken && !!clientWithToken;
}
function $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn) {
    return {
        flowId: $c6548387155117f6$export$a8ad7472af635967($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)).contactFlowId,
        formContext: {
            summary: [
                "Chat Transcript for <email removed for privacy>"
            ],
            details: "",
            contactEmail: isUserLoggedIn ? userEmail ?? "" : "",
            isAuthenticated: isUserLoggedIn
        }
    };
}
function $c6548387155117f6$var$hasCustomerConversations(response) {
    const count = response?.channelPlatform_getCustomerConversations?.conversations?.length ?? 0;
    return count > 0;
}
function $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded) {
    const isChatLoaded = isWidgetOpen && !!clientToken && !!chatConnectionConfig && isCustomerComponentLoaded;
    return {
        isChatLoaded: isChatLoaded,
        showFloatingButton: !isChatLoaded,
        isButtonLoading: isWidgetOpen && (!clientToken || !chatConnectionConfig || !isCustomerComponentLoaded)
    };
}
const $c6548387155117f6$var$ChatFloatingButton = ({ isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": isLoading ? "Loading chat" : "Open chat widget",
        style: {
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 1000,
            cursor: isLoading ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            backgroundColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            color: "white",
            boxShadow: (0, $lP7A9.default)("elevation.shadow.raised")
        },
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "medium",
            label: "Loading chat",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))), {
            label: "",
            size: "medium",
            color: "currentColor"
        })
    });
};

function $c6548387155117f6$var$useChatWidgetConnection({ isWidgetOpen: isWidgetOpen, contextId: contextId, userEmail: userEmail, isUserLoggedIn: isUserLoggedIn, setIsCustomerComponentLoaded: setIsCustomerComponentLoaded }) {
    const [clientToken, setClientToken] = (0, $1oC0p.useState)(null);
    const [chatConnectionConfig, setChatConnectionConfig] = (0, $1oC0p.useState)(null);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    const [channelPlatformTokenError, setChannelPlatformTokenError] = (0, $1oC0p.useState)(null);
    const [customerConversationsResponse, setCustomerConversationsResponse] = (0, $1oC0p.useState)(null);
    const generateAuthHeader = (channelsIdentityHash)=>new (0, $ac0eX.ApolloLink)((operation, forward)=>{
            operation.setContext(({ headers: headers = {} })=>({
                    headers: {
                        ...headers,
                        "Content-Type": "application/json",
                        "X-Client-Hash": channelsIdentityHash
                    }
                }));
            return forward(operation);
        });
    const client = (0, $1oC0p.useMemo)(()=>{
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: link,
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, []);
    const wasWidgetOpenRef = (0, $1oC0p.useRef)(false);
    const clientWithToken = (0, $1oC0p.useMemo)(()=>{
        if (!clientToken) return null;
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: (0, $ac0eX.ApolloLink).from([
                generateAuthHeader(clientToken),
                link
            ]),
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, [
        clientToken
    ]);
    const isRefreshed = (0, $1oC0p.useMemo)(()=>$c6548387155117f6$var$hasCustomerConversations(customerConversationsResponse), [
        customerConversationsResponse
    ]);
    const fetchCustomerConversations = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) return;
        const anonymousId = (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "";
        clientWithToken.query({
            query: (0, $kEjoI.getCustomerConversations),
            variables: {
                anonymousId: anonymousId
            }
        }).then((response)=>{
            setCustomerConversationsResponse(response?.data ?? null);
        }).catch((err)=>{
            console.warn("Error fetching customer conversations:", err);
            setCustomerConversationsResponse(null);
        });
    }, [
        clientWithToken
    ]);
    const fetchChatConnectionConfig = (0, $1oC0p.useCallback)(async ()=>{
        if (!clientWithToken) {
            console.warn("Client with token not available yet");
            return;
        }
        setLoading(true);
        const formValues = $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail ?? "", isUserLoggedIn);
        // Dynamic import to avoid pulling @atlassiansox/analytics-web-client
        // (which calls setTimeout at module init) into the SSR bundle.
        const { getAnalyticsWebClient: getAnalyticsWebClient } = await (parcelRequire("ix6JR"));
        const metadataPayload = $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn);
        const metadata = $c6548387155117f6$export$b13b32483d23f773({
            contactEmail: metadataPayload.formContext["contactEmail"]
        }, metadataPayload.flowId, getAnalyticsWebClient().getCurrentSessionId());
        clientWithToken.query({
            query: (0, $kEjoI.getChatConnectionConfigForSalesChannel),
            variables: {
                requestType: "CHAT",
                payload: $c6548387155117f6$export$2b66390f6eecea5c(formValues),
                metadata: metadata,
                attributes: JSON.parse($c6548387155117f6$export$39f87d2399b576ea($c6548387155117f6$export$8a240b2f27c2948f(window.location.href))) ?? {},
                anonymousId: (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || ""
            }
        }).then((response)=>{
            setChatConnectionConfig(response?.data);
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching chat connection config:", err);
            setError(err);
            setLoading(false);
        });
    }, [
        clientWithToken,
        contextId,
        isUserLoggedIn,
        userEmail
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if ($c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasWidgetOpenRef.current, clientToken, clientWithToken)) {
            wasWidgetOpenRef.current = true;
            fetchCustomerConversations();
            fetchChatConnectionConfig();
        }
        if (!isWidgetOpen) {
            wasWidgetOpenRef.current = false;
            setIsCustomerComponentLoaded(false);
        }
    }, [
        isWidgetOpen,
        clientToken,
        clientWithToken,
        fetchCustomerConversations,
        fetchChatConnectionConfig,
        setIsCustomerComponentLoaded
    ]);
    const fetchToken = (0, $1oC0p.useCallback)(()=>{
        setLoading(true);
        client.query({
            query: (0, $kEjoI.getChannelPlatformTokenByClientName),
            variables: {
                clientName: "sales"
            }
        }).then((response)=>{
            const token = response.data?.supportInquiry_channelsIdentityHashByClientName;
            if (token) {
                setClientToken(token);
                setChannelPlatformTokenError(null);
            }
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching channel platform token:", err);
            setError(err);
            setLoading(false);
            const errorMessage = err instanceof Error ? err.message : String(err);
            setChannelPlatformTokenError(errorMessage);
        });
    }, [
        client
    ]);
    return {
        clientToken: clientToken,
        chatConnectionConfig: chatConnectionConfig,
        loading: loading,
        error: error,
        channelPlatformTokenError: channelPlatformTokenError,
        client: client,
        clientWithToken: clientWithToken,
        isRefreshed: isRefreshed,
        customerConversationsResponse: customerConversationsResponse,
        setClientToken: setClientToken,
        fetchToken: fetchToken
    };
}
const $c6548387155117f6$export$a4cac963ae9f34ca = ({ children: children })=>{
    const [isWidgetOpen, setIsWidgetOpen] = (0, $1oC0p.useState)(false);
    const [isCustomerComponentLoaded, setIsCustomerComponentLoaded] = (0, $1oC0p.useState)(false);
    const { accountId: aaid, email: userEmail, isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const contextId = (0, $1oC0p.useMemo)(()=>(0, $fuLgT.default)(), []);
    const connection = $c6548387155117f6$var$useChatWidgetConnection({
        isWidgetOpen: isWidgetOpen,
        contextId: contextId,
        userEmail: userEmail,
        isUserLoggedIn: isUserLoggedIn,
        setIsCustomerComponentLoaded: setIsCustomerComponentLoaded
    });
    const { clientToken: clientToken, chatConnectionConfig: chatConnectionConfig, loading: loading, error: error, channelPlatformTokenError: channelPlatformTokenError, isRefreshed: isRefreshed, customerConversationsResponse: customerConversationsResponse } = connection;
    const surveyModalAttributes = {
        width: "80%",
        height: 500
    };
    const omniChannelEnv = "production";
    const handleChatButtonClick = ()=>{
        const opening = !isWidgetOpen;
        setIsWidgetOpen(opening);
        if (opening) connection.fetchToken();
    };
    const handleChatButtonKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleChatButtonClick();
        }
    };
    const viewState = $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded);
    const showChatPanel = isWidgetOpen && !!chatConnectionConfig && !!clientToken;
    const conversationId = $c6548387155117f6$export$c0c7c314cc68764f(chatConnectionConfig);
    const connectionConfigAttributes = $c6548387155117f6$export$f0671fd2506d780c(chatConnectionConfig);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                children,
                chatConnectionConfig && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics, {
                            conversationId: conversationId
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics, {
                            contactId: connectionConfigAttributes.contactId,
                            participantId: connectionConfigAttributes.participantId,
                            region: connectionConfigAttributes.region
                        })
                    ]
                }),
                channelPlatformTokenError && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenErrorAnalytics, {
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                clientToken && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics, {
                        clientToken: clientToken,
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                viewState.showFloatingButton && /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatFloatingButton, {
                    isLoading: viewState.isButtonLoading,
                    onClick: handleChatButtonClick,
                    onKeyDown: handleChatButtonKeyDown
                }),
                showChatPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetOmniChannelUI, {
                        env: omniChannelEnv,
                        clientIdentityHash: clientToken || "",
                        chatContactDetails: $c6548387155117f6$export$6999922c2cdd8944(chatConnectionConfig),
                        accountId: aaid || "",
                        isRefreshed: isRefreshed,
                        customerConversations: customerConversationsResponse,
                        loading: loading,
                        error: error,
                        isUserLoggedIn: isUserLoggedIn,
                        surveyModalAttributes: surveyModalAttributes,
                        onLoaded: ()=>setIsCustomerComponentLoaded(true)
                    })
                })
            ]
        })
    });
};
var $c6548387155117f6$export$2e2bcd8739ae039 = $c6548387155117f6$export$a4cac963ae9f34ca;

});
parcelRegister("kEjoI", function(module, exports) {
$parcel$export(module.exports, "getChatConnectionConfigForSalesChannel", function () { return $59b9792633dffc77$export$2fedc4b0d22f20b3; });
$parcel$export(module.exports, "getCustomerConversations", function () { return $59b9792633dffc77$export$54e9b7f1aad2199a; });
$parcel$export(module.exports, "getChannelPlatformTokenByClientName", function () { return $59b9792633dffc77$export$c543cd67c9b21e36; });
// @ts-expect-error - @apollo/client is ESM but this file is treated as CommonJS by TypeScript

var $4Wqet = parcelRequire("4Wqet");
const $59b9792633dffc77$export$51e62cbd534f416c = (0, $4Wqet.gql)`
    query channelPlatformTokenGeneration {
        supportInquiry_channelsIdentityHash
    }
`;
const $59b9792633dffc77$export$2fedc4b0d22f20b3 = (0, $4Wqet.gql)`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
        $anonymousId: String
        $attributes: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: {
                payload: $payload
                metadata: $metadata
                attributes: $attributes
            }
            anonymousId: $anonymousId
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`;
const $59b9792633dffc77$export$54e9b7f1aad2199a = (0, $4Wqet.gql)`
    query CustomerConversations($anonymousId: String) {
        channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
            conversations
        }
    }
`;
const $59b9792633dffc77$export$f843774d31ce9c0c = (0, $4Wqet.gql)`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: { payload: $payload, metadata: $metadata }
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`;
const $59b9792633dffc77$export$c543cd67c9b21e36 = (0, $4Wqet.gql)`
    query channelPlatformTokenGenerationByClientName($clientName: String) {
        supportInquiry_channelsIdentityHashByClientName(
            request: { clientName: $clientName }
        )
    }
`;

});

parcelRegister("bS1lo", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("1UZeW"),
    $eao4m("eDmkW"),
    $eao4m("2TJ5h"),
    $eao4m("8vPuH"),
    $eao4m("31vyW"),
    $eao4m("hCwjc"),
    $eao4m("lRMpp"),
    $eao4m("i3lCc"),
    $eao4m("7kVZX"),
    $eao4m("9WEDO"),
    $eao4m("7Q4ht"),
    $eao4m("76kmj")
]).then(()=>parcelRequire('8Cs4z'));

});

parcelRegister("50y75", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("1UZeW"),
    $eao4m("hCwjc"),
    $eao4m("hx68B")
]).then(()=>parcelRequire('cJIcN'));

});

parcelRegister("ix6JR", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("4lJtX").then(()=>parcelRequire('k1dhr'));

});


parcelRegister("gNuc8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3a8a4fb00075491$var$_react = $c3a8a4fb00075491$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c3a8a4fb00075491$var$_baseNew = $c3a8a4fb00075491$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c3a8a4fb00075491$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3a8a4fb00075491$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $c3a8a4fb00075491$var$_react.default.createElement($c3a8a4fb00075491$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$c3a8a4fb00075491$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $c3a8a4fb00075491$var$_default = module.exports.default = $c3a8a4fb00075491$var$ChartTrendIcon;

});

parcelRegister("7Xpzl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cb1e08dc9ec04f5$var$_react = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5cb1e08dc9ec04f5$var$_baseNew = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5cb1e08dc9ec04f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cb1e08dc9ec04f5$var$InformationIcon = (props)=>/*#__PURE__*/ $5cb1e08dc9ec04f5$var$_react.default.createElement($5cb1e08dc9ec04f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$5cb1e08dc9ec04f5$var$InformationIcon.displayName = 'InformationIcon';
var $5cb1e08dc9ec04f5$var$_default = module.exports.default = $5cb1e08dc9ec04f5$var$InformationIcon;

});

parcelRegister("iMdbU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dab6f123f69f6bcc$var$_react = $dab6f123f69f6bcc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dab6f123f69f6bcc$var$_baseNew = $dab6f123f69f6bcc$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $dab6f123f69f6bcc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dab6f123f69f6bcc$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $dab6f123f69f6bcc$var$_react.default.createElement($dab6f123f69f6bcc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$dab6f123f69f6bcc$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $dab6f123f69f6bcc$var$_default = module.exports.default = $dab6f123f69f6bcc$var$PersonAddedIcon;

});

parcelRegister("7pQ29", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56633b0430bc4d64$var$_react = $56633b0430bc4d64$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56633b0430bc4d64$var$_baseNew = $56633b0430bc4d64$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $56633b0430bc4d64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56633b0430bc4d64$var$PhoneIcon = (props)=>/*#__PURE__*/ $56633b0430bc4d64$var$_react.default.createElement($56633b0430bc4d64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$56633b0430bc4d64$var$PhoneIcon.displayName = 'PhoneIcon';
var $56633b0430bc4d64$var$_default = module.exports.default = $56633b0430bc4d64$var$PhoneIcon;

});

parcelRegister("l6HGO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5dc0c5d851b1603$var$_react = $f5dc0c5d851b1603$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5dc0c5d851b1603$var$_baseNew = $f5dc0c5d851b1603$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f5dc0c5d851b1603$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5dc0c5d851b1603$var$StarStarredIcon = (props)=>/*#__PURE__*/ $f5dc0c5d851b1603$var$_react.default.createElement($f5dc0c5d851b1603$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$f5dc0c5d851b1603$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $f5dc0c5d851b1603$var$_default = module.exports.default = $f5dc0c5d851b1603$var$StarStarredIcon;

});

parcelRegister("kHMU7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12dc2233694369e$var$_react = $f12dc2233694369e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f12dc2233694369e$var$_baseNew = $f12dc2233694369e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f12dc2233694369e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12dc2233694369e$var$WarningIcon = (props)=>/*#__PURE__*/ $f12dc2233694369e$var$_react.default.createElement($f12dc2233694369e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$f12dc2233694369e$var$WarningIcon.displayName = 'WarningIcon';
var $f12dc2233694369e$var$_default = module.exports.default = $f12dc2233694369e$var$WarningIcon;

});


var $3NQOU = parcelRequire("3NQOU");

var $dXL3R = parcelRequire("dXL3R");
(0, $3NQOU.init)((0, $dXL3R.JiraSoftwarePage));


//# sourceMappingURL=jira-software-page.9f68c0e9.js.map
